webpackJsonp([2],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);




var curpage = {},
    userinf = {};
var ctrler = 'index',
    action = 'index';
var URLPREFIX = '?admin=',
    HEADERH = 50;

function getHost() {
	return  false ? '/index.php/' : window.apihost;
}

function parSearch() {
	var locstr = location.search.substr(1);
	if (!locstr.trim().length) return {};
	var resarr = {},
	    locarr = locstr.split('&');
	for (var i in locarr) {
		var _locarr$i$split = locarr[i].split('='),
		    _locarr$i$split2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_locarr$i$split, 2),
		    ky = _locarr$i$split2[0],
		    val = _locarr$i$split2[1];

		resarr[ky] = unescape(val);
	}
	return resarr;
}

function resetSearch(queryobj) {
	var _query = '',
	    locsearch = parSearch();
	for (var ky in queryobj) {
		locsearch[ky] = encodeURIComponent(queryobj[ky]);
	}
	for (var idx in locsearch) {
		_query += '&' + idx + '=' + locsearch[idx];
	}return '?' + _query.substr(1);
}

function isPreview() {
	var srhmap = parSearch();
	return srhmap['hash'] == 'preview';
}

function isEditor() {
	var pageid = '',
	    srhmap = parSearch(),
	    iid = srhmap['editor'] || '';
	if (iid && /^\d+$/i.test(iid)) pageid = iid;
	return pageid;
}

function getModAct() {
	var srhmap = parSearch(),
	    mastr = srhmap['admin'] || '';
	if (mastr && /^(\w+)\/(\w+)$/i.test(mastr)) {
		ctrler = RegExp.$1;
		action = RegExp.$2;
	}
	return [ctrler, action];
}

function remoteUrl(short_path) {
	var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'api';
	var param = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	var host =  false ? '/index.php/' : window.hosturl;
	var q = '',
	    hosturl = type == 'api' ? window.apihost : host;
	if (!$.isPlainObject(param)) param = { param: param };
	for (var k in param) {
		q += '&' + k + '=' + encodeURIComponent(param[k]);
	}return hosturl + short_path + '?_ax=1' + q;
}

function remoteStaticUrl(short_path) {
	return window.hosturl + short_path;
}

function xhrPost(url, data, success) {
	var fail = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $.noop;

	var host = getHost(),
	    sid = getCookie('loginresponsid') || getCookie('PHPSESSID'),
	    newdata = $.extend({}, data || {}, { sid: sid });
	$.post(host + url + '?_ax=1', newdata, function (res) {
		if (!$.isPlainObject(res)) res = JSON.parse(res);
		if (res.result == 'ERROR' && res.errcode == -1000) {
			/*alert('登录超时，请重新登录。');
   location.reload();*/return false;
		}
		$.isFunction(success) && success(res);
	}).fail(function (xhr) {
		return fail(xhr.statusText + ' (' + xhr.status + ')');
	});
}

function getUserInfo(success) {
	var fail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $.noop;

	var loginuser = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, userinf);
	if (/^[1-9]\d*$/.test((loginuser.data || {}).id || 0)) {
		success(loginuser);
		return false;
	}

	new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		xhrPost('user/index', null, function (res) {
			return resolve(res);
		}, function (err) {
			return reject(err);
		});
	}).then(function (res) {
		userinf = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, res);
		var errmsg = res.errmsg || res.data.errmsg || '';
		if (userinf.result == 'ERROR' && errmsg != 'unlogin') {
			alert(errmsg);return false;
		}
		success(userinf);
	}, function (err) {
		return fail(err);
	});
}

function ucFirst(str) {
	if (!(str && str.trim().length)) return str;
	return str.charAt(0).toUpperCase() + str.substr(1);
}

function getCookie(key) {
	var cookiesArray = document.cookie ? document.cookie.split('; ') : Array.prototype,
	    i = 0,
	    len = cookiesArray.length,
	    item = [],
	    value = void 0,
	    tempKey = void 0;

	for (i; i < len; i++) {
		item = cookiesArray[i].split('=');
		tempKey = decodeURIComponent(item[0]);
		if (tempKey === key) {
			value = decodeURIComponent(item[1]);
			if (/[\{\[]/.test(value)) value = JSON.parse(value);
		}
	}

	return value;
}

function fGuid(param) {
	var fGuidCst = function fGuidCst() {
		var sGuid = '';
		for (var i = 1; i <= 32; i++) {
			var nNum = 0;
			nNum = parseInt(Math.random() * 16);
			sGuid += nNum.toString(16);
			if ($.inArray(i, [8, 12, 16, 20]) > -1) sGuid += '-';
		}
		return '{' + sGuid.toUpperCase() + '}';
	};
	var sGuid = fGuidCst();
	if (param) return sGuid;
	return ('' + sGuid).replace(/\{|\}|-/g, '');
}

function Page(pid) {
	this.pageid = pid;
	this.pages = [];
	this.pageinfo = {};
	this.modinfo = [];
	this.rmids = [];
	this.fetchPageInf(pid);
}
Page.prototype.fetchPageInf = function (id) {
	var self = this,
	    host = getHost(),
	    sid = getCookie('loginresponsid') || getCookie('PHPSESSID');
	$.ajax({
		async: false,
		type: 'POST',
		url: host + 'page/index?_ax=1',
		data: { id: id, sid: sid },
		success: function success(res) {
			var pid = parseInt(res.pageid || '0');
			if (pid) self.pageid = pid;
			self.pages = res.pages;
			self.pageinfo = res.pageinfo;
			self.modinfo = res.modinfo;
		}
	});
};

function getCurPage() {
	var id = isEditor();
	if (curpage && curpage.pageid == id) return curpage;

	curpage = new Page(id);
	return curpage;
}

function pageSave(vm, pageid) {
	var curpage = getCurPage(),
	    modstr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(curpage.modinfo);

	xhrPost('page/save_layout', {
		"id": pageid, "mods": modstr,
		"rmids": curpage.rmids
	}, function (res) {
		if (res.result == "OK") {
			curpage.rmids = [];
			vm.$Message.success('保存成功');
			setTimeout(function () {
				var isdirect = res.data.isdirect || '1';
				if (isdirect === '1') {
					location.search = '?admin=wxapp/pages';
					return false;
				}

				if (pageid != isEditor()) {
					location.search = resetSearch({ 'editor': pageid });
				}
			}, 100);
		} else vm.$Message.error('保存失败');
	}, function (err) {
		return console.error(err);
	});
}

function pagelink(lnkobj) {
	// for 'page-links'
	if (!$.isPlainObject(lnkobj) || $.isEmptyObject(lnkobj)) return false;

	var val = lnkobj.param.value || '';
	switch (lnkobj.type || 'none') {
		case 'page':
			if (!/^\d+$/.test(val)) return false;
			location.search = resetSearch({ 'editor': val });
			break;
		case 'func':
			var _type = lnkobj.param.type || '';
			if (!$.trim(val).length && _type == 'callto') return false;

			if (_type == 'callto') location.href = 'tel:' + val;else if (_type && lnkobj.param.pagevalue) {
				var pagevalue = lnkobj.param.pagevalue,
				    idsvalue = lnkobj.param.idsvalue || [];

				var params = { 'editor': pagevalue };
				if (idsvalue.length) params['id'] = idsvalue.toString();
				location.search = resetSearch(params);
			}
			break;
	}
}

function parseTime(t) {
	var spliter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';

	var tt = new Date(t * 1000),
	    strpad = function strpad(n) {
		return (('' + n).length > 1 ? '' : '0') + n;
	},
	    datestr = tt.getFullYear();
	datestr += spliter + strpad(tt.getMonth() + 1) + spliter + strpad(tt.getDate());
	datestr += ' ' + strpad(tt.getHours()) + ':' + strpad(tt.getMinutes());
	datestr += ':' + strpad(tt.getSeconds());
	return datestr;
}

function checkSiteStatus() {
	var userinf = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	var site_status = userinf.site_status || '0',
	    expired_time = parseInt(userinf.expired_time || '0');
	if (isNaN(expired_time)) return '到期时间异常';

	var errmsg = '',
	    msec = +new Date(),
	    curtime = parseInt(('' + msec).substr(0, 10));
	if (site_status == '-1') errmsg = '该账户暂无法使用';else if (site_status == '0') errmsg = '该账户已被删除';else if (site_status == '2' || expired_time < curtime) errmsg = '该账户已过期';

	return errmsg;
}

/* harmony default export */ __webpack_exports__["a"] = ({
	URLPREFIX: URLPREFIX,
	HEADERH: HEADERH,
	isEditor: isEditor,
	isPreview: isPreview,
	getModAct: getModAct,
	xhrPost: xhrPost,
	getUserInfo: getUserInfo,
	ucFirst: ucFirst,
	fGuid: fGuid,
	getCurPage: getCurPage,
	pageSave: pageSave,
	remoteUrl: remoteUrl,
	remoteStaticUrl: remoteStaticUrl,
	getHost: getHost,
	parSearch: parSearch,
	resetSearch: resetSearch,
	pagelink: pagelink,
	parseTime: parseTime,
	checkSiteStatus: checkSiteStatus
});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(23);


var modevts = {},
    ebus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();
ebus.Add = function (id, type, fn) {
	!modevts[id] && (modevts[id] = {});
	!modevts[id][type] && (modevts[id][type] = fn);
};
ebus.Emit = function (id, type, data) {
	var tmpobj = modevts[id] || {};
	return tmpobj[type] ? tmpobj[type](data) : {};
};

/* harmony default export */ __webpack_exports__["a"] = (ebus);

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global__ = __webpack_require__(4);


var plugin_params = {};
function get_plugin_param(type) {
    return $.extend({}, plugin_params[type]);
}

function get_plugin_options(type) {
    var options = {};
    for (var k in plugin_params[type]) {
        if (/^_/.test(k)) continue;
        options[k] = $.extend({}, plugin_params[type][k]);
    }
    return options;
}

function set_plugin_param(type, param) {
    if (!plugin_params[type]) plugin_params[type] = $.extend({}, param);
}

function get_default_plugin(modtype, params) {
    var defaultparams = {
        "left": 0, "top": 0, "parent": '', "width": 100,
        "height": 'auto', "zindex": -1, "childprop": {}
    };
    var modparam = $.extend({}, defaultparams, params),
        curpage = __WEBPACK_IMPORTED_MODULE_0__global__["a" /* default */].getCurPage(),
        modinf = curpage.modinfo,
        id = 'layer' + __WEBPACK_IMPORTED_MODULE_0__global__["a" /* default */].fGuid();
    if (modparam.zindex == -1) {
        var biggestzindex = -1,
            parent = modparam.parent;
        for (var i = 0, ln = modinf.length; i < ln; i++) {
            if (modinf[i].parent != parent) continue;
            if (biggestzindex < modinf[i].zindex) biggestzindex = modinf[i].zindex;
        }
        modparam.zindex = biggestzindex + 1;
    }
    modparam.id = id;
    modparam.type = modtype;

    return modparam;
}

var propertyarr = {};
function set_plugin_property(key, propertyobj) {
    propertyarr[key] = propertyobj;
}

function get_plugin_property(key) {
    return propertyarr[key];
}

var stylesarr = {};
function set_plugin_styles(key, stylesobj) {
    stylesarr[key] = stylesobj;
}

function get_plugin_styles(key) {
    return stylesarr[key];
}

/* harmony default export */ __webpack_exports__["a"] = ({
    get_plugin_param: get_plugin_param,
    set_plugin_param: set_plugin_param,
    get_plugin_options: get_plugin_options,
    set_plugin_property: set_plugin_property,
    get_plugin_property: get_plugin_property,
    set_plugin_styles: set_plugin_styles,
    get_plugin_styles: get_plugin_styles,
    get_default_plugin: get_default_plugin
});

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var dlgdrag = {
	directives: {
		dlgdrag: {
			inserted: function inserted(el, binding, vnode) {
				var dlgw;
				var dlgh;
				var winw;
				var winh;
				var retrynum = 0;
				$(el).bind('reposition', function () {
					dlgw = $(el).width();
					dlgh = $(el).height();
					if (dlgw == 0) {
						if (retrynum < 100) {
							setTimeout(function () {
								$(el).trigger('reposition');
							}, 60);
							retrynum += 1;
						}
						return;
					}
					winw = $(window).width();
					winh = $(window).height();
					var left = parseInt((winw - dlgw) / 2) + 'px';
					var top = parseInt((winh - dlgh) / 2) + 'px';
					$(el).css({ left: left, top: top });
				});
				$(el).css('position', '').trigger('reposition');
				$(el).draggable({
					handle: '.dig_title',
					drag: function drag(event, ui) {
						if (dlgw >= 320 && ui.position.left < 320 - dlgw) {
							ui.position.left = 320 - dlgw;
						} else if (dlgw < 320 && ui.position.left < 0) {
							ui.position.left = 0;
						}
						if (ui.position.top < -23) ui.position.top = -23;
						if (ui.position.left + 320 > winw) {
							ui.position.left = winw - 320;
						}
						if (ui.position.top + 70 > winh) {
							ui.position.top = winh - 70;
						}
					}
				}).css('position', '');
			},
			unbind: function unbind(el) {
				$(el).unbind('reposition');
				$(el).css({ left: '', top: '' });
				$(el).draggable('destroy');
			}
		}
	}
};

/* harmony default export */ __webpack_exports__["a"] = (dlgdrag);

/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(164)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(88),
  /* template */
  __webpack_require__(192),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);




var _extends = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default.a || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};
var exportobj;
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(arr);
  }
}
(function () {
  "use strict";

  if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default.a) {
    Array.from = function (object) {
      return [].slice.call(object);
    };
  }

  function buildDraggable(Sortable) {
    function removeNode(node) {
      node.parentElement.removeChild(node);
    }

    function insertNodeAt(fatherNode, node, position) {
      var refNode = position === 0 ? fatherNode.children[0] : fatherNode.children[position - 1].nextSibling;
      fatherNode.insertBefore(node, refNode);
    }

    function computeVmIndex(vnodes, element) {
      return vnodes.map(function (elt) {
        return elt.elm;
      }).indexOf(element);
    }

    function _computeIndexes(slots, children, isTransition) {
      if (!slots) {
        return [];
      }

      var elmFromNodes = slots.map(function (elt) {
        return elt.elm;
      });
      var rawIndexes = [].concat(_toConsumableArray(children)).map(function (elt) {
        return elmFromNodes.indexOf(elt);
      });
      return isTransition ? rawIndexes.filter(function (ind) {
        return ind !== -1;
      }) : rawIndexes;
    }

    function emit(evtName, evtData) {
      var _this = this;

      this.$nextTick(function () {
        return _this.$emit(evtName.toLowerCase(), evtData);
      });
    }

    function delegateAndEmit(evtName) {
      var _this2 = this;

      return function (evtData) {
        if (_this2.realList !== null) {
          _this2['onDrag' + evtName](evtData);
        }
        emit.call(_this2, evtName, evtData);
      };
    }

    var eventsListened = ['Start', 'Add', 'Remove', 'Update', 'End'];
    var eventsToEmit = ['Choose', 'Sort', 'Filter', 'Clone'];
    var readonlyProperties = ['Move'].concat(eventsListened, eventsToEmit).map(function (evt) {
      return 'on' + evt;
    });
    var draggingElement = null;

    var props = {
      options: Object,
      list: {
        type: Array,
        required: false,
        default: null
      },
      value: {
        type: Array,
        required: false,
        default: null
      },
      noTransitionOnDrag: {
        type: Boolean,
        default: false
      },
      clone: {
        type: Function,
        default: function _default(original) {
          return original;
        }
      },
      element: {
        type: String,
        default: 'div'
      },
      move: {
        type: Function,
        default: null
      }
    };

    var draggableComponent = {
      name: 'draggable',

      props: props,

      data: function data() {
        return {
          transitionMode: false,
          componentMode: false
        };
      },
      render: function render(h) {
        var slots = this.$slots.default;
        if (slots && slots.length === 1) {
          var child = slots[0];
          if (child.componentOptions && child.componentOptions.tag === "transition-group") {
            this.transitionMode = true;
          }
        }
        var children = slots;
        var footer = this.$slots.footer;

        if (footer) {
          children = slots ? [].concat(_toConsumableArray(slots), _toConsumableArray(footer)) : [].concat(_toConsumableArray(footer));
        }
        return h(this.element, null, children);
      },
      mounted: function mounted() {
        var _this3 = this;

        this.componentMode = this.element.toLowerCase() !== this.$el.nodeName.toLowerCase();
        if (this.componentMode && this.transitionMode) {
          throw new Error('Transition-group inside component is not supported. Please alter element value or remove transition-group. Current element value: ' + this.element);
        }
        var optionsAdded = {};
        eventsListened.forEach(function (elt) {
          optionsAdded['on' + elt] = delegateAndEmit.call(_this3, elt);
        });

        eventsToEmit.forEach(function (elt) {
          optionsAdded['on' + elt] = emit.bind(_this3, elt);
        });

        var options = _extends({}, this.options, optionsAdded, { onMove: function onMove(evt, originalEvent) {
            return _this3.onDragMove(evt, originalEvent);
          } });
        !('draggable' in options) && (options.draggable = '>*');
        this._sortable = new Sortable(this.rootContainer, options);
        this.computeIndexes();
      },
      beforeDestroy: function beforeDestroy() {
        this._sortable.destroy();
      },

      computed: {
        rootContainer: function rootContainer() {
          return this.transitionMode ? this.$el.children[0] : this.$el;
        },
        isCloning: function isCloning() {
          return !!this.options && !!this.options.group && this.options.group.pull === 'clone';
        },
        realList: function realList() {
          return !!this.list ? this.list : this.value;
        }
      },

      watch: {
        options: {
          handler: function handler(newOptionValue) {
            for (var property in newOptionValue) {
              if (readonlyProperties.indexOf(property) == -1) {
                this._sortable.option(property, newOptionValue[property]);
              }
            }
          },

          deep: true
        },

        realList: function realList() {
          this.computeIndexes();
        }
      },

      methods: {
        getChildrenNodes: function getChildrenNodes() {
          if (this.componentMode) {
            return this.$children[0].$slots.default;
          }
          var rawNodes = this.$slots.default;
          return this.transitionMode ? rawNodes[0].child.$slots.default : rawNodes;
        },
        computeIndexes: function computeIndexes() {
          var _this4 = this;

          this.$nextTick(function () {
            _this4.visibleIndexes = _computeIndexes(_this4.getChildrenNodes(), _this4.rootContainer.children, _this4.transitionMode);
          });
        },
        getUnderlyingVm: function getUnderlyingVm(htmlElt) {
          var index = computeVmIndex(this.getChildrenNodes() || [], htmlElt);
          if (index === -1) {
            //Edge case during move callback: related element might be
            //an element different from collection
            return null;
          }
          var element = this.realList[index];
          return { index: index, element: element };
        },
        getUnderlyingPotencialDraggableComponent: function getUnderlyingPotencialDraggableComponent(_ref) {
          var __vue__ = _ref.__vue__;

          if (!__vue__ || !__vue__.$options || __vue__.$options._componentTag !== "transition-group") {
            return __vue__;
          }
          return __vue__.$parent;
        },
        emitChanges: function emitChanges(evt) {
          var _this5 = this;

          this.$nextTick(function () {
            _this5.$emit('change', evt);
          });
        },
        alterList: function alterList(onList) {
          if (!!this.list) {
            onList(this.list);
          } else {
            var newList = [].concat(_toConsumableArray(this.value));
            onList(newList);
            this.$emit('input', newList);
          }
        },
        spliceList: function spliceList() {
          var _arguments = arguments;

          var spliceList = function spliceList(list) {
            return list.splice.apply(list, _arguments);
          };
          this.alterList(spliceList);
        },
        updatePosition: function updatePosition(oldIndex, newIndex) {
          var updatePosition = function updatePosition(list) {
            return list.splice(newIndex, 0, list.splice(oldIndex, 1)[0]);
          };
          this.alterList(updatePosition);
        },
        getRelatedContextFromMoveEvent: function getRelatedContextFromMoveEvent(_ref2) {
          var to = _ref2.to,
              related = _ref2.related;

          var component = this.getUnderlyingPotencialDraggableComponent(to);
          if (!component) {
            return { component: component };
          }
          var list = component.realList;
          var context = { list: list, component: component };
          if (to !== related && list && component.getUnderlyingVm) {
            var destination = component.getUnderlyingVm(related);
            if (destination) {
              return _extends(destination, context);
            }
          }

          return context;
        },
        getVmIndex: function getVmIndex(domIndex) {
          var indexes = this.visibleIndexes;
          var numberIndexes = indexes.length;
          return domIndex > numberIndexes - 1 ? numberIndexes : indexes[domIndex];
        },
        getComponent: function getComponent() {
          return this.$slots.default[0].componentInstance;
        },
        resetTransitionData: function resetTransitionData(index) {
          if (!this.noTransitionOnDrag || !this.transitionMode) {
            return;
          }
          var nodes = this.getChildrenNodes();
          nodes[index].data = null;
          var transitionContainer = this.getComponent();
          transitionContainer.children = [];
          transitionContainer.kept = undefined;
        },
        onDragStart: function onDragStart(evt) {
          this.context = this.getUnderlyingVm(evt.item);
          evt.item._underlying_vm_ = this.clone(this.context.element);
          draggingElement = evt.item;
        },
        onDragAdd: function onDragAdd(evt) {
          var element = evt.item._underlying_vm_;
          if (element === undefined) {
            return;
          }
          removeNode(evt.item);
          var newIndex = this.getVmIndex(evt.newIndex);
          this.spliceList(newIndex, 0, element);
          this.computeIndexes();
          var added = { element: element, newIndex: newIndex };
          this.emitChanges({ added: added });
        },
        onDragRemove: function onDragRemove(evt) {
          insertNodeAt(this.rootContainer, evt.item, evt.oldIndex);
          if (this.isCloning) {
            removeNode(evt.clone);
            return;
          }
          var oldIndex = this.context.index;
          this.spliceList(oldIndex, 1);
          var removed = { element: this.context.element, oldIndex: oldIndex };
          this.resetTransitionData(oldIndex);
          this.emitChanges({ removed: removed });
        },
        onDragUpdate: function onDragUpdate(evt) {
          removeNode(evt.item);
          insertNodeAt(evt.from, evt.item, evt.oldIndex);
          var oldIndex = this.context.index;
          var newIndex = this.getVmIndex(evt.newIndex);
          this.updatePosition(oldIndex, newIndex);
          var moved = { element: this.context.element, oldIndex: oldIndex, newIndex: newIndex };
          this.emitChanges({ moved: moved });
        },
        computeFutureIndex: function computeFutureIndex(relatedContext, evt) {
          if (!relatedContext.element) {
            return 0;
          }
          var domChildren = [].concat(_toConsumableArray(evt.to.children)).filter(function (el) {
            return el.style['display'] !== 'none';
          });
          var currentDOMIndex = domChildren.indexOf(evt.related);
          var currentIndex = relatedContext.component.getVmIndex(currentDOMIndex);
          var draggedInList = domChildren.indexOf(draggingElement) != -1;
          return draggedInList || !evt.willInsertAfter ? currentIndex : currentIndex + 1;
        },
        onDragMove: function onDragMove(evt, originalEvent) {
          var onMove = this.move;
          if (!onMove || !this.realList) {
            return true;
          }

          var relatedContext = this.getRelatedContextFromMoveEvent(evt);
          var draggedContext = this.context;
          var futureIndex = this.computeFutureIndex(relatedContext, evt);
          _extends(draggedContext, { futureIndex: futureIndex });
          _extends(evt, { relatedContext: relatedContext, draggedContext: draggedContext });
          return onMove(evt, originalEvent);
        },
        onDragEnd: function onDragEnd(evt) {
          this.computeIndexes();
          draggingElement = null;
          $(evt.path[1]).width('').css("width", function () {
            return 'calc(100% + 17px)';
          });
        }
      }
    };
    return draggableComponent;
  }

  var Sortable = __webpack_require__(103);
  Sortable = Sortable.default;
  exportobj = buildDraggable(Sortable);
  // if (typeof exports == "object") {
  //   var Sortable = require("@/components/vuedraggable/sortable.js");
  //   module.exports = buildDraggable(Sortable);
  // } else if (typeof define == "function" && define.amd) {
  //   define(['sortablejs'], function (Sortable) {
  //     return buildDraggable(Sortable);
  //   });
  // } else if (window && window.Vue && window.Sortable) {
  //   var draggable = buildDraggable(window.Sortable);
  //   Vue.component('draggable', draggable);
  // }
})();
/* harmony default export */ __webpack_exports__["a"] = (exportobj);

/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);


/**
 * 
 * 计算有效期
 * 
 * @param {any} expiresStr 有效期数字或字符串
 */
function calcExpires(expiresStr) {
	var Years = /^\d+Y$/,
	    Months = /^\d+M$/,
	    Days = /^[-\d]+D$/,
	    hours = /^\d+h$/,
	    minutes = /^\d+m$/,
	    seconds = /^\d+s$/;
	// culc time unit
	var time = new Date(),
	    timeUnit = 0;
	expiresStr = expiresStr === undefined ? '1D' : +expiresStr + '' == expiresStr ? expiresStr + 'D' : expiresStr;

	switch (true) {
		case Years.test(expiresStr):
			timeUnit = 864e+5 * 365;
			break;
		case Months.test(expiresStr):
			timeUnit = 864e+5 * 30;
			break;
		case Days.test(expiresStr):
			timeUnit = 864e+5;
			break;
		case hours.test(expiresStr):
			timeUnit = 3600000;
			break;
		case minutes.test(expiresStr):
			timeUnit = 60000;
			break;
		case seconds.test(expiresStr):
			timeUnit = 1000;
			break;
		default:
			throw new Error('expires type error!');
	}
	expiresStr = expiresStr.replace(/[YMDhms]/, '') * 1;
	time.setMilliseconds(time.getMilliseconds() + expiresStr * timeUnit);

	return time.toGMTString();
}

function extend() {
	return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default.a.apply({}, arguments);
}

var defaultOptions = { path: '/' }; //{path: '/', expires: 1};

/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		Vue.prototype.$cookie = this;
		Vue.cookie = this;
	},
	set: function set(key, value, options) {
		options = extend(defaultOptions, options);
		var expires = options.expires;
		// 纯数字或数字字符串单位默认为天
		if (typeof expires === 'number' || typeof expires === 'string') {
			options.expires = calcExpires(expires);
		} else {}
		// expires == undefined为会话cookie，浏览器关闭后自动清除
		//throw new Error('expires must be number or string type!');


		// value 转换为 json
		var result = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value);
		if (/[\{\[]/.test(result)) {
			value = result;
		}

		// 特殊字符转换
		value = encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

		key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);

		var tempStr = '';
		// 遍历属性
		for (var val in options) {
			if (!options[val]) continue;
			tempStr += '; ' + val + '=' + options[val];
		}

		document.cookie = key + '=' + value + tempStr;
		return document.cookie;
	},
	get: function get(key) {
		var cookiesArray = document.cookie ? document.cookie.split('; ') : Array.prototype,
		    i = 0,
		    len = cookiesArray.length,
		    item = [],
		    value,
		    tempKey;

		for (i; i < len; i++) {
			item = cookiesArray[i].split('=');
			tempKey = decodeURIComponent(item[0]);
			if (tempKey === key) {
				value = decodeURIComponent(item[1]);
				if (/[\{\[]/.test(value)) {
					value = JSON.parse(value);
				}
			}
		}

		return value;
	},
	delete: function _delete(key) {
		this.set.call(this, key, '', { expires: -1 });
	}
});

/***/ }),
/* 71 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 72 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 73 */,
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(155)
  __webpack_require__(156)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(87),
  /* template */
  __webpack_require__(185),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2de9151e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 75 */,
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(169)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(196),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d3eabaa0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */,
/* 78 */,
/* 79 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,R0lGODlhFAAUALMIAPh2AP+TMsZiALlcAKNOAOp4ANVqAP+PFv///wAAAAAAAAAAAAAAAAAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQFCgAIACwAAAAAFAAUAAAEUxDJSau9iBDMtebTMEjehgTBJYqkiaLWOlZvGs8WDO6UIPCHw8TnAwWDEuKPcxQml0Ynj2cwYACAS7VqwWItWyuiUJB4s2AxmWxGg9bl6YQtl0cAACH5BAUKAAgALAEAAQASABIAAAROEMkpx6A4W5upENUmEQT2feFIltMJYivbvhnZ3Z1h4FMQIDodz+cL7nDEn5CH8DGZhcLtcMBEoxkqlXKVIgAAibbK9YLBYvLtHH5K0J0IACH5BAUKAAgALAEAAQASABIAAAROEMkphaA4W5upMdUmDQP2feFIltMJYivbvhnZ3V1R4BNBIDodz+cL7nDEn5CH8DGZAMAtEMBEoxkqlXKVIg4HibbK9YLBYvLtHH5K0J0IACH5BAUKAAgALAEAAQASABIAAAROEMkpjaE4W5tpKdUmCQL2feFIltMJYivbvhnZ3R0A4NMwIDodz+cL7nDEn5CH8DGZh8ONQMBEoxkqlXKVIgIBibbK9YLBYvLtHH5K0J0IACH5BAUKAAgALAEAAQASABIAAAROEMkpS6E4W5spANUmGQb2feFIltMJYivbvhnZ3d1x4JMgIDodz+cL7nDEn5CH8DGZgcBtMMBEoxkqlXKVIggEibbK9YLBYvLtHH5K0J0IACH5BAUKAAgALAEAAQASABIAAAROEMkpAaA4W5vpOdUmFQX2feFIltMJYivbvhnZ3V0Q4JNhIDodz+cL7nDEn5CH8DGZBMJNIMBEoxkqlXKVIgYDibbK9YLBYvLtHH5K0J0IACH5BAUKAAgALAEAAQASABIAAAROEMkpz6E4W5tpCNUmAQD2feFIltMJYivbvhnZ3R1B4FNRIDodz+cL7nDEn5CH8DGZg8HNYMBEoxkqlXKVIgQCibbK9YLBYvLtHH5K0J0IACH5BAkKAAgALAEAAQASABIAAAROEMkpQ6A4W5spIdUmHQf2feFIltMJYivbvhnZ3d0w4BMAIDodz+cL7nDEn5CH8DGZAsGtUMBEoxkqlXKVIgwGibbK9YLBYvLtHH5K0J0IADs="

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,R0lGODlhEAAQAIAAAP///8zMzCH/C1hNUCBEYXRhWE1QPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS4wLWMwNjAgNjEuMTM0Nzc3LCAyMDEwLzAyLzEyLTE3OjMyOjAwICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1IFdpbmRvd3MiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6N0MyOTQ2REZCMDQ1MTFFMTgzNURBRUE2MjRDMTY3RUEiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6N0MyOTQ2RTBCMDQ1MTFFMTgzNURBRUE2MjRDMTY3RUEiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo3QzI5NDZEREIwNDUxMUUxODM1REFFQTYyNEMxNjdFQSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo3QzI5NDZERUIwNDUxMUUxODM1REFFQTYyNEMxNjdFQSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PgH//v38+/r5+Pf29fTz8vHw7+7t7Ovq6ejn5uXk4+Lh4N/e3dzb2tnY19bV1NPS0dDPzs3My8rJyMfGxcTDwsHAv769vLu6ubi3trW0s7KxsK+urayrqqmop6alpKOioaCfnp2cm5qZmJeWlZSTkpGQj46NjIuKiYiHhoWEg4KBgH9+fXx7enl4d3Z1dHNycXBvbm1sa2ppaGdmZWRjYmFgX15dXFtaWVhXVlVUU1JRUE9OTUxLSklIR0ZFRENCQUA/Pj08Ozo5ODc2NTQzMjEwLy4tLCsqKSgnJiUkIyIhIB8eHRwbGhkYFxYVFBMSERAPDg0MCwoJCAcGBQQDAgEAACH5BAAAAAAALAAAAAAQABAAAAIfjG+gq4jM3IFLJgpswNly/XkcBpIiVaInlLJr9FZWAQA7"

/***/ }),
/* 82 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAXsAAAAeCAYAAADNcL5WAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpGMjhFMDk2RkMzNUUxMUU3OURGNjhGQkIwOTI3Njc5QyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpGMjhFMDk3MEMzNUUxMUU3OURGNjhGQkIwOTI3Njc5QyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkYyOEUwOTZEQzM1RTExRTc5REY2OEZCQjA5Mjc2NzlDIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkYyOEUwOTZFQzM1RTExRTc5REY2OEZCQjA5Mjc2NzlDIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+Iyq1XAAAAtRJREFUeNrs3b1rU1EcxvGT9zSNVhAFrUvm0kEtiKWKtjgIOlSRgs7+Ca4iXRUEOzq7VKiDgpv4MoggiKCrg/gCiqLFlKRNiM8vN5Vqb0Kiyb231+8HnqGXQMO57ZOTc9LTRKPRcAMyohxWJpQxpaSMKjuUogOA/9cP5ZvyQXmjvFaeK0+V74P4hok+l/0+ZU45oxxSUtxTAOhaXXmmLCm3lbdRK/ujyiXlJAUPAH0r/vvKNeVR2GV/TJlXjnBfAGBgniiXlYdBl/0e5apygXsAAIG55bxVlI9BlP055abzNmABAMGyDdyLzlvT71qyh8dmlQVlkaIHgNCMtHrY+jjX75n9NuWOMsM4A0BkPFZmla/9KPtdztsRPsi4AkDkvFROKJ//pezt7cID5QDjCQCR9UI57jr8QVanNXtbo1+i6AEg8va3+jr7N2V/XZlmDAFgS5hu9bavdss49vHKRcYOQVpdXXWVSsXV63WXSqVcPp932az/RMV+bldWVtza2pob4PlO/jOkZNLlcrnm8wMiaM6vv/3K3g4re+W8A8uAwIq+XC5vuj48POxb+MvLy80XhTBZ2Q8NDXHzEDV2wNq48u63SYrPAxcoegTNZvTdXq/VaqEXvalWq9w4RJH1941N70j/+Np2c2cZKwStXXlHodSBLch6fKZT2c8zRgiDrdF3e92uJRKJ0J9zJpPhxiHKrrQrezumeIrxQRjabXb6XbeiLxaLzY3SsKTTaVcoFLhxiLKpVq97vzcbNmjvKqcYH4Sll0/jrAtjmcdebMJ8oQF6cE85vbHsdyvvbcLC2ABAbNSc9wnLT+vTk/MUPQDETrrV77/W7M8yJgAQS81+t2UcO+zsi+N/xwJAHNnG1k6b2U9S9AAQW9bvk1b2nGoJAPE2YWU/zjgAQKyNWdmXGAcAiLWSlf1exgEAYm3Uyp4TLgEg3rbbRy8bjAMAxNtPAQYAOCys+ZpRPNsAAAAASUVORK5CYII="

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(152)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(93),
  /* template */
  __webpack_require__(183),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 84 */,
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(162)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(94),
  /* template */
  __webpack_require__(190),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-67785c7f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(163)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(100),
  /* template */
  __webpack_require__(191),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7604f92b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tips__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tips___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_tips__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_editor__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_sidebar__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_login_login__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_login_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__modules_login_login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_events__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_file_manager__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_file_manager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_file_manager__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








//import defaultlogo from '@/assets/logo.jpg';

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'app',
	data: function data() {
		return {
			iseditor: false,
			cmpalias: 'Tips',
			cmptype: 'loading',
			pageid: 0,
			containerh: 0,
			headerh: __WEBPACK_IMPORTED_MODULE_1__global__["a" /* default */].HEADERH,
			logined: true,
			loguser: '',
			ispreview: false,
			winheight: 0,
			filemgr_type: '',
			filemgr_multiselect: false,
			show_filedialog: false,
			buildAppTip: false,
			siteError: false,
			siteErrTips: '',
			page_title: '',
			page_subtitle: '',
			logo: '',
			helper: '',
			logsmore: '',
			vscnt: 1,
			version: '',
			syslog: {}
		};
	},

	computed: {
		ctstyle: function ctstyle() {
			var ispreview = this.ispreview,
			    width = 'calc(100% - 300px)',
			    mleft = ispreview ? '0px' : '30px';
			if (this.iseditor) width = ispreview ? '100%' : 'calc(100% - 278px)';
			return { width: width, 'margin-left': mleft };
		},
		con_height: function con_height() {
			return (parseFloat(this.winheight) - 37 * 2 - 7) * 0.9 + 'px';
		},
		con_main_left_height: function con_main_left_height() {
			return Math.max(245, (parseFloat(this.winheight) - 37 * 2 - 7) * 0.9 - 35 - 132 + 30) + 'px';
		}
	},
	created: function created() {
		var _this = this;

		var deflogo = window.hosturl + 'image/logo.png?v=1.0';
		this.helper = window.hosturl + 'index/help';
		this.logsmore = window.hosturl + 'index/logs';
		this.page_title = window.page_title || '';
		this.page_subtitle = window.page_subtitle || '';
		// for 'site-status'
		this.ispreview = __WEBPACK_IMPORTED_MODULE_1__global__["a" /* default */].isPreview();
		var pageid = __WEBPACK_IMPORTED_MODULE_1__global__["a" /* default */].isEditor();
		if (pageid) {
			this.pageid = pageid;this.iseditor = true;
		}
		// for 'customer-scrollbar'
		this.$nextTick(function () {
			var that = _this,
			    headerh = that.headerh,
			    domroot = that.$refs.approot,
			    sidebar = that.$refs.sidebar,
			    content = that.$refs.content;
			$(window).on("resize", function (e) {
				var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

				var winh = $(this).height();
				that.winheight = winh;
				if (!type) {
					$(domroot).height(winh);
					var $target = $([]),
					    csidx = 'min-height';
					if (that.iseditor) {
						csidx = 'height';
						that.containerh = winh - headerh;
						$target = $('.baseplugin, .propanel', that.$el);
					}$target = $('> ul', sidebar);
					$target.add([sidebar, content]).css(csidx, winh - headerh + 'px');
					if (that.ispreview) $(content).height(winh);
				}
				!that.iseditor && that.$vuebar.refreshScrollbar(domroot);
			}).trigger("resize");

			if (that.iseditor && that.$vuebar.getState(domroot)) {
				that.$vuebar.destroyScrollbar(domroot);
			}
		});
		// for 'resize-listener'
		__WEBPACK_IMPORTED_MODULE_6__common_events__["a" /* default */].$on("winresize", function (v) {
			return $(window).trigger("resize", [v]);
		});
		// 'File-manager' listener
		__WEBPACK_IMPORTED_MODULE_6__common_events__["a" /* default */].$on("show_filemanager", function (ishow, callback) {
			var ftype = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'all';
			var multiselect = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

			_this.show_filedialog = ishow || false;
			if (!ishow) {
				__WEBPACK_IMPORTED_MODULE_6__common_events__["a" /* default */].$off("select_picture");return false;
			}
			_this.filemgr_type = ftype;
			_this.filemgr_multiselect = multiselect;
			// 'Select-picture' listener
			if (!$.isFunction(callback)) return false;
			__WEBPACK_IMPORTED_MODULE_6__common_events__["a" /* default */].$once("select_picture", function (res) {
				callback.call(null, res);
				_this.show_filedialog = false;
			});
		});
		// for 'oauth'
		__WEBPACK_IMPORTED_MODULE_1__global__["a" /* default */].getUserInfo(function (res) {
			var userinf = res.data || {};
			if (res.result == 'ERROR') {
				_this.initComp();
				return false;
			}
			// for 'site-status'
			var errmsg = __WEBPACK_IMPORTED_MODULE_1__global__["a" /* default */].checkSiteStatus(userinf);
			if (errmsg.length > 0) {
				_this.siteError = true;
				_this.siteErrTips = errmsg;
				return false;
			}

			_this.logined = true;
			_this.loguser = userinf.account;
			// for 'version'
			_this.version = userinf.version || '';
			// for 'logo'
			var extra = JSON.parse(userinf.extra || '{}');
			_this.logo = extra.logo || deflogo;
			// for 'editor-pause'
			if (_this.iseditor) return false;
			// for '是否绑定小程序提示'
			if (_this.$cookie.get('wxappbuild') != '1') {
				__WEBPACK_IMPORTED_MODULE_1__global__["a" /* default */].xhrPost('wxapp/configset', null, function (res) {
					_this.buildAppTip = $.isEmptyObject(userinf);
				});
			} else _this.buildAppTip = false;

			var _jGlobal$getModAct = __WEBPACK_IMPORTED_MODULE_1__global__["a" /* default */].getModAct(),
			    _jGlobal$getModAct2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_jGlobal$getModAct, 2),
			    mod = _jGlobal$getModAct2[0],
			    act = _jGlobal$getModAct2[1],
			    curcomp = __WEBPACK_IMPORTED_MODULE_1__global__["a" /* default */].ucFirst(mod) + __WEBPACK_IMPORTED_MODULE_1__global__["a" /* default */].ucFirst(act);
			//this.logined.referer = curcomp;
			// for 'success'


			_this.cmpalias = curcomp;
			var shortpath = mod + '/' + act;
			__WEBPACK_IMPORTED_MODULE_6__common_events__["a" /* default */].$emit("sidebar_menuactived", shortpath);
			_this.$options.components['Mc' + curcomp] = function (resolve) {
				__webpack_require__.e/* require.ensure */(0).then((function (require) {
					var reqc = __webpack_require__(201);

					try {
						var loaded = reqc('./' + shortpath + '.vue');
						if (loaded) resolve(loaded);else throw 'not found';
					} catch (err) {
						_this.cmpalias = 'Tips';mod = '404';
						__WEBPACK_IMPORTED_MODULE_6__common_events__["a" /* default */].$emit("sidebar_menuactived", '');
					}
					_this.cmptype = mod;
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			};
		}, function (err) {
			return _this.initComp();
		});
		// for 'Get offical-version information'
		__WEBPACK_IMPORTED_MODULE_1__global__["a" /* default */].xhrPost('user/logs', null, function (res) {
			_this.vscnt = res.data.vscnt || 0;
			_this.syslog = res.data.logs || {};
		});
	},

	methods: {
		updateVersion: function updateVersion() {
			var vscnt = this.vscnt || 0;
			if (!vscnt) return false;
			this.vscnt = 0;
			// for 'update local-version'
			__WEBPACK_IMPORTED_MODULE_1__global__["a" /* default */].xhrPost('user/logvs', { 'vs': this.version });
		},
		showFile: function showFile() {
			__WEBPACK_IMPORTED_MODULE_6__common_events__["a" /* default */].$emit("show_filemanager", true);
		},
		showSetting: function showSetting() {
			__WEBPACK_IMPORTED_MODULE_6__common_events__["a" /* default */].$emit("show_setting", true);
		},
		onSave: function onSave() {
			__WEBPACK_IMPORTED_MODULE_6__common_events__["a" /* default */].$emit("pagesave");
		},
		initComp: function initComp() {
			this.cmpalias = 'Tips';
			this.cmptype = 'loading';
			this.logined = false;
		},
		allowDrop: function allowDrop(e) {
			if (!this.editor) return true;
			e.preventDefault();
			if (/firefox/i.test(navigator.userAgent)) window.event = e;
			return true;
		},
		logout: function logout() {
			__WEBPACK_IMPORTED_MODULE_1__global__["a" /* default */].xhrPost('user/logout', null, function (res) {
				location.search = 'admin=index/index';
			});
		},
		onTaste: function onTaste() {
			this.$cookie.set('wxappbuild', '1');
		},
		onBuild: function onBuild() {
			this.$cookie.set('wxappbuild', '1');
			location.search = '?admin=wxapp/publish';
		}
	},
	components: { McTips: __WEBPACK_IMPORTED_MODULE_2__components_tips___default.a, Login: __WEBPACK_IMPORTED_MODULE_5__modules_login_login___default.a, Weditor: __WEBPACK_IMPORTED_MODULE_3__components_editor___default.a, Sidebar: __WEBPACK_IMPORTED_MODULE_4__components_sidebar___default.a, FileManager: __WEBPACK_IMPORTED_MODULE_7__components_file_manager___default.a }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_events__ = __webpack_require__(5);
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            color: this.value
        };
    },
    mounted: function mounted() {
        var vm = this,
            _format = vm.format || '';
        $(this.$el).spectrum({
            showPalette: true,
            showAlpha: _format ? false : true,
            color: this.val_to_color(this.color),
            change: function change(color) {
                var corgb = color.toRgbString();
                var costr = '';
                if (corgb == 'rgba(0, 0, 0, 0)') {
                    costr = 'transparent';
                } else if (/^rgba/i.test(corgb)) {
                    costr = corgb;
                } else {
                    costr = color.toHexString(); // #ff0000
                }
                vm.color = costr;
                vm.$emit('input', costr);
            },
            palette: [['rgb(0, 0, 0)', 'rgb(67, 67, 67)', 'rgb(102, 102, 102)', 'rgb(204, 204, 204)', 'rgb(217, 217, 217)', 'rgb(255, 255, 255)', _format ? 'rgb(45,140,240)' : 'rgba(0, 0, 0, 0)'], ['rgb(152, 0, 0)', 'rgb(255, 0, 0)', 'rgb(255, 153, 0)', 'rgb(255, 255, 0)', 'rgb(0, 255, 0)', 'rgb(0, 255, 255)', 'rgb(74, 134, 232)', 'rgb(0, 0, 255)', 'rgb(153, 0, 255)', 'rgb(255, 0, 255)'], ['rgb(230, 184, 175)', 'rgb(244, 204, 204)', 'rgb(252, 229, 205)', 'rgb(255, 242, 204)', 'rgb(217, 234, 211)', 'rgb(208, 224, 227)', 'rgb(201, 218, 248)', 'rgb(207, 226, 243)', 'rgb(217, 210, 233)', 'rgb(234, 209, 220)'], ['rgb(221, 126, 107)', 'rgb(234, 153, 153)', 'rgb(249, 203, 156)', 'rgb(255, 229, 153)', 'rgb(182, 215, 168)', 'rgb(162, 196, 201)', 'rgb(164, 194, 244)', 'rgb(159, 197, 232)', 'rgb(180, 167, 214)', 'rgb(213, 166, 189)'], ['rgb(204, 65, 37)', 'rgb(224, 102, 102)', 'rgb(246, 178, 107)', 'rgb(255, 217, 102)', 'rgb(147, 196, 125)', 'rgb(118, 165, 175)', 'rgb(109, 158, 235)', 'rgb(111, 168, 220)', 'rgb(142, 124, 195)', 'rgb(194, 123, 160)'], ['rgb(166, 28, 0)', 'rgb(204, 0, 0)', 'rgb(230, 145, 56)', 'rgb(241, 194, 50)', 'rgb(106, 168, 79)', 'rgb(69, 129, 142)', 'rgb(60, 120, 216)', 'rgb(61, 133, 198)', 'rgb(103, 78, 167)', 'rgb(166, 77, 121)'], ['rgb(91, 15, 0)', 'rgb(102, 0, 0)', 'rgb(120, 63, 4)', 'rgb(127, 96, 0)', 'rgb(39, 78, 19)', 'rgb(12, 52, 61)', 'rgb(28, 69, 135)', 'rgb(7, 55, 99)', 'rgb(32, 18, 77)', 'rgb(76, 17, 48)']],
            preferredFormat: "hex",
            showInput: true,
            hideAfterPaletteSelect: true,
            chooseText: '确定',
            cancelText: '取消',
            showInitial: false
        });
        var onfunc = function onfunc() {
            $(vm.$el).spectrum("hide");
        };
        __WEBPACK_IMPORTED_MODULE_0__common_events__["a" /* default */].$on('mod_activate', onfunc);
        vm.$data._activatefunc = onfunc;
    },
    beforeDestroy: function beforeDestroy() {
        $(this.$el).spectrum("destroy");
        if (this.$data._activatefunc) {
            __WEBPACK_IMPORTED_MODULE_0__common_events__["a" /* default */].$off('mod_activate', this.$data._activatefunc);
            this.$data._activatefunc = null;
        }
    },

    methods: {
        val_to_color: function val_to_color(value) {
            if (value == 'transparent') {
                return 'rgba(0, 0, 0, 0)';
            }
            return value;
        }
    },
    watch: {
        value: function value(newval) {
            this.color = newval;
            $(this.$el).spectrum("hide");
            $(this.$el).spectrum("set", newval);
        }
    },
    props: ['value', 'format']
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_events__ = __webpack_require__(5);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  replace: true,
  name: 'vue-draggable-resizable',
  props: {
    draggable: {
      type: Boolean, default: true
    },
    resizable: {
      type: Boolean, default: true
    },
    w: {
      type: Number,
      default: 200,
      validator: function validator(val) {
        return val > 0;
      }
    },
    h: {
      type: Number,
      default: 200,
      validator: function validator(val) {
        return val > 0;
      }
    },
    minw: {
      type: Number,
      default: 20,
      validator: function validator(val) {
        return val > 0;
      }
    },
    minh: {
      type: Number,
      default: 20,
      validator: function validator(val) {
        return val > 0;
      }
    },
    x: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val >= 0;
      }
    },
    y: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val >= 0;
      }
    },
    handles: {
      type: Array,
      default: function _default() {
        return ['tl', 'tm', 'tr', 'mr', 'br', 'bm', 'bl', 'ml'];
      }
    },
    axis: {
      type: String,
      default: 'both',
      validator: function validator(val) {
        return ['x', 'y', 'both'].indexOf(val) !== -1;
      }
    },
    grid: {
      type: Array,
      default: function _default() {
        return [1, 1];
      }
    },
    parent: {
      type: Boolean, default: false
    },
    maximize: {
      type: Boolean, default: false
    },
    id: {
      type: String, default: ''
    }
  },
  created: function created() {
    this.parentX = 0;
    this.parentW = 9999;
    this.parentY = 0;
    this.parentH = 9999;

    this.mouseX = 0;
    this.mouseY = 0;

    this.lastMouseX = 0;
    this.lastMouseY = 0;

    this.mouseOffX = 0;
    this.mouseOffY = 0;

    this.elmX = 0;
    this.elmY = 0;

    this.elmW = 0;
    this.elmH = 0;

    var that = this;
    __WEBPACK_IMPORTED_MODULE_0__common_events__["a" /* default */].$on("vdr_activated", function (id) {
      var isactive = false;
      var target = that.id,
          eft = 'hide';
      if (that.id == id) {
        isactive = true;
        target = id;eft = 'show';
      }
      that.active = isactive;
      $('> .handler', '#' + target)[eft]().removeClass("hover");
    });
  },
  mounted: function mounted() {
    document.documentElement.addEventListener('mousemove', this.handleMove, true);
    document.documentElement.addEventListener('mousedown', this.deselect, true);
    document.documentElement.addEventListener('mouseup', this.handleUp, true);

    if (this.minw > this.w) this.width = this.minw;

    if (this.minh > this.h) this.height = this.minh;

    if (this.parent) {
      var parentW = parseInt(this.$el.parentNode.clientWidth, 10);
      var parentH = parseInt(this.$el.parentNode.clientHeight, 10);

      this.parentW = parentW;
      // this.parentH = parentH

      if (this.w > this.parentW) this.width = parentW;

      if (this.h > this.parentH) this.height = parentH;

      if (this.x + this.w > this.parentW) this.width = parentW - this.x;

      if (this.y + this.h > this.parentH) this.height = parentH - this.y;
    }

    this.$emit('resizing', this.left, this.top, this.width, this.height);
  },
  beforeDestroy: function beforeDestroy() {
    document.documentElement.removeEventListener('mousemove', this.handleMove, true);
    document.documentElement.removeEventListener('mousedown', this.deselect, true);
    document.documentElement.removeEventListener('mouseup', this.handleUp, true);
  },
  data: function data() {
    return {
      top: this.y,
      left: this.x,
      width: this.w,
      height: this.h,
      resizing: false,
      dragging: false,
      active: false,
      opacity: 1,
      handle: null,
      zIndex: 1
    };
  },
  methods: {
    elmDown: function elmDown(e) {
      var target = e.target || e.srcElement;

      if (this.$el.contains(target)) {
        if (!this.active) {
          this.zIndex += 1;
          this.active = true;

          this.$emit('activated');
        }

        this.elmX = parseInt(this.$el.style.left);
        this.elmY = parseInt(this.$el.style.top);
        this.elmW = this.$el.offsetWidth || this.$el.clientWidth;
        this.elmH = this.$el.offsetHeight || this.$el.clientHeight;

        if (this.draggable) {
          this.opacity = 0.6;
          this.dragging = true;
        }
      }
      try {
        if (document.selection) {
          // Timeout neccessary for IE9
          setTimeout(function () {
            document.selection.empty();
          });
        } else {
          window.getSelection().removeAllRanges();
        }
      } catch (err) {}
    },
    deselect: function deselect(e) {
      var target = e.target || e.srcElement;
      var regex = new RegExp('handle-([trmbl]{2})', '');
      var filters = ['.propanel', '.page-linker', '.ivu-select-dropdown', '.file-manager', '.sp-container'];
      if (!this.$el.contains(target) && !$(target).closest(filters).length && !regex.test(target.className)) {
        if (this.active) {
          this.active = false;

          this.$emit('deactivated');
        }
      }
    },
    handleDown: function handleDown(handle, e) {
      this.handle = handle;

      if (e.stopPropagation) e.stopPropagation();
      if (e.preventDefault) e.preventDefault();

      this.elmX = parseInt(this.$el.style.left);
      this.elmY = parseInt(this.$el.style.top);
      this.elmW = this.$el.offsetWidth || this.$el.clientWidth;
      this.elmH = this.$el.offsetHeight || this.$el.clientHeight;

      this.resizing = true;
    },
    fillParent: function fillParent(e) {
      var _this = this;

      if (!this.parent || !this.resizable || !this.maximize) return;

      var done = false;

      var animate = function animate() {
        if (!done) {
          window.requestAnimationFrame(animate);
        }

        if (_this.axis === 'x') {
          if (_this.width === _this.parentW && _this.left === _this.parentX) done = true;
        } else if (_this.axis === 'y') {
          if (_this.height === _this.parentH && _this.top === _this.parentY) done = true;
        } else if (_this.axis === 'both') {
          if (_this.width === _this.parentW && _this.height === _this.parentH && _this.top === _this.parentY && _this.left === _this.parentX) done = true;
        }

        if (_this.axis === 'x' || _this.axis === 'both') {
          if (_this.width < _this.parentW) {
            _this.width++;
            _this.elmW++;
          }

          if (_this.left > _this.parentX) {
            _this.left--;
            _this.elmX--;
          }
        }

        if (_this.axis === 'y' || _this.axis === 'both') {
          if (_this.height < _this.parentH) {
            _this.height++;
            _this.elmH++;
          }

          if (_this.top > _this.parentY) {
            _this.top--;
            _this.elmY--;
          }
        }

        _this.$emit('resizing', _this.left, _this.top, _this.width, _this.height);
      };

      window.requestAnimationFrame(animate);
    },
    handleMove: function handleMove(e) {
      this.mouseX = e.pageX || e.clientX + document.documentElement.scrollLeft;
      this.mouseY = e.pageY || e.clientY + document.documentElement.scrollTop;

      var diffX = this.mouseX - this.lastMouseX + this.mouseOffX;
      var diffY = this.mouseY - this.lastMouseY + this.mouseOffY;

      this.mouseOffX = this.mouseOffY = 0;

      this.lastMouseX = this.mouseX;
      this.lastMouseY = this.mouseY;

      var dX = diffX;
      var dY = diffY;

      if (this.resizing) {
        if (this.handle.indexOf('t') >= 0) {
          if (this.elmH - dY < this.minh) this.mouseOffY = dY - (diffY = this.elmH - this.minh);else if (this.elmY + dY < this.parentY) this.mouseOffY = dY - (diffY = this.parentY - this.elmY);
          this.elmY += diffY;
          this.elmH -= diffY;
        }

        if (this.handle.indexOf('b') >= 0) {
          if (this.elmH + dY < this.minh) this.mouseOffY = dY - (diffY = this.minh - this.elmH);else if (this.elmY + this.elmH + dY > this.parentH) this.mouseOffY = dY - (diffY = this.parentH - this.elmY - this.elmH);
          this.elmH += diffY;
        }

        if (this.handle.indexOf('l') >= 0) {
          if (this.elmW - dX < this.minw) this.mouseOffX = dX - (diffX = this.elmW - this.minw);else if (this.elmX + dX < this.parentX) this.mouseOffX = dX - (diffX = this.parentX - this.elmX);
          this.elmX += diffX;
          this.elmW -= diffX;
        }

        if (this.handle.indexOf('r') >= 0) {
          if (this.elmW + dX < this.minw) this.mouseOffX = dX - (diffX = this.minw - this.elmW);else if (this.elmX + this.elmW + dX > this.parentW) this.mouseOffX = dX - (diffX = this.parentW - this.elmX - this.elmW);
          this.elmW += diffX;
        }

        this.left = Math.round(this.elmX / this.grid[0]) * this.grid[0];
        this.top = Math.round(this.elmY / this.grid[1]) * this.grid[1];

        this.width = Math.round(this.elmW / this.grid[0]) * this.grid[0];
        this.height = Math.round(this.elmH / this.grid[1]) * this.grid[1];

        this.$emit('resizing', this.left, this.top, this.width, this.height);
      } else if (this.dragging) {
        if (this.elmX + dX < this.parentX) this.mouseOffX = dX - (diffX = this.parentX - this.elmX);else if (this.elmX + this.elmW + dX > this.parentW) this.mouseOffX = dX - (diffX = this.parentW - this.elmX - this.elmW);

        if (this.elmY + dY < this.parentY) this.mouseOffY = dY - (diffY = this.parentY - this.elmY);else if (this.elmY + this.elmH + dY > this.parentH) this.mouseOffY = dY - (diffY = this.parentH - this.elmY - this.elmH);

        this.elmX += diffX;
        this.elmY += diffY;

        if (this.axis === 'x' || this.axis === 'both') {
          this.left = Math.round(this.elmX / this.grid[0]) * this.grid[0];
        }
        if (this.axis === 'y' || this.axis === 'both') {
          this.top = Math.round(this.elmY / this.grid[1]) * this.grid[1];
        }

        this.$emit('dragging', this.left, this.top);
      }
    },
    handleUp: function handleUp(e) {
      this.handle = null;
      if (this.resizing) {
        this.resizing = false;
        this.$emit('resizestop', this.left, this.top, this.width, this.height);
      }
      if (this.dragging) {
        this.dragging = false;
        this.$emit('dragstop', this.left, this.top);
      }
      this.opacity = 1;

      this.elmX = this.left;
      this.elmY = this.top;
    }
  },
  computed: {
    style: function style() {
      return {
        top: this.top + 'px',
        left: this.left + 'px',
        width: this.width + 'px',
        height: this.height + 'px',
        zIndex: this.zIndex,
        opacity: this.opacity
      };
    }
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_mods__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_events__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_vuedraggable_vuedraggable__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_module__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_module___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_module__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_property__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_setting__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_setting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_setting__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var propInfo = { "type": 'page' };
/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'weditor',
	data: function data() {
		return {
			propInfo: propInfo,
			btmtop: 0,
			active_mod: '',
			child_changed: false,
			show_setdialog: false,
			pageinfo: {},
			pagestyle: {},
			childzIndex: {},
			modules: [],
			popAttrs: {},
			ubehaviors: [],
			placeholder_height: 0
		};
	},
	created: function created() {
		var _this = this;

		// 'User-(un)behavior' Listener
		__WEBPACK_IMPORTED_MODULE_5__common_events__["a" /* default */].$on("user_unbehavior", function () {
			return _this.ubehaviors = [];
		});
		__WEBPACK_IMPORTED_MODULE_5__common_events__["a" /* default */].$on("user_behavior", function (v) {
			var tmparr = _this.ubehaviors;
			if ($.inArray(v, tmparr) < 0) _this.ubehaviors.push(v);
		});
		// 'Dragable' Listener
		__WEBPACK_IMPORTED_MODULE_5__common_events__["a" /* default */].$on("addplugin_bydrag", function (etype) {
			for (var _len = arguments.length, extra = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
				extra[_key - 1] = arguments[_key];
			}

			if (etype && extra.length && /function/i.test(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(_this[etype]))) _this[etype].apply(_this, extra);
		});
		// 'Place-holder show or not'
		__WEBPACK_IMPORTED_MODULE_5__common_events__["a" /* default */].$on("placeholder_reheight", function (h) {
			return _this.placeholder_height = h;
		});
		// for 'pagesave-listener'
		__WEBPACK_IMPORTED_MODULE_5__common_events__["a" /* default */].$on("pagesave", function () {
			var that = _this;
			new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				var enumArr = ['display', 'ishome'],
				    locsearch = __WEBPACK_IMPORTED_MODULE_3__global__["a" /* default */].parSearch(),
				    frmdata = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this.pageinfo);
				// Boolean -> String
				enumArr.forEach(function (v) {
					return frmdata[v] = frmdata[v] ? '1' : '0';
				});
				if ('home' == locsearch['hash'] || '') frmdata['ishome'] = '1';
				if ('shop' == locsearch['hash'] || '') frmdata['query_hash'] = 'wxshop';
				// filter frmdata
				enumArr.push('id', 'name', 'query_hash', 's_params');
				for (var idx in frmdata) {
					if ($.inArray(idx, enumArr) < 0) delete frmdata[idx];
				}

				__WEBPACK_IMPORTED_MODULE_3__global__["a" /* default */].xhrPost('page/create', { frmdata: frmdata }, function (res) {
					if ('OK' == (res || {}).result) {
						resolve(res.data.pageid);
						return false;
					}

					_this.$Notice.warning({
						title: '页面更新失败',
						desc: frmdata.name + ' - ' + res.data.errmsg
					});
				}, function (err) {
					return console.error(err);
				});
			}).then(function (pageid) {
				__WEBPACK_IMPORTED_MODULE_3__global__["a" /* default */].pageSave(that, pageid);
				__WEBPACK_IMPORTED_MODULE_5__common_events__["a" /* default */].$emit("user_unbehavior");
			});
		});

		this.$nextTick(function () {
			var that = _this,
			    boxer = that.$refs.editor,
			    headerh = __WEBPACK_IMPORTED_MODULE_3__global__["a" /* default */].HEADERH,
			    placeh = 30,
			    btmh = 60;
			$(window).on("resize", function (e) {
				var winheight = $(this).height(),
				    maxh = winheight - headerh;
				that.btmtop = maxh - placeh - btmh / 2;
				var scheight = that.ispreview ? winheight : maxh - placeh - btmh;
				if (that.ispreview) maxh = winheight;
				$(boxer).height(maxh).find('#scroll_container').height(scheight);
			}).trigger("resize");
		});

		this.$watch('modules', function (newval, oldval) {
			if (newval.length == 0) return false;
			__WEBPACK_IMPORTED_MODULE_5__common_events__["a" /* default */].$emit("user_behavior", 'edit_plugin');
		}, { deep: true });

		var isTextarea = function isTextarea(e) {
			var $target = $(e.target);
			return $target.is('textarea') || $target.is('input');
		};
		document.onkeydown = function (e) {
			e = e || window.event;
			if (e.ctrlKey && e.keyCode == 83) {
				__WEBPACK_IMPORTED_MODULE_5__common_events__["a" /* default */].$emit("pagesave");
				return false;
			}
			// for 'delete'
			var rmid = window.actived_layerid;
			if (/^layer[0-9A-Z]+$/i.test(rmid) && e.keyCode == 46) {
				if (isTextarea(e)) return true;
				__WEBPACK_IMPORTED_MODULE_5__common_events__["a" /* default */].$emit("mod_remove", rmid);
			}
		};
	},
	mounted: function mounted() {
		var _this2 = this;

		var curpage = __WEBPACK_IMPORTED_MODULE_3__global__["a" /* default */].getCurPage();
		this.modules = curpage.modinfo;
		// 'Page - style'
		this.pageinfo = curpage.pageinfo;
		this.pagestyle = $.extend({}, this.pageinfo.s_params || {});
		if ($.isPlainObject(this.pagestyle)) {
			var bgimgstr = this.pagestyle['background-image'] || 'none';
			if (bgimgstr != 'none') this.pagestyle['background-image'] = 'url(' + bgimgstr + ')';
		} else this.pagestyle = {};

		this.$watch('pageinfo.s_params', function (res) {
			if (!$.isPlainObject(res)) return false;
			var bgimg = res['background-image'] || 'none';
			if (bgimg != 'none') res = $.extend({}, res, { 'background-image': 'url(' + bgimg + ')' });
			_this2.pagestyle = res;
		});

		$('#scroll_container').on("scrolltoup scrolltodown", function (e) {
			var step = e.type == 'scrolltoup' ? -15 : 15,
			    barstate = _this2.$vuebar.getState(e.target),
			    scrollt = barstate.el2.scrollTop + step;

			barstate.el2.scrollTop = scrollt;
			_this2.$vuebar.refreshScrollbar(e.target);
		});

		document.body.ondrop = function (e) {
			e.preventDefault();
			e.stopPropagation();
		};

		__WEBPACK_IMPORTED_MODULE_5__common_events__["a" /* default */].$on("mod_activate", function (mod_id) {
			var modparams = _this2.modules.find(function (c) {
				return c.id == mod_id;
			});
			if (modparams == null) return false;
			_this2.propShow({ "status": 'Activated', "target": modparams });
			_this2.active_mod = mod_id;
		});

		__WEBPACK_IMPORTED_MODULE_5__common_events__["a" /* default */].$on("mod_deactivate", function () {
			_this2.active_mod = '';
			var target = event.target || event.srcElement;
			if (!$(target).closest('.cstlayer').length) _this2.propShow({ "status": 'Deactivated' });
			$('.cstlayer > .removit').hide();
		});

		// 'Setting' listener
		__WEBPACK_IMPORTED_MODULE_5__common_events__["a" /* default */].$on("show_setting", function () {
			return _this2.show_setdialog = true;
		});
		__WEBPACK_IMPORTED_MODULE_5__common_events__["a" /* default */].$on("hide_setting", function () {
			return _this2.show_setdialog = false;
		});

		// 'Plugin-remove' listener
		__WEBPACK_IMPORTED_MODULE_5__common_events__["a" /* default */].$on("mod_remove", function (id) {
			var that = _this2;
			that.$Modal.confirm({
				content: '确定要删除该元素吗？',
				onOk: function onOk() {
					var idx = that.modules.findIndex(function (c) {
						return c.id == id;
					});
					if (idx < 0) return false;

					var curobj = that.modules[idx];
					that.modules.splice(idx, 1);
					// for 'freelayout'
					if (!curobj.parent) {
						that.modules.find(function (c, i) {
							if (!c) return true;
							c.parent == id && that.modules.splice(i, 1);
							return false;
						});
					}
					if ($.isArray(curpage.rmids || '')) curpage.rmids.push(id);
					__WEBPACK_IMPORTED_MODULE_5__common_events__["a" /* default */].$emit("user_behavior", 'mod_remove');
				}
			});
		});

		// listener
		document.documentElement.addEventListener("mousedown", this.globalMouseDown, true);
		$(window).on("beforeunload", function (e) {
			if (!_this2.ispreview && _this2.ubehaviors.length) {
				return "系统含有未保存的操作，是否确认要离开或关闭该页面？";
			}
		});
		document.onselectstart = function () {
			return false;
		};
	},
	beforeDestroy: function beforeDestroy() {
		document.onselectstart = function () {
			return true;
		};
		document.documentElement.removeEventListener("mousedown", this.globalMouseDown, true);
	},

	computed: {
		edstyle: function edstyle() {
			var height = '',
			    margin = '';
			if (this.ispreview) {
				height = '100%';margin = '0px';
			}
			return { height: height, margin: margin };
		},
		scstyle: function scstyle() {
			var tmpobj = { width: '', 'border-left-width': '1px', 'border-right-width': '1px', 'margin-top': '' };
			if (this.ispreview) {
				tmpobj.width = '375px';
				tmpobj['border-left-width'] = '0px';
				tmpobj['border-right-width'] = '0px';
				tmpobj['margin-top'] = '0px';
			}
			return tmpobj;
		},

		tree_modules: {
			get: function get() {
				var moduleshash = {},
				    newmodules = [],
				    othermodules = [];
				for (var i = 0, ln = this.modules.length; i < ln; i++) {
					var orimodinf = this.modules[i],
					    wrapmodinf = { "id": orimodinf.id, "orimodinf": orimodinf, "children": [],
						"zindex": orimodinf.zindex, "active": this.active_mod == orimodinf.id ? true : false };
					moduleshash[orimodinf.id] = wrapmodinf;
					if ($.inArray(orimodinf.parent, ['', '0']) > -1) newmodules.push(wrapmodinf);else othermodules.push(wrapmodinf);
				}

				for (var _i = 0, _ln = othermodules.length; _i < _ln; _i++) {
					var otherwrapinf = othermodules[_i],
					    modparent = otherwrapinf.orimodinf.parent;
					if (moduleshash[modparent]) moduleshash[modparent].children.push(otherwrapinf);
					this.childzIndex[modparent] = (this.childzIndex[modparent] || '') + otherwrapinf.zindex + ',';
				}

				newmodules.sort(function (a, b) {
					var aidx = a.zindex || 0,
					    bidx = b.zindex || 0;
					return aidx - bidx;
				});

				return newmodules;
			},
			set: function set(newmodules) {
				var ln = newmodules.length;
				for (var i = 0; i < ln; i++) {
					newmodules[i].orimodinf.zindex = i;
				}
			}
		}
	},
	methods: {
		onEnd: function onEnd(e, dragEvt) {
			var modinfo = void 0,
			    childparam = {},
			    draginlayout = false,
			    type = e.item.getAttribute("data-role"),
			    $target = $(e.item);

			if ($target.closest('.cstlayer').length > 0) {
				var dragId = $target.closest('.cstlayer').prop('id');
				childparam = __WEBPACK_IMPORTED_MODULE_5__common_events__["a" /* default */].Emit(dragId, 'add_child', { item: e.item, e: e });
				draginlayout = true;
			}

			if (!draginlayout) {
				var minBigzindex = -1,
				    pos = $target.prevAll('.mod_wrapper').length;
				if (pos < this.tree_modules.length) {
					minBigzindex = this.tree_modules[pos].orimodinf.zindex;
				}
				modinfo = __WEBPACK_IMPORTED_MODULE_4__common_mods__["a" /* default */].get_default_plugin(type, { "zindex": minBigzindex });
			} else {
				modinfo = __WEBPACK_IMPORTED_MODULE_4__common_mods__["a" /* default */].get_default_plugin(type, childparam);
				// Set 'plug-in' position
				var offset = $('#' + childparam.parent).offset();
				if (!dragEvt) dragEvt = { "x": offset.left + 20, "y": offset.top + 10 };
				var modx = parseInt(Math.max(0, dragEvt.x - offset.left));
				modinfo.left = parseInt(Math.min(modx, 375 - modinfo.width));
				modinfo.top = parseInt(Math.max(0, dragEvt.y - offset.top));
			}

			var modid = modinfo.id,
			    modtype = modinfo.type,
			    modfields = __WEBPACK_IMPORTED_MODULE_4__common_mods__["a" /* default */].get_plugin_param(modtype);
			if (modfields && modfields._one_per_page) {
				var sametypemod = this.modules.find(function (v) {
					return v.type == modtype;
				});
				if (sametypemod) {
					var modshowname = modfields['_module_name'];
					this.$Notice.warning({
						title: '无法添加插件',
						desc: '\u4E00\u4E2A\u9875\u9762\u53EA\u80FD\u6709\u4E00\u4E2A' + modshowname + '\u63D2\u4EF6'
					});
					$target.remove();
					return false;
				}
			}

			if (modtype == 'webpage' && this.modules.length > 0) {
				var _modshowname = modfields['_module_name'];
				this.$Notice.warning({
					title: '无法添加插件',
					desc: '\u300CWeb\u9875\u9762\u300D\u63D2\u4EF6\u53EA\u80FD\u653E\u7F6E\u5728\u4E00\u4E2A\u7A7A\u767D\u9875\u9762'
				});
				$target.remove();
				return false;
			}

			var childzIndex = this.childzIndex;
			this.modules.push(modinfo);
			this.modules.forEach(function (element) {
				if (modinfo.id != element.id && modinfo.zindex <= element.zindex && modinfo.parent == element.parent) element.zindex += 1;

				var parentid = element.parent || '';
				if (modinfo.id == element.id && $.trim(parentid).length > 0 && !modinfo.type.startsWith('form_')) {
					var maxindex = Math.max.apply(null, (childzIndex[parentid] || '0').replace(/,$/, '').split(","));
					element.zindex = maxindex + 1;
					if (element.type == 'mtitle') element.height = 50;
					if (element.type == 'navigation') element.height = 40;
				}
			});

			$target.remove();__WEBPACK_IMPORTED_MODULE_5__common_events__["a" /* default */].$emit("end_add_module", e);
			__WEBPACK_IMPORTED_MODULE_5__common_events__["a" /* default */].$emit("user_behavior", 'add_' + modtype);
			this.$nextTick(function () {
				return setTimeout(function () {
					__WEBPACK_IMPORTED_MODULE_5__common_events__["a" /* default */].$emit('activate_mod_' + modid);
				}, 0);
			});
		},
		add: function add(e, type) {
			var modinfo = __WEBPACK_IMPORTED_MODULE_4__common_mods__["a" /* default */].get_default_plugin(type || e.target.getAttribute("data-role"));
			this.modules.push(modinfo);
			__WEBPACK_IMPORTED_MODULE_5__common_events__["a" /* default */].$emit("user_behavior", 'load_' + type);
		},
		propShow: function propShow(data) {
			if ('Activated' == data.status) this.propInfo = data.target || {};else this.propInfo = propInfo;
		},
		globalMouseDown: function globalMouseDown(e) {
			if (/firefox/i.test(navigator.userAgent)) window.event = e;
			var target = e.target || e.srcElement,
			    filters = ['.cstlayer', '.propanel', '.page-linker', '.ivu-select-dropdown', '.file-manager', '.sp-container'];
			if (!$(target).closest(filters).length) __WEBPACK_IMPORTED_MODULE_5__common_events__["a" /* default */].$emit("mod_deactivate");
			__WEBPACK_IMPORTED_MODULE_5__common_events__["a" /* default */].$emit("document_mousedown", e);
		}
	},
	props: ['id', 'height', 'ispreview'],
	components: { draggable: __WEBPACK_IMPORTED_MODULE_6__components_vuedraggable_vuedraggable__["a" /* default */], WpModule: __WEBPACK_IMPORTED_MODULE_7__components_module___default.a, Property: __WEBPACK_IMPORTED_MODULE_8__components_property___default.a, Setting: __WEBPACK_IMPORTED_MODULE_9__components_setting___default.a }
});

document.oncontextmenu = function () {
	return false;
};

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_events__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_dlgdrag__ = __webpack_require__(32);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var loadFilesByXhr = function loadFilesByXhr() {
	var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	var callback = arguments[1];

	if (!$.isPlainObject(options) || !$.isFunction(callback)) {
		console.error('Get files - failed1');
		return false;
	}

	__WEBPACK_IMPORTED_MODULE_1__global__["a" /* default */].xhrPost('file/lists', $.extend({}, options), function (res) {
		if (!$.isPlainObject(res) || $.isEmptyObject(res)) {
			console.error('Get files - failed2');
			return false;
		}
		callback.apply(null, [res]);
	}, function (err) {
		return console.error(err);
	});
},
    loadCategoryByXhr = function loadCategoryByXhr() {
	var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	var callback = arguments[1];

	if (!$.isPlainObject(options) || !$.isFunction(callback)) {
		console.error('Get categories - failed1');
		return false;
	}

	__WEBPACK_IMPORTED_MODULE_1__global__["a" /* default */].xhrPost('file/category', $.extend({}, options), function (res) {
		if (!$.isPlainObject(res) || $.isEmptyObject(res)) {
			console.error('Get categories - failed2');
			return false;
		}
		callback.apply(null, [res]);
	}, function (err) {
		return console.error(err);
	});
};

/* harmony default export */ __webpack_exports__["default"] = ({
	mixins: [__WEBPACK_IMPORTED_MODULE_3__common_dlgdrag__["a" /* default */]],
	data: function data() {
		return {
			selectedIdx: [],
			getFiles: [],
			showSuperCate: false,
			current_cname: ' ',
			current_fathercname: '',
			catename: '',
			renameid: -1,
			renameCtag: '-1',
			tabpanes: [{ "alias": "我的文件", "name": "wxall" }, { "alias": "图片", "name": "pic" }, { "alias": "音频", "name": "mp3" }],
			dig_title: "我的文件",
			items_total: 0,
			items: [],
			cur_category: '',
			categories: [],
			subCategoryClose: {},
			category_children: {},
			curr_page: 1,
			page_size: 15,
			keyword: '',
			tabtype: 'wxall',
			filemtype: '',
			filestype: {},
			file_accept: '',
			file_maxsize: 1024,
			file_allowext: '',
			file_err_str: '加载中...',
			category_err_str: '',
			sid: '',
			token: '',
			uploadUrl: __WEBPACK_IMPORTED_MODULE_1__global__["a" /* default */].remoteUrl('file/upload'),
			soundGif: __WEBPACK_IMPORTED_MODULE_1__global__["a" /* default */].remoteStaticUrl('image/sound.gif')
		};
	},
	created: function created() {
		var _this = this;

		var _ftype_ = '';
		this.filemtype = this.fmtype;
		if (this.filemtype == 'tabicon') {
			_ftype_ = this.filemtype;
			this.filemtype = 'pic';
		}
		// Set 'file-manager' type
		if ($.inArray(this.filemtype, ['pic', 'mp3']) < 0) this.filemtype = 'all';
		if (this.filemtype != 'all') {
			var _panes_ = [];
			this.tabtype = this.filemtype;
			this.tabpanes.forEach(function (c) {
				return c.name == _this.filemtype && _panes_.push(c);
			});
			this.tabpanes = _panes_;
		}

		this.sid = this.$cookie.get('PHPSESSID');
		this.token = $.ajaxSettings.data.token;
		// Get 'files' list
		loadFilesByXhr({ type: this.tabtype }, function (res) {
			if ('ERROR' == res.result || '') {
				_this.file_err_str = res.data.errmsg;
				return false;
			}

			_this.items = res.data || [];
			_this.items_total = parseInt(res.total || 0);
			_this.curr_page = res.page || 1;
			_this.page_size = res.pagesize || 15;
			if (!_this.items || !_this.items.length) _this.file_err_str = '尚未上传资源';
		});
		// Get 'files' type
		__WEBPACK_IMPORTED_MODULE_1__global__["a" /* default */].xhrPost('file/types', {}, function (res) {
			if (!$.isPlainObject(res) || $.isEmptyObject(res)) return false;

			_this.filestype = res;
			var extobj = res[_this.tabtype] || {};
			_this.file_accept = extobj.fileext || '';
			_this.file_allowext = extobj.allowext || '';
			// 单位KB
			if (_ftype_ == 'tabicon') _this.file_maxsize = 40;else _this.file_maxsize = (extobj.upload_size || 2) * 1024;
		}, function (err) {
			return console.error(err);
		});
		// Get 'categories' list
		loadCategoryByXhr({}, function (res) {
			if (res.result == 'ERROR') {
				_this.category_err_str = res.data.errmsg;
				return false;
			}
			_this.categories = res.catearr || [];
			_this.category_children = res.childcatearr || {};
		});
	},
	mounted: function mounted() {
		var _this2 = this;

		__WEBPACK_IMPORTED_MODULE_2__common_events__["a" /* default */].$on("document_mousedown", function (e) {
			var $target = $(e.target || e.srcElement);
			// Destroy 'rename'
			if (!$target.is('.inprename')) _this2.renameid = -1;
			if (!$target.closest('.catrename').length) _this2.renameCtag = '-1';
		});
	},

	computed: {
		categoryTree: function categoryTree() {
			var _this3 = this;

			var trees = [];
			this.categories.forEach(function (c) {
				trees.push(c);
				var subarr = _this3.category_children[c] || [];
				if (subarr.length > 0) trees.push.apply(trees, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(subarr));
			});
			return trees;
		}
	},
	directives: {
		adapt: {
			inserted: function inserted(el, binding) {
				$(el).css("visibility", 'hidden');
				$(el).on("load", function (event) {
					var img = event.target,
					    w = void 0,
					    h = void 0,
					    t = void 0,
					    W = 102,
					    H = 60,
					    cw = img.width,
					    ch = img.height;
					if (cw == 0 || ch == 0) {
						cw = W;ch = H;
					}
					if (cw > ch * W / H) {
						w = Math.min(W, cw);
						h = ch * w / cw;
						t = (H - h) / 2;
					} else {
						h = Math.min(H, ch);
						w = cw * h / ch;
						t = (H - h) / 2;
					}

					$(img).css({ width: w + 'px', height: h + 'px', top: t + 'px', visibility: '' }).fadeIn("slow", function () {
						$(this).siblings('.loading').remove();
					});
				});
			}
		}
	},
	methods: {
		parseTitle: function parseTitle(v) {
			if (v.length == 0) return '未分类';
			return v.replace(/^id_\d+_::/i, '');
		},
		branchOpen: function branchOpen(type, index) {
			var tmpobj = {};
			tmpobj[index] = type == 'minus' ? false : true;
			tmpobj = $.extend({}, this.subCategoryClose, tmpobj);
			this.$set(this, 'subCategoryClose', tmpobj);
		},
		dialogClose: function dialogClose() {
			this.unSelect();
			__WEBPACK_IMPORTED_MODULE_2__common_events__["a" /* default */].$emit("show_filemanager", false);
		},
		imgFocus: function imgFocus(index, src) {
			/* 设置焦点 */
			if (this.multiselect) {
				var _had_ = this.selectedIdx.findIndex(function (v) {
					return v == index;
				});
				if (_had_ > -1) {
					this.getFiles.splice(_had_, 1);
					this.selectedIdx.splice(_had_, 1);
				} else {
					this.getFiles.push(src);
					this.selectedIdx.push(index);
				}
			} else {
				this.getFiles = [src];
				this.selectedIdx = [index];
			}
		},
		selectAll: function selectAll() {
			var _this4 = this;

			/* 全选 */
			this.unSelect();
			this.items.forEach(function (c, i) {
				_this4.getFiles.push(c.fpath);
				_this4.selectedIdx.push(i);
			});
		},
		deleteBatch: function deleteBatch() {
			/* 批量删除 */
			var vm = this,
			    files = vm.getFiles;
			vm.$Modal.confirm({
				content: '该操作会影响引用此文件的页面显示，确定删除吗？',
				loading: true,
				onOk: function onOk() {
					var that = this,
					    fnamearr = [];
					// Filter
					if (!$.isArray(files) || !files.length) {
						that.$Notice.warning({
							title: '文件删除失败',
							desc: '非法请求'
						});
						return false;
					} else {
						files.forEach(function (c) {
							return fnamearr.push(c.substr(c.lastIndexOf("/") + 1));
						});
					}

					__WEBPACK_IMPORTED_MODULE_1__global__["a" /* default */].xhrPost('file/batch_delete', { fnamearr: fnamearr }, function (res) {
						if (!$.isPlainObject(res) || $.isEmptyObject(res)) return false;

						if (res.result == 'OK') {
							vm.unSelect();
							vm.fileSearch();
						} else {
							that.$Notice.warning({
								title: '文件删除失败',
								desc: fnamearr.join() + ' - ' + res.data.errmsg
							});
						}
						that.$Modal.remove();
					}, function (err) {
						return console.error(err);
					});
				}
			});
		},
		fileMoveTo: function fileMoveTo(val) {
			var _this5 = this;

			/* 移动至 */
			var filenames = [];
			this.getFiles.forEach(function (c) {
				return filenames.push(c.substr(c.lastIndexOf("/") + 1));
			});

			__WEBPACK_IMPORTED_MODULE_1__global__["a" /* default */].xhrPost('file/change_category', { filenames: filenames, catename: val }, function (res) {
				if (!$.isPlainObject(res) || $.isEmptyObject(res)) return false;

				if (res.result == 'OK') {
					_this5.unSelect();
					_this5.fileSearch();
				} else if (res.result == 'ERROR') {
					_this5.$Notice.warning({
						title: '文件移动失败',
						desc: res.data.errmsg == '-1' ? '分类不存在' : '非法文件名'
					});
				}

				_this5.$Modal.remove();
			}, function (err) {
				return console.error(err);
			});
		},
		unSelect: function unSelect() {
			/* 取消选择 */
			this.getFiles = [];
			this.selectedIdx = [];
		},
		picSelect: function picSelect() {
			/* 选择使用 */
			var _files = this.getFiles;
			if (!$.isArray(_files) || !_files.length) return false;
			__WEBPACK_IMPORTED_MODULE_2__common_events__["a" /* default */].$emit("select_picture", this.multiselect ? _files : _files[0]);
			this.unSelect();
		},
		addCategory: function addCategory() {
			var _this6 = this;

			/* 资源分类添加 */
			// Filter
			if ($.trim(this.catename).length == 0) {
				this.$Notice.warning({
					title: '分类添加失败',
					desc: this.catename + ' - 请输入分类名称'
				});
				return false;
			}

			__WEBPACK_IMPORTED_MODULE_1__global__["a" /* default */].xhrPost('file/add_category', { catename: this.catename }, function (res) {
				if (!$.isPlainObject(res) || $.isEmptyObject(res)) return false;

				if (res.result == 'OK') {
					_this6.catename = '';
					// Get 'categories' list
					loadCategoryByXhr({}, function (res) {
						_this6.categories = res.catearr || [];
					});
				} else {
					_this6.$Notice.warning({
						title: '分类添加失败',
						desc: _this6.catename + ' - ' + res.data.errmsg
					});
				}
			}, function (err) {
				return console.error(err);
			});
		},
		addSubCategory: function addSubCategory(fathercate, e) {
			var _this7 = this;

			/* 资源子分类添加 */
			var $input = $(e.target || e.srcElement).closest('.children').children('input');
			var catename = $input.val() || '';
			// Filter
			if ($.trim(catename).length == 0) {
				this.$Notice.warning({
					title: '子分类添加失败',
					desc: catename + ' - 请输入分类名称'
				});
				return false;
			}

			__WEBPACK_IMPORTED_MODULE_1__global__["a" /* default */].xhrPost('file/add_category', { fathercate: fathercate, catename: catename }, function (res) {
				if (!$.isPlainObject(res) || $.isEmptyObject(res)) return false;

				if (res.result == 'OK') {
					$input.val('');
					// Get 'categories' list
					loadCategoryByXhr({}, function (res) {
						_this7.category_children = res.childcatearr || {};
					});
				} else {
					_this7.$Notice.warning({
						title: '分类添加失败',
						desc: catename + ' - ' + res.data.errmsg
					});
				}
			}, function (err) {
				return console.error(err);
			});
		},
		showCateInput: function showCateInput(category, e) {
			var _this8 = this;

			this.renameCtag = category;
			// Set input-value
			var $parent = $(e.target).closest(['.father', '.children']);
			if (!$parent.length) return false;
			setTimeout(function () {
				$('input', $parent[0].elem).val(_this8.parseTitle(category));
			}, 0);
		},
		categoryEdit: function categoryEdit(catename, e) {
			var _this9 = this;

			/* 资源分类编辑 */
			var $parent = $(e.target).closest(['.father', '.children']);
			var ncatename = $('input', $parent[0].elem).val();
			// Filter
			var errmsg = '';
			if (!$.trim(ncatename).length) errmsg = '请输入分类名称';else {
				var regexp = new RegExp('::' + $.trim(ncatename) + '$');
				if (regexp.test(catename)) {
					this.renameCtag = -1;return false;
				}
			}

			if (errmsg.length > 0) {
				this.$Notice.warning({
					title: '分类编辑失败',
					desc: catename + ' - ' + errmsg
				});
				return false;
			}

			// Edit category
			__WEBPACK_IMPORTED_MODULE_1__global__["a" /* default */].xhrPost('file/rename_category', { catename: catename, ncatename: ncatename }, function (res) {
				if (!$.isPlainObject(res) || $.isEmptyObject(res)) return false;

				if (res.result == 'OK') {
					// Get 'categories' list
					loadCategoryByXhr({}, function (res) {
						_this9.categories = res.catearr || [];
						_this9.category_children = res.childcatearr || {};
					});
				} else {
					_this9.$Notice.warning({
						title: '分类重命名失败',
						desc: catename + ' - ' + res.data.errmsg
					});
				}
			}, function (err) {
				return console.error(err);
			});
		},
		categoryDelete: function categoryDelete(catename) {
			/* 资源分类删除 */
			var vm = this;
			vm.$Modal.confirm({
				content: '该操作会将该分类及其下级分类下所有的文件全部删除，是否继续？',
				loading: true,
				onOk: function onOk() {
					var that = this;
					// Filter
					if ($.trim(catename).length == 0) {
						that.$Notice.warning({
							title: '分类删除失败',
							desc: catename + ' - 非法请求'
						});
						return false;
					}

					__WEBPACK_IMPORTED_MODULE_1__global__["a" /* default */].xhrPost('file/del_category', { catename: catename }, function (res) {
						if (!$.isPlainObject(res) || $.isEmptyObject(res)) return false;

						if (res.result == 'OK') {
							loadCategoryByXhr({}, function (res) {
								vm.categories = res.catearr || [];
								vm.category_children = res.childcatearr || {};
							});
						} else {
							that.$Notice.warning({
								title: '分类删除失败',
								desc: catename + ' - ' + res.data.errmsg
							});
						}
						that.$Modal.remove();
					}, function (err) {
						return console.error(err);
					});
				}
			});
		},
		categoryTofather: function categoryTofather(catename) {
			var fathername = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
			/* 资源上级分类重置 */
			this.showSuperCate = true;
			this.current_cname = catename;
			this.current_fathercname = fathername;
		},
		superCategorySet: function superCategorySet() {
			var _this10 = this;

			var tag = this.current_cname,
			    parentcate = this.current_fathercname;
			if (parentcate == 'top') parentcate = '';

			__WEBPACK_IMPORTED_MODULE_1__global__["a" /* default */].xhrPost('file/change_parent_category', { tag: tag, parentcate: parentcate }, function (res) {
				if (!$.isPlainObject(res) || $.isEmptyObject(res)) return false;

				if (res.result == 'OK') {
					loadCategoryByXhr({}, function (res) {
						_this10.categories = res.catearr || [];
						_this10.category_children = res.childcatearr || {};
					});
				} else {
					_this10.$Notice.warning({
						title: '上级分类设置失败',
						desc: tag + ' - ' + res.data.errmsg
					});
				}
			}, function (err) {
				return console.error(err);
			});
		},
		pageSwitch: function pageSwitch(page) {
			var _this11 = this;

			/* 页码切换 */
			var tag = this.cur_category,
			    type = this.tabtype;
			loadFilesByXhr({ type: type, page: page, tag: tag }, function (res) {
				if (res.result == 'ERROR') {
					_this11.file_err_str = res.data.errmsg;
					return false;
				}

				_this11.curr_page = page;
				_this11.items = res.data || [];
				if (!_this11.items || !_this11.items.length) _this11.file_err_str = '尚未上传资源';
			});
		},
		tabSwitch: function tabSwitch(type) {
			var _this12 = this;

			/* 标签切换 */
			this.keyword = '';
			this.cur_category = '';
			this.tabtype = type;
			loadFilesByXhr({ type: type }, function (res) {
				if (res.result == 'ERROR') {
					_this12.file_err_str = res.data.errmsg;
					return false;
				}

				_this12.items = res.data || [];
				_this12.items_total = parseInt(res.total || 0);
				_this12.curr_page = res.page || 1;
				_this12.page_size = res.pagesize || 15;
				if (!_this12.items || !_this12.items.length) _this12.file_err_str = '尚未上传资源';
			});
			// Reset 'upload' configuration
			var extobj = this.filestype[type] || {};
			this.file_accept = extobj.fileext || '';
			this.file_allowext = extobj.allowext || '';
			this.file_maxsize = (extobj.upload_size || 2) * 1024 * 1024;
		},
		fileDelete: function fileDelete(fname) {
			/* 资源删除 */
			var vm = this;
			vm.$Modal.confirm({
				content: '该操作会影响引用此文件的页面显示，确定删除吗？',
				loading: true,
				onOk: function onOk() {
					var that = this;
					// Filter
					if ($.trim(fname).length == 0) {
						that.$Notice.warning({
							title: '文件删除失败',
							desc: fname + ' - 非法请求'
						});
						return false;
					}

					__WEBPACK_IMPORTED_MODULE_1__global__["a" /* default */].xhrPost('file/delete', { fname: fname }, function (res) {
						if (!$.isPlainObject(res) || $.isEmptyObject(res)) return false;

						if (res.result == 'OK') vm.fileSearch();else {
							that.$Notice.warning({
								title: '文件删除失败',
								desc: fname + ' - ' + res.data.errmsg
							});
						}

						that.$Modal.remove();
					}, function (err) {
						return console.error(err);
					});
				}
			});
		},
		fileRename: function fileRename(index, e) {
			var _this13 = this;

			/* 资源重命名 */
			this.renameid = -1;
			var curobj = this.items[index],
			    fname = curobj.fname,
			    nfname = curobj.fbasename,
			    suffix = fname.replace(/^[^\.]+\./i, '.');
			nfname += suffix;
			// Filter
			var errmsg = '';
			if ($.trim(nfname).length == 0) errmsg = '请输入文件名称';else if (fname == $.trim(nfname)) errmsg = '请输入新的文件名称';

			if (errmsg.length > 0) {
				this.$Notice.warning({
					title: '文件重命名失败',
					desc: fname + ' - ' + errmsg
				});
				return false;
			}

			this.$set(this.items[index], 'fname', nfname);
			__WEBPACK_IMPORTED_MODULE_1__global__["a" /* default */].xhrPost('file/rename', { fname: fname, nfname: nfname }, function (res) {
				if (!$.isPlainObject(res) || $.isEmptyObject(res)) return false;

				if (res.result == 'ERROR') {
					_this13.$Notice.warning({
						title: '文件重命名失败',
						desc: fname + ' - ' + res.data.errmsg
					});
					_this13.$set(_this13.items[index], 'fname', fname);
					_this13.$set(_this13.items[index], 'fbasename', fname.replace(suffix, ''));
				}
			}, function (err) {
				return console.error(err);
			});
		},
		fileSearch: function fileSearch() {
			var _this14 = this;

			/* 关键词检索 */
			loadFilesByXhr({
				type: this.tabtype,
				keyword: this.keyword,
				tag: this.cur_category
			}, function (res) {
				if (res.result == 'ERROR') {
					_this14.file_err_str = res.data.errmsg;
					return false;
				}

				_this14.items = res.data || [];
				_this14.items_total = parseInt(res.total || 0);
				_this14.curr_page = res.page || 1;
				_this14.page_size = res.pagesize || 15;
				if (!_this14.items || !_this14.items.length) _this14.file_err_str = '尚未上传资源';
			});
		},
		categorySearch: function categorySearch(tag) {
			var _this15 = this;

			/* 分类检索 */
			this.keyword = '';
			this.cur_category = tag;
			loadFilesByXhr({ tag: tag, type: this.tabtype }, function (res) {
				if (res.result == 'ERROR') {
					_this15.file_err_str = res.data.errmsg;
					return false;
				}

				_this15.items = res.data || [];
				_this15.items_total = parseInt(res.total || 0);
				_this15.curr_page = res.page || 1;
				_this15.page_size = res.pagesize || 15;
				if (!_this15.items || !_this15.items.length) _this15.file_err_str = '尚未上传资源';
			});
		},
		uploadSuccess: function uploadSuccess(res, file) {
			/* 资源上传(2) */
			if (res.result == 'OK') {
				this.$Notice.success({
					title: '文件上传成功',
					desc: file.name + ' 文件上传成功'
				});
				// Update 'file-manager'
				this.categorySearch(this.cur_category);
			} else {
				this.$Notice.warning({
					title: '文件上传失败',
					desc: file.name + ' - ' + res.data.errmsg
				});
			}
		},
		maxSizeTips: function maxSizeTips(file) {
			/* 资源上传(4) */
			var ftypobj = this.filestype[this.tabtype];
			this.$Notice.warning({
				title: '超出文件大小限制',
				desc: '文件 ' + file.name + ' 太大，不能超过 ' + ftypobj.upload_size + 'M'
			});
		}
	},
	props: ['fmtype', 'multiselect', 'con_height', 'con_main_left_height']
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_mods__ = __webpack_require__(24);
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return { cmpname: 'loading' };
	},
	created: function created() {
		var _this = this;

		var timer = setInterval(function () {
			var modname = _this.attrs.type,
			    modcmp = __WEBPACK_IMPORTED_MODULE_0__common_mods__["a" /* default */].get_plugin_property(modname);
			if (!modcmp) return true;

			clearInterval(timer);
			_this.cmpname = 'property_' + modname;
			_this.$options.components[_this.cmpname] = modcmp;
		}, 500);
	},

	components: {
		loading: {
			template: '<div style="color: #999;line-height: 2;text-align: center;">加载中...</div>'
		}
	},
	props: ['options', 'attrs']
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dragresizable__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dragresizable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_dragresizable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_events__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_mods__ = __webpack_require__(24);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'module',
	data: function data() {
		return {
			module_params: this.mod_param,
			type: this.mod_param.type,
			isActive: false,
			layoutResizing: false,
			layoutHandle: null,
			heightResizable: false,
			ispreview: false
		};
	},

	filters: {
		calcheight: function calcheight(val, layerid) {
			if (layerid.length && val == 'auto') val = $('#' + layerid).height() || 100;

			return val;
		}
	},
	computed: {
		id: function id() {
			return this.module_params.id;
		},
		pos: function pos() {
			return { "left": this.module_params.left, "top": this.module_params.top, "zindex": this.module_params.zindex };
		},
		size: function size() {
			var height = this.module_params.height;
			if (this.isContainer) height = 'auto';
			return { "width": this.module_params.width, height: height };
		},
		is_relative: function is_relative() {
			return this.position == 'relative';
		},
		iswrapper: function iswrapper() {
			return this.is_relative && !/^form_/i.test(this.type) ? true : false;
		},
		isContainer: function isContainer() {
			var filters = ['freelayout', 'forms'];
			return $.inArray(this.type, filters) > -1 ? true : false;
		}
	},
	created: function created() {
		var _this = this;

		var modname = this.type;
		this.ispreview = __WEBPACK_IMPORTED_MODULE_0__global__["a" /* default */].isPreview();
		this.$options.components['wp_' + modname] = function (resolve) {
			__webpack_require__.e/* require.ensure */(0).then((function (require) {
				var reqc = __webpack_require__(202);

				try {
					var loaded = reqc('./' + modname + '/' + modname + '.vue');
					if (loaded) resolve(loaded);else throw 'not found';
				} catch (err) {
					console.error(modname + ' not found');
				}
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		};

		__WEBPACK_IMPORTED_MODULE_2__common_events__["a" /* default */].$on('activate_mod_' + this.id, function () {
			if (modname.startsWith('form_')) return false;
			_this.onActivated.apply(_this);
			__WEBPACK_IMPORTED_MODULE_2__common_events__["a" /* default */].$emit("vdr_activated", _this.id);
		});

		this.minh = 50;
		this.mouseY = 0;
		this.mouseOffY = 0;
		this.lastMouseY = 0;
	},
	mounted: function mounted() {
		var vm = this;
		// for 'preview'
		if (vm.ispreview) return false;
		// for 'layout'
		if (this.is_relative) {
			window['formel_parentid'] = '';
			$(vm.$el).on('mouseenter', function (e) {
				// for '表单子组件'
				var _this_ = e.currentTarget,
				    layerid = $(_this_).attr("id"),
				    targetid = $(e.target).closest('.cstlayer').attr("id");
				if ($(_this_).hasClass('mod_wrapper')) formel_parentid = layerid;
				if (layerid != targetid) return false;
				if (formel_parentid && targetid != formel_parentid) $('#' + formel_parentid).trigger('mouseleave', ['foo']);

				$('> .myhandler, > .removit', _this_).show();
				if (!vm.is_active) $('> .handler-top, > .handler-btm', _this_).addClass("hover").show();
				// Show 'layer-name'
				vm.showLayerName(_this_);
			}).on('mouseleave', function (e, type) {
				// for '表单子组件'
				var _this_ = e.currentTarget,
				    $handler = $('> .handler-top, > .handler-btm', _this_);
				if (!type && $(_this_).attr("id") == formel_parentid) formel_parentid = '';else formel_parentid && $('#' + formel_parentid).trigger('mouseenter');

				$('> .myhandler, > .removit', _this_).hide();
				$handler.removeClass("hover");
				!vm.is_active && $handler.hide();
			});
		}
		// for 'cstlayer'
		else {
				$(vm.$el).on('mouseenter', function (e) {
					e.stopPropagation();
					var $removit = $('> .removit', this),
					    $handler = $('> .handler', this);
					if ($(this).width() >= 60) $removit.css({ 'border-right': 'none', 'border-top': 'none', 'top': '1px' });else $removit.css({ 'border-right': '1px solid #2d8cf0', 'border-top': '1px solid #2d8cf0', 'top': '-19px' });

					$('> .removit', this).add($handler).show();
					!$(this).hasClass("active") && $handler.addClass("hover");
					$(this).closest('.mod_wrapper').trigger("mouseleave");
					// Show 'layer-name'
					vm.showLayerName(this);
				}).on('mouseleave', function (e) {
					$('> .removit', this).hide();
					var $handler = $('> .handler', this);
					$handler.removeClass("hover");
					!$(this).hasClass("active") && $handler.hide();
					$(this).closest('.mod_wrapper').trigger("mouseenter");
				});
			}

		document.documentElement.addEventListener('mousemove', this.dragMove, true);
		document.documentElement.addEventListener('mouseup', this.dragUp, true);
	},
	beforeDestroy: function beforeDestroy() {
		document.documentElement.removeEventListener('mousemove', this.dragMove, true);
		document.documentElement.removeEventListener('mouseup', this.dragUp, true);
		__WEBPACK_IMPORTED_MODULE_2__common_events__["a" /* default */].$off('activate_mod_' + this.id);
	},

	methods: {
		layerTap: function layerTap(attr) {
			var clickobj = attr.modclick || {};
			if (!$.isEmptyObject(clickobj) && 'page' == clickobj.type || 'none') {
				var pgval = (clickobj.param || {}).value || '';
				if (typeof pgval == 'number') {
					location.search = __WEBPACK_IMPORTED_MODULE_0__global__["a" /* default */].resetSearch({ 'editor': pgval });
				} else if (/^[a-z_]+$/i.test(pgval)) {
					console.log(pgval, '后期开发...');
					//EventBus.$emit('marketing_redirect', pgval)
				}
			}
		},
		showLayerName: function showLayerName(target) {
			var $target = $(target),
			    modparam = __WEBPACK_IMPORTED_MODULE_3__common_mods__["a" /* default */].get_plugin_param($target.attr("type")),
			    layername = modparam['_module_name'] || '';
			if (layername.length == 0) return false;
			if (parseFloat($('.wp_content', target).css('width')) < 50) return false;

			$('> .handler > #layertip', target).remove();
			var ndstr = Math.min($target.offset().top, $target.position().top) >= 22 ? 'top' : 'btm';
			$('<span id="layertip">' + layername + '</span>').appendTo($('> .handler-' + ndstr + '.hover', target));
		},
		modStyle: function modStyle() {
			var bgobj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

			var tmpobj = $.extend(true, {}, bgobj),
			    bgimg = tmpobj['background-image'] || 'none';
			if (bgimg != 'none') tmpobj = $.extend({}, tmpobj, { 'background-image': 'url(' + bgimg + ')' });
			// Add 'px'
			for (var v in tmpobj) {
				var pval = tmpobj[v];
				if (typeof pval == 'number') tmpobj[v] = pval + 'px';
			}
			// for 'preview'
			if (!this.is_relative && this.ispreview) tmpobj['position'] = 'absolute';

			return tmpobj;
		},
		onResize: function onResize(x, y, w, h) {
			this.module_params.left = parseInt(x);
			this.module_params.top = parseInt(y);
			this.module_params.width = parseInt(w);
			this.module_params.height = parseInt(h);
		},
		onDrag: function onDrag(x, y) {
			this.module_params.left = parseInt(x);
			this.module_params.top = parseInt(y);
		},
		onActivated: function onActivated() {
			// for 'preview'
			if (this.ispreview) {
				__WEBPACK_IMPORTED_MODULE_0__global__["a" /* default */].pagelink(this.module_params.childprop.modclick);
				return false;
			}
			this.isActive = true;
			__WEBPACK_IMPORTED_MODULE_2__common_events__["a" /* default */].$emit('mod_activate', this.id);
			// show 'border'
			$('> .handler', '#' + this.id).removeClass("hover").show().children('#layertip').remove();

			// for 'resize-height'
			var modfields = __WEBPACK_IMPORTED_MODULE_3__common_mods__["a" /* default */].get_plugin_param(this.type);
			this.heightResizable = modfields._height_resizable || false;

			// Move the module through the arrow keys
			var vm = this,
			    maxwidth = 375;
			if (vm.is_relative) return false;
			$(document).on('keydown.vdrmove', function (e) {
				var kycode = e.keyCode;
				switch (kycode) {
					case 37: // '←'
					case 39:
						// '→'
						var newleft = 0,
						    _left_ = vm.pos.left;
						if (kycode == 37) newleft = Math.max(0, _left_ - 1);else newleft = Math.min(maxwidth - vm.size.width, _left_ + 1);
						vm.module_params.left = newleft;
						break;
					case 38: // '↑'
					case 40:
						// '↓'
						e.preventDefault();
						var newtop = 0,
						    _top_ = vm.pos.top;
						if (kycode == 40) newtop = _top_ + 1;else newtop = Math.max(0, _top_ - 1);
						vm.module_params.top = newtop;
						break;
				}
			});
		},
		onDeactivated: function onDeactivated() {
			this.isActive = false;
			__WEBPACK_IMPORTED_MODULE_2__common_events__["a" /* default */].$emit('mod_deactivate', this.id);
			// show 'border'
			$('> .handler', '#' + this.id).hide();
			// Move the module through the arrow keys
			$(document).off('.vdrmove');
			__WEBPACK_IMPORTED_MODULE_2__common_events__["a" /* default */].$emit("user_behavior", 'edit_plugin');
		},
		rmPlugin: function rmPlugin() {
			__WEBPACK_IMPORTED_MODULE_2__common_events__["a" /* default */].$emit('mod_remove', this.id);
		},
		layoutResize: function layoutResize(handle, e) {
			this.layoutHandle = handle;
			if (e.stopPropagation) e.stopPropagation();
			if (e.preventDefault) e.preventDefault();

			this.layoutResizing = true;
		},
		dragMove: function dragMove(e) {
			this.mouseY = e.pageY || e.clientY + document.documentElement.scrollTop;
			var diffY = this.mouseY - this.lastMouseY + this.mouseOffY;
			this.mouseOffY = 0;
			this.lastMouseY = this.mouseY;

			var dY = diffY;
			if (!this.layoutResizing) return false;
			var elmH = this.module_params.childprop.height;
			if (this.layoutHandle.indexOf('b') >= 0) {
				if (elmH + dY < this.minh) this.mouseOffY = dY - (diffY = this.minh - elmH);
				this.module_params.childprop.height += diffY;
			}
		},
		dragUp: function dragUp(e) {
			this.layoutHandle = null;
			this.layoutResizing = false;
		}
	},
	props: ['mod_param', 'position', 'is_active', 'children', 'islast'],
	components: { DragResizable: __WEBPACK_IMPORTED_MODULE_1__components_dragresizable___default.a }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_events__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var lnkobj_default = { type: 'none', param: { type: '', value: '', pagevalue: '', idsvalue: '', title: '' } };
/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			pages: [],
			lnkobj: {},
			placement: 'top'
		};
	},
	created: function created() {
		var _this = this;

		var curpage = __WEBPACK_IMPORTED_MODULE_0__global__["a" /* default */].getCurPage();
		this.pages = curpage.pages;
		if (!$.isPlainObject(this.attrs || {}) || $.isEmptyObject(this.attrs || {})) return false;

		this.$watch('attrs.id', function () {
			_this.lnkobj = $.extend(true, {}, lnkobj_default, _this.value || {});
			_this._data.placement = _this._props.attrs.type == 'buttons' ? 'bottom' : 'top';
		}, { deep: true, immediate: true });

		this.$watch('lnkobj', function (res) {
			return _this.$emit("input", res);
		}, { deep: true });
	},
	mounted: function mounted() {
		!this.inner && $(this.$el).appendTo('body');
	},

	methods: {
		etabSwitch: function etabSwitch(etype) {
			this.lnkobj.type = etype;
			var tmpobj = $.extend(true, {}, lnkobj_default);
			this.lnkobj.param = tmpobj.param;
		},
		linkerSet: function linkerSet() {
			__WEBPACK_IMPORTED_MODULE_1__common_events__["a" /* default */].$emit("set_linker", this.lnkobj);
			this.popupClose();
		},
		popupClose: function popupClose() {
			__WEBPACK_IMPORTED_MODULE_1__common_events__["a" /* default */].$off("set_linker");
			__WEBPACK_IMPORTED_MODULE_1__common_events__["a" /* default */].$emit("pagelinker_close");
		}
	},
	props: ['value', 'inner', 'attrs']
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var enumArr = ['display', 'ishome'];
/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'page_settings',
	computed: {
		frmdata: function frmdata() {
			var _pageinfo = this.pageinfo;
			enumArr.forEach(function (v, k) {
				_pageinfo[v] = _pageinfo[v] == '1' ? true : false;
			});
			return _pageinfo;
		}
	},
	props: ['pageinfo']
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_mods__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_events__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_colorpicker__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_colorpicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_colorpicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modproperty__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modproperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_modproperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pagelinker__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pagelinker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_pagelinker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pageset__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pageset___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_pageset__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_prevbg_gif__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_prevbg_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_prevbg_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__wxplugins_product_list_product_selector__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__wxplugins_product_list_product_selector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__wxplugins_product_list_product_selector__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('font-weight', {
	template: '<i @click="setVal" :class="[\'fontIcon\',\'icon-jiacu\',{on: value==\'bold\'}]" title="粗体"></i>',
	props: { value: String },
	methods: {
		setVal: function setVal() {
			this.$emit('input', this.value == 'normal' ? 'bold' : 'normal');
		}
	}
});
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('text-decoration', {
	template: '<i @click="setVal" :class="[\'fontIcon\',icnClastr,{on: isActived}]" :title="icnTitle"></i>',
	props: { value: String, accept: String },
	computed: {
		icnClastr: function icnClastr() {
			return 'icon-' + (this.accept ? 'fontstrikethrough' : 'xiahuaxian');
		},
		isActived: function isActived() {
			return this.value == (this.accept || 'underline') ? true : false;
		},
		icnTitle: function icnTitle() {
			return this.accept ? '中划线' : '下划线';
		}
	},
	methods: {
		setVal: function setVal() {
			this.$emit('input', this.value == 'none' ? this.accept || 'underline' : 'none');
		}
	}
});
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('font-style', {
	template: '<i @click="setVal" :class="[\'fontIcon\',\'icon-xieti\',{on: value==\'italic\'}]" title="斜体"></i>',
	props: { value: String },
	methods: {
		setVal: function setVal() {
			this.$emit('input', this.value == 'normal' ? 'italic' : 'normal');
		}
	}
});
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('inline-linker', {
	template: '<Select :value="value" :size="size" :placement="placement" :placeholder="placeholder" :filterable="filterable" @on-change="setVal">\
		<Option value="">请选择</Option>\
		<!--Option value="ucenter">我的</Option-->\
		<Option v-for="d in data" :value="d.id" :key="d.id">{{d.name||`未命名(${d.id})`}}</Option>\
		</Select>',
	computed: {
		isLevel4: function isLevel4() {
			var gparams = WPCommon.getGlobalParams();
			return gparams.wxapp_level == '4' ? true : false;
		}
	},
	props: {
		value: [String, Number], data: [Array, Object], size: String,
		filterable: { type: Boolean, default: false },
		placement: { type: String, default: 'bottom' },
		placeholder: { type: String, default: '请选择' }
	},
	methods: {
		setVal: function setVal(newval) {
			this.$emit('input', newval);
		}
	}
});

var maxw = 375,
    aspectFit = function aspectFit(maxh, imgw, imgh) {
	var maxw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 375;

	var new_imgw = 0,
	    new_imgh = 0;
	// 保持纵横比缩放图片，使图片的长边能完全显示出来
	// 即可以完整地将图片显示出来 - aspectFit
	if (imgw >= imgh) {
		new_imgw = maxw;
		new_imgh = maxw * imgh / imgw;
		if (new_imgh > maxh) {
			new_imgh = maxh;
			new_imgw = maxh * imgw / imgh;
		}
	} else {
		new_imgh = maxh;
		new_imgw = maxh * imgw / imgh;
		if (new_imgw > maxw) {
			new_imgw = maxw;
			new_imgh = maxw * imgh / imgw;
		}
	}
	var m_top = maxh > new_imgh ? Math.round((maxh - new_imgh) / 2) : 0;
	var m_left = maxw > new_imgw ? Math.round((maxw - new_imgw) / 2) : 0;
	return { "width": new_imgw, "height": new_imgh, "mtop": m_top, "mleft": m_left };
};
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].directive('aspectfit', {
	inserted: function inserted(el) {
		var maxh = parseInt($(el).parent().css('height'));
		$(el).css("visibility", 'hidden').on("load", function (e) {
			var img = new Image();
			img.src = $(el)[0].currentSrc;
			var imgWidth = img.width,
			    imgHeight = img.height;
			maxw = $(this).parent().width();
			var size = aspectFit(maxh, imgWidth, imgHeight, maxw),
			    plugin = $(this).closest('.cstlayer').attr('type');
			if (plugin != 'product_list') size.mleft = 0;
			$(this).css({ "display": 'inline', "visibility": '', "margin-top": size.mtop + 'px',
				"margin-left": size.mleft + 'px', "width": size.width + 'px', "height": size.height + 'px' });
		});
	},
	update: function update(el) {
		var plugin = $(el).closest('.cstlayer').attr('type');
		if (plugin == 'product_list') return false;
		var maxh = parseInt($(el).parent().css('height'));
		$(el).width('auto').height('auto');

		var size = aspectFit(maxh, $(el).width(), $(el).height());
		$(el).css({ "width": size.width + 'px', "height": size.height + 'px', "margin-top": size.mtop + 'px' });
	}
});

var initProperty = function initProperty() {
	var isinit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

	var _type = this.attrs.type,
	    curpage = __WEBPACK_IMPORTED_MODULE_3__global__["a" /* default */].getCurPage();

	this.nostyle = false;
	if (_type.toLowerCase() == 'page') {
		//this.panelId = 'bg';
		this.ispage = true;
		!isinit && (this.options = curpage.pageinfo || {});
	} else {
		//this.panelId = '';
		this.ispage = false;
		!isinit && (this.pages = curpage.pages);
		this.options = __WEBPACK_IMPORTED_MODULE_4__common_mods__["a" /* default */].get_plugin_options(_type);
	}

	// Set 'background/border-style'
	var bgopt = {
		'background-image': 'none',
		'background-color': 'transparent',
		'background-repeat': 'repeat',
		'background-position': 'top left'
	},
	    oldval = this.options['s_params'];
	if (!this.ispage) {
		oldval = this.attrs.childprop.globalstyle || this.attrs.globalstyle;
		bgopt = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(bgopt, { 'border-color': 'transparent',
			'border-style': 'none', 'border-width': 0, 'border-radius': 0 });
	}
	if (!$.isPlainObject(oldval)) oldval = {};
	this.glbstyle = $.extend(true, {}, bgopt, oldval);
	// for 'styles - component'
	var modstyles = __WEBPACK_IMPORTED_MODULE_4__common_mods__["a" /* default */].get_plugin_styles(_type);
	if (!modstyles) {
		this.compStyle = '';return false;
	}
	this.compStyle = 'styles_' + _type;
	this.$options.components[this.compStyle] = modstyles;
};

var initDetailLink = function initDetailLink() {
	var modclicks = this.attrs.childprop.modclick;
	if (!modclicks) {
		this.$set(this.attrs.childprop, 'modclick', {
			"type": 'none', "param": { "type": '', "value": '' }
		});
	}

	this.initDetail = true;
	if (this.attrs.type == 'buttons') {
		this.pagePlacement = 'bottom';
	} else this.pagePlacement = 'top';

	// for '链接至商品列表/详情'
	this.linkToProductPage(modclicks.param.type);
};

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Property',
	data: function data() {
		return {
			ispage: false,
			isInner: true,
			pages: [],
			options: {},
			glbstyle: {},
			borderstyle: [{ value: 'none', label: '无' }, { value: 'solid', label: '实线' }, { value: 'dotted', label: '点线' }, { value: 'dashed', label: '虚线' }],
			bgpos: ['top left', 'top center', 'top right', 'center left', 'center center', 'center right', 'bottom left', 'bottom center', 'bottom right'],
			compStyle: '',
			panelId: 'bg',
			detail_pages: [],
			showDetailId: false,
			detailType: '',
			isradio: true,
			dialogShow: false,
			initDetail: false,
			pagePlacement: 'top'
		};
	},

	props: ['attrs', 'height'],
	created: function created() {
		var _this = this;

		initProperty.apply(this, [true]);
		var curpage = __WEBPACK_IMPORTED_MODULE_3__global__["a" /* default */].getCurPage();
		if (this.attrs.type.toLowerCase() == 'page') {
			this.options = curpage.pageinfo || {};
			this.glbstyle = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.glbstyle, this.options['s_params']);
		} else this.pages = curpage.pages;

		this.$watch('glbstyle', function (res) {
			if (_this.ispage) {
				var oldval = {};
				if (_this.options['s_params']) oldval = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this.options['s_params']));
				var newval = $.extend(true, {}, oldval, res);
				_this.$set(_this.options, 's_params', newval);
			} else {
				var layerid = _this.attrs.id,
				    _curpage = __WEBPACK_IMPORTED_MODULE_3__global__["a" /* default */].getCurPage(),
				    i = _curpage.modinfo.findIndex(function (v) {
					return v.id == layerid;
				});
				if (i >= 0) _curpage.modinfo[i]['globalstyle'] = res;
			}
		}, { deep: true });

		this.$watch('attrs.childprop.modclick.param.type', function (newtype, oldtype) {
			// for '链接至商品列表/详情'
			_this.linkToProductPage(newtype);
			// for '重置'
			if (oldtype && oldtype != newtype) {
				_this.attrs.childprop.modclick.param.pagevalue = '';
			}
		}, { deep: true });

		this.$watch('attrs.childprop.modclick.param.pagevalue', function (res) {
			if (res != '') return false;
			_this.attrs.childprop.modclick.param.idsvalue = '';
			_this.attrs.childprop.modclick.param.title = '';
		});
	},

	watch: {
		'attrs.id': function attrsId(layerid) {
			initProperty.apply(this);
			// for 'delete' shortcut key
			window.actived_layerid = layerid;
		}
	},
	computed: {
		dataSourceAlias: function dataSourceAlias() {
			var _param = this.attrs.childprop.modclick.param;
			return _param.type == 'product_list' ? _param.idsvalue.length + '\u4E2A' : _param.title;
		},
		isPageDirectShow: function isPageDirectShow() {
			var modclick = this.attrs.childprop.modclick;
			if (!modclick) return false;

			var linktype = modclick.type,
			    param = modclick.param;
			if (linktype == 'page' && $.trim(param.value).length) return true;else if (linktype == 'func' && this.showDetailId && $.trim(param.pagevalue).length) return true;
			return false;
		},

		linkredirect: {
			get: function get() {
				var param = this.attrs.childprop.modclick.param;
				return param.redirect == '1' ? '1' : '0';
			},
			set: function set(newval) {
				var param = this.attrs.childprop.modclick.param;
				this.$set(param, 'redirect', newval);
			}
		},
		parseBgimg: function parseBgimg() {
			var bgimg = this.glbstyle['background-image'];
			if (bgimg == 'none') bgimg = __WEBPACK_IMPORTED_MODULE_10__assets_prevbg_gif___default.a;
			return (/^url\(/i.test(bgimg) ? bgimg : 'url(' + bgimg + ')'
			);
		},
		isAbsMedia: function isAbsMedia() {
			return this.attrs.type == 'media' ? true : false;
		},
		isformel: function isformel() {
			return (/^form_/i.test(this.attrs.type)
			);
		}
	},
	components: { ColorPicker2: __WEBPACK_IMPORTED_MODULE_6__components_colorpicker___default.a, Pagelinker: __WEBPACK_IMPORTED_MODULE_8__components_pagelinker___default.a, PageSet: __WEBPACK_IMPORTED_MODULE_9__components_pageset___default.a, ModProperty: __WEBPACK_IMPORTED_MODULE_7__components_modproperty___default.a, ProductSelector: __WEBPACK_IMPORTED_MODULE_11__wxplugins_product_list_product_selector___default.a },
	methods: {
		choosePic: function choosePic(idx) {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_5__common_events__["a" /* default */].$emit("show_filemanager", true, function (res) {
				if (idx == 'bgimg') _this2.glbstyle['background-image'] = res;else _this2.$set(vm.attrs.childprop, idx, res);
			}, 'pic');
		},
		linkToProductPage: function linkToProductPage(curmod) {
			var _this3 = this;

			var showDetailId = true,
			    action = '';
			switch (curmod) {
				case 'product_detail':
					action = 'prdetail';
					this.detailType = '产品详情';
					break;
				case 'product_list':
					action = 'prdlist';
					this.detailType = '产品列表';
					break;
				default:
					action = '';curmod = '';
					showDetailId = false;
					break;
			}

			if (curmod.length > 0 && action.length > 0) {
				__WEBPACK_IMPORTED_MODULE_3__global__["a" /* default */].xhrPost('page/' + action, null, function (res) {
					if (res.result != 'OK') {
						console.error('尚未找到匹配的数据源或产品已下架');
						return false;
					}

					_this3.detail_pages = res.data || [];
					if (_this3.detail_pages.length > 0) {
						_this3.isradio = curmod == 'product_list' ? false : true;
						__WEBPACK_IMPORTED_MODULE_5__common_events__["a" /* default */].$on("prdselector_close", function () {
							return _this3.dialogShow = false;
						});
					}
				}, function (err) {
					return console.error(err);
				});
			}

			this.showDetailId = showDetailId;
		}
	},
	directives: {
		adapt: {
			inserted: function inserted(el) {
				$(el).css("visibility", 'hidden');
				$(el).on("load", function (event) {
					var img = event.target,
					    w = void 0,
					    h = void 0,
					    t = void 0,
					    W = 102,
					    H = 108,
					    cw = img.width,
					    ch = img.height;
					if (cw == 0 || ch == 0) {
						var imgobj = this.items[index] || {};
						cw = parseFloat(imgobj.width);
						ch = parseFloat(imgobj.height);
					}
					if (cw > ch * W / H) {
						w = Math.min(W, cw);
						h = ch * w / cw;
						t = (H - h) / 2;
					} else {
						h = Math.min(H, ch);
						w = cw * h / ch;
						t = (H - h) / 2;
					}

					$(img).css({ "width": w + 'px', height: h + 'px', top: t + 'px', 'visibility': '' }).fadeIn("slow", function () {
						$(this).siblings('.loading').remove();
					});
				});
			}
		}
	}
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_events__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_dlgdrag__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_colorpicker__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_colorpicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_colorpicker__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var navbarSet = function navbarSet() {
	var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	var that = this;
	__WEBPACK_IMPORTED_MODULE_1__global__["a" /* default */].xhrPost('page/styles', param, function (res) {
		if (res.result == 'ERROR') {
			that.errmsg = res.data.errmsg;
			return false;
		}

		var jsndata = res.data || {};
		if (!$.isEmptyObject(jsndata)) {
			that.settings = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(that.settings, jsndata);
		} else if (!$.isEmptyObject(param)) that.dialogClose();
	}, function (err) {
		return console.error(err);
	});
};

/* harmony default export */ __webpack_exports__["default"] = ({
	mixins: [__WEBPACK_IMPORTED_MODULE_3__common_dlgdrag__["a" /* default */]],
	data: function data() {
		return {
			settings: {
				navigationBarTextStyle: 'white',
				navigationBarTitleText: '',
				navigationBarBackgroundColor: '#000',
				insidepage_themecolor: '#c71f3b'
			},
			errmsg: ''
		};
	},
	created: function created() {
		// Get 'settings'
		navbarSet.call(this);
	},

	methods: {
		dialogClose: function dialogClose() {
			__WEBPACK_IMPORTED_MODULE_2__common_events__["a" /* default */].$emit("hide_setting");
		},
		settingsSave: function settingsSave() {
			navbarSet.call(this, {
				type: 'update',
				settings: this.settings
			});
		}
	},
	components: { ColorPicker2: __WEBPACK_IMPORTED_MODULE_4__components_colorpicker___default.a }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_events__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_sidebar_data__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_vuedraggable_vuedraggable__ = __webpack_require__(50);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'sidebar',
	data: function data() {
		return {
			menus: __WEBPACK_IMPORTED_MODULE_3__common_sidebar_data__["a" /* menus */],
			plugins: __WEBPACK_IMPORTED_MODULE_3__common_sidebar_data__["b" /* plugins */],
			mactived: '',
			activedMenu: [],
			pluginTipsShow: true
		};
	},
	created: function created() {
		var _this = this;

		var _jGlobal$getModAct = __WEBPACK_IMPORTED_MODULE_1__global__["a" /* default */].getModAct(),
		    _jGlobal$getModAct2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_jGlobal$getModAct, 2),
		    mod = _jGlobal$getModAct2[0],
		    act = _jGlobal$getModAct2[1];
		// Set 'actived-menu'


		this.openMenu(mod + '/' + act);
		__WEBPACK_IMPORTED_MODULE_2__common_events__["a" /* default */].$on("sidebar_menuactived", function (v) {
			return _this.mactived = v;
		});
		// for '插件提示信息'
		var ishow = this.$cookie.get('wxplugintips');
		this.pluginTipsShow = ishow == '0' ? false : true;
	},

	methods: {
		hidePlugintips: function hidePlugintips() {
			this.pluginTipsShow = false;
			this.$cookie.set('wxplugintips', '0');
		},
		fnSwitch: function fnSwitch(pname) {
			var _prefix = __WEBPACK_IMPORTED_MODULE_1__global__["a" /* default */].URLPREFIX;
			location.href = _prefix + pname;
		},
		openChange: function openChange() {
			this.$nextTick(function () {
				return __WEBPACK_IMPORTED_MODULE_2__common_events__["a" /* default */].$emit("winresize", 'update');
			});
		},
		openMenu: function openMenu(mname) {
			var curidx = this.menus.findIndex(function (c, i) {
				var found = (c.children || []).find(function (cc) {
					return cc._src == mname ? true : false;
				});
				return found ? true : false;
			});
			if (curidx > -1) this.activedMenu.push('super-m' + curidx);
		},
		onStart: function onStart(e) {
			// for 'web页面'
			if ($('#canvas .cstlayer[type="webpage"]').length > 0) {
				this.$Message.error('当前页面已包含「Web页面」插件，无法再添加其他插件');
				return false;
			}
			$(e.item).append('<div class="drophint">放这里</div>');
			__WEBPACK_IMPORTED_MODULE_2__common_events__["a" /* default */].$emit("drag_add_module", e);
		},
		onEnd: function onEnd(e) {
			if ($('#canvas .cstlayer[type="webpage"]').length || e.newIndex == e.oldIndex) return false;
			__WEBPACK_IMPORTED_MODULE_2__common_events__["a" /* default */].$emit("addplugin_bydrag", 'onEnd', e, event);
		}
	},
	props: ['iseditor', 'height'],
	components: { draggable: __WEBPACK_IMPORTED_MODULE_4__components_vuedraggable_vuedraggable__["a" /* default */] }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_loading_gif__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_loading_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_loading_gif__);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'tips',
	data: function data() {
		return { loading: __WEBPACK_IMPORTED_MODULE_0__assets_loading_gif___default.a };
	},

	props: ['type']
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'login',
    data: function data() {
        return {
            page_title: '',
            page_subtitle: '',
            frmdata: {
                account: '',
                password: ''
            },
            rulers: {
                account: [{ "required": true, "message": '请输入管理账号', "trigger": 'blur' }],
                password: [{ "required": true, "message": '请输入密码', "trigger": 'blur' }, { "type": 'string', "min": 5, "message": '密码长度不能少于5位', "trigger": 'blur' }]
            },
            bgimg: ''
        };
    },
    created: function created() {
        var _this = this;

        this.page_title = window.page_title || '';
        this.page_subtitle = window.page_subtitle || '';
        this.bgimg = window.hosturl + 'image/loginbg.jpg';
        this.$nextTick(function () {
            var that = _this;
            $(window).on("resize", function (e) {
                var winh = $(this).height(),
                    winw = $(this).width();
                $(that.$el).width(winw).height(winh);
            }).trigger("resize");
        });
    },

    methods: {
        onSubmit: function onSubmit(idx) {
            var _this2 = this;

            this.$refs[idx].validate(function (valid) {
                if (!valid) return false;
                __WEBPACK_IMPORTED_MODULE_1__global__["a" /* default */].xhrPost('user/login', _this2.frmdata, function (res) {
                    if (res.result == 'OK') {
                        var _query = '',
                            srharr = __WEBPACK_IMPORTED_MODULE_1__global__["a" /* default */].parSearch();
                        if (srharr.sicode) delete srharr.sicode;
                        _this2.$cookie.set('loginresponsid', res.sid);
                        if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(srharr).length) {
                            location.reload();return false;
                        }
                        for (var ky in srharr) {
                            _query += '&' + ky + '=' + srharr[ky];
                        }location.search = _query.substr(1);
                    } else _this2.$Message.error(res.data.errmsg);
                }, function (err) {
                    return _this2.$Message.error(err);
                });
            });
        }
    }
});

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_events__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_dlgdrag__ = __webpack_require__(32);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
	mixins: [__WEBPACK_IMPORTED_MODULE_3__common_dlgdrag__["a" /* default */]],
	props: ['attrs', 'category', 'isradio'],
	data: function data() {
		return {
			products: [],
			selectedArr: [],
			keyword: '',
			pagesize: 10,
			total: 0
			/*category_id: '',
   categories: [],
   selectedName: '全部',*/
		};
	},
	created: function created() {
		// data-source
		this.all_products = [];
		this.loadProduct();
	},
	mounted: function mounted() {
		var _this = this;

		$(this.$el).appendTo("body");
		this.$nextTick(function () {
			var winh = $(window).height();
			$(_this.$refs.tabul).height(winh - 215);
		});
	},

	methods: {
		loadProduct: function loadProduct() {
			var _this2 = this;

			var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

			params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(params, { status: '1' });
			__WEBPACK_IMPORTED_MODULE_1__global__["a" /* default */].xhrPost('wxshop/index', params, function (res) {
				var jsndata = res.data || {};
				_this2.products = jsndata.source;
				_this2.all_products = jsndata.source;
				// for 'init-style'
				var pids = [];
				if (!_this2.attrs.childprop.data_source) {
					pids = _this2.attrs.childprop.modclick.param.idsvalue;
				} else pids = _this2.attrs.childprop.data_source.value;

				if ($.isArray(pids) && pids.length) _this2.selectedArr = pids;
				if (params.pageid) return false;
				_this2.pagesize = jsndata.pagesize;
				_this2.total = jsndata.total;
			}, function (err) {
				return console.log(err);
			});
		},
		onPager: function onPager(pageid) {
			var params = {};
			params['pageid'] = pageid;
			params['keyword'] = this.keyword.trim();
			this.loadProduct(params);
		},
		selectedPrdById: function selectedPrdById(id) {
			// for 'product-detail'
			var chkedarr = this.selectedArr || [],
			    _i = chkedarr.findIndex(function (v) {
				return id == v;
			});
			if (_i < 0) {
				if (this.isradio && chkedarr.length) {
					this.selectedArr.shift();
				}
				this.selectedArr.push(id);
			} else this.selectedArr.splice(_i, 1);
		},
		selectedProduct: function selectedProduct() {
			var pids = this.selectedArr;
			if (!this.attrs.childprop.data_source) {
				this.attrs.childprop.modclick.param.idsvalue = pids;
				// for 'product-detail'
				if (this.isradio == true) {
					var tmpobj = this.products.find(function (c) {
						return c.id == pids[0];
					});
					if (tmpobj) this.attrs.childprop.modclick.param.title = tmpobj['name'];
				}
			} else {
				this.attrs.childprop.data_source.value = pids;
				// for 'product-detail'
				if (this.isradio == true) {
					var _tmpobj = this.products.find(function (c) {
						return c.id == pids[0];
					});
					if (_tmpobj) this.attrs.childprop.data_source.title = _tmpobj['name'];
				}
			}
			this.dialogClose();
		},
		searchProduct: function searchProduct() {
			this.loadProduct({ keyword: this.keyword.trim() });
		},
		dialogClose: function dialogClose() {
			__WEBPACK_IMPORTED_MODULE_2__common_events__["a" /* default */].$emit("prdselector_close");
		}
	}
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return menus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return plugins; });
var menus = [{
	"title": '概况',
	"icon": 'iconfont icon-gaikuang',
	"_src": 'index/index',
	"children": []
}, {
	"title": '小程序设置',
	"icon": 'iconfont icon-xiaochengxu',
	"children": [{ "title": '企业官网', "_src": 'wxapp/home' }, { "title": '入口名片', "_src": 'wxapp/entry' }, { "title": '名片模板', "_src": 'wxapp/cards' }, { "title": '微页面', "_src": 'wxapp/pages' }, { "title": '动态表单', "_src": 'wxapp/forms' }, { "title": '发布小程序', "_src": 'wxapp/publish' }]
}, {
	"title": '公司管理',
	"icon": 'iconfont icon-gongsi',
	"children": [{ "title": '组织架构', "_src": 'company/index' }, { "title": 'AI雷达权限', "_src": 'company/airadar' }, { "title": '企业微信', "_src": 'company/wechat' }]
}, {
	"title": '客户管理',
	"icon": 'iconfont icon-kehu',
	"children": [{ "title": '客户一览', "_src": 'clients/index' }]
}, {
	"title": '商城管理',
	"icon": 'iconfont icon-shangpin',
	"children": [{ "title": '装修店铺', "_src": 'wxshop/index' }, { "title": '产品管理', "_src": 'wxshop/goods' }]
}, {
	"title": '系统设置',
	"icon": 'iconfont icon-shezhi',
	"children": [{ "title": '订阅消息', "_src": 'setting/message' }, { "title": '海报缓存', "_src": 'poster/caches' }]
}, {
	"title": '我的账号',
	"icon": 'iconfont icon-wodedangxuan',
	"children": [{ "title": '企业信息', "_src": 'user/detail' }, { "title": '修改密码', "_src": 'user/password' }]
}],
    plugins = [{ "name": 'mtitle', "alias": '文本', "icon": 'iconfont icon-text' }, { "name": 'media', "alias": '图片', "icon": 'iconfont icon-tupian' }, { "name": 'swiper', "alias": '轮播', "icon": 'iconfont icon-lunbo' }, { "name": 'freelayout', "alias": '自由布局', "icon": 'iconfont icon-rongqi' }, { "name": 'buttons', "alias": '按钮', "icon": 'iconfont icon-anniu' }, { "name": 'navigation', "alias": '导航', "icon": 'iconfont icon-daohang' }, { "name": 'forms', "alias": '表单', "icon": 'iconfont icon-biaodan' }, { "name": 'mmap', "alias": '地图', "icon": 'iconfont icon-ditu' }, { "name": 'mvideo', "alias": '视频', "icon": 'iconfont icon-shipin' }, { "name": 'webpage', "alias": 'Web页面', "icon": 'iconfont icon-wangyesheji' }, { "name": 'product_list', "alias": '产品列表', "icon": 'iconfont icon-chanpin' }, { "name": 'product_detail', "alias": '产品详情', "icon": 'iconfont icon-details' }, { "name": 'official_account', "alias": '公众号关注', "icon": 'iconfont icon-guanzhugzh' }, { "name": 'miniprogram', "alias": '小程序跳转', "icon": 'iconfont icon-miniprogram' }];



/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

/**!
 * Sortable
 * @author	RubaXa   <trash@rubaxa.org>
 * @license MIT
 */
var exportobj;
(function sortableModule(factory) {
	"use strict";
	// if (typeof define === "function" && define.amd) {
	// 	define(factory);
	// }
	// else if (typeof module != "undefined" && typeof module.exports != "undefined") {
	// 	module.exports = factory();
	// }
	// else {
	// 	/* jshint sub:true */
	// 	window["Sortable"] = factory();
	// }

	exportobj = factory();
})(function sortableFactory() {
	"use strict";

	if (typeof window == "undefined" || !window.document) {
		return function sortableError() {
			throw new Error("Sortable.js requires a window with a document");
		};
	}

	var dragEl,
	    parentEl,
	    ghostEl,
	    cloneEl,
	    rootEl,
	    nextEl,
	    lastDownEl,
	    scrollEl,
	    scrollParentEl,
	    scrollCustomFn,
	    lastEl,
	    lastCSS,
	    lastParentCSS,
	    oldIndex,
	    newIndex,
	    activeGroup,
	    putSortable,
	    autoScroll = {},
	    tapEvt,
	    touchEvt,
	    moved,


	/** @const */
	R_SPACE = /\s+/g,
	    R_FLOAT = /left|right|inline/,
	    expando = 'Sortable' + new Date().getTime(),
	    win = window,
	    document = win.document,
	    parseInt = win.parseInt,
	    $ = win.jQuery || win.Zepto,
	    Polymer = win.Polymer,
	    captureMode = false,
	    supportDraggable = !!('draggable' in document.createElement('div')),
	    supportCssPointerEvents = function (el) {
		// false when IE11
		if (!!navigator.userAgent.match(/Trident.*rv[ :]?11\./)) {
			return false;
		}
		el = document.createElement('x');
		el.style.cssText = 'pointer-events:auto';
		return el.style.pointerEvents === 'auto';
	}(),
	    _silent = false,
	    abs = Math.abs,
	    min = Math.min,
	    savedInputChecked = [],
	    touchDragOverListeners = [],
	    _autoScroll = _throttle(function ( /**Event*/evt, /**Object*/options, /**HTMLElement*/rootEl) {
		// Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
		if (rootEl && options.scroll) {
			var _this = rootEl[expando],
			    el,
			    rect,
			    sens = options.scrollSensitivity,
			    speed = options.scrollSpeed,
			    x = evt.clientX,
			    y = evt.clientY,
			    winWidth = window.innerWidth,
			    winHeight = window.innerHeight,
			    vx,
			    vy,
			    scrollOffsetX,
			    scrollOffsetY;

			// Delect scrollEl
			if (scrollParentEl !== rootEl) {
				scrollEl = options.scroll;
				scrollParentEl = rootEl;
				scrollCustomFn = options.scrollFn;

				if (scrollEl === true) {
					scrollEl = rootEl;

					do {
						if (scrollEl.offsetWidth < scrollEl.scrollWidth || scrollEl.offsetHeight < scrollEl.scrollHeight) {
							break;
						}
						/* jshint boss:true */
					} while (scrollEl = scrollEl.parentNode);
				}
			}

			if (scrollEl) {
				el = scrollEl;
				rect = scrollEl.getBoundingClientRect();
				vx = (abs(rect.right - x) <= sens) - (abs(rect.left - x) <= sens);
				vy = (abs(rect.bottom - y) <= sens) - (abs(rect.top - y) <= sens);
			}

			if (!(vx || vy)) {
				vx = (winWidth - x <= sens) - (x <= sens);
				vy = (winHeight - y <= sens) - (y <= sens);

				/* jshint expr:true */
				(vx || vy) && (el = win);
			}

			if (autoScroll.vx !== vx || autoScroll.vy !== vy || autoScroll.el !== el) {
				autoScroll.el = el;
				autoScroll.vx = vx;
				autoScroll.vy = vy;

				clearInterval(autoScroll.pid);

				if (el) {
					autoScroll.pid = setInterval(function () {
						scrollOffsetY = vy ? vy * speed : 0;
						scrollOffsetX = vx ? vx * speed : 0;

						if ('function' === typeof scrollCustomFn) {
							return scrollCustomFn.call(_this, scrollOffsetX, scrollOffsetY, evt);
						}

						if (el === win) {
							win.scrollTo(win.pageXOffset + scrollOffsetX, win.pageYOffset + scrollOffsetY);
						} else {
							el.scrollTop += scrollOffsetY;
							el.scrollLeft += scrollOffsetX;
						}
					}, 24);
				}
			}
		}
	}, 30),
	    _prepareGroup = function _prepareGroup(options) {
		function toFn(value, pull) {
			if (value === void 0 || value === true) {
				value = group.name;
			}

			if (typeof value === 'function') {
				return value;
			} else {
				return function (to, from) {
					var fromGroup = from.options.group.name;

					return pull ? value : value && (value.join ? value.indexOf(fromGroup) > -1 : fromGroup == value);
				};
			}
		}

		var group = {};
		var originalGroup = options.group;

		if (!originalGroup || (typeof originalGroup === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(originalGroup)) != 'object') {
			originalGroup = { name: originalGroup };
		}

		group.name = originalGroup.name;
		group.checkPull = toFn(originalGroup.pull, true);
		group.checkPut = toFn(originalGroup.put);
		group.revertClone = originalGroup.revertClone;

		options.group = group;
	};

	/**
  * @class  Sortable
  * @param  {HTMLElement}  el
  * @param  {Object}       [options]
  */
	function Sortable(el, options) {
		if (!(el && el.nodeType && el.nodeType === 1)) {
			throw 'Sortable: `el` must be HTMLElement, and not ' + {}.toString.call(el);
		}

		this.el = el; // root element
		this.options = options = _extend({}, options);

		// Export instance
		el[expando] = this;

		// Default options
		var defaults = {
			group: Math.random(),
			sort: true,
			disabled: false,
			store: null,
			handle: null,
			scroll: true,
			scrollSensitivity: 30,
			scrollSpeed: 10,
			draggable: /[uo]l/i.test(el.nodeName) ? 'li' : '>*',
			ghostClass: 'sortable-ghost',
			chosenClass: 'sortable-chosen',
			dragClass: 'sortable-drag',
			ignore: 'a, img',
			filter: null,
			preventOnFilter: true,
			animation: 0,
			setData: function setData(dataTransfer, dragEl) {
				dataTransfer.setData('Text', dragEl.textContent);
			},
			dropBubble: false,
			dragoverBubble: false,
			dataIdAttr: 'data-id',
			delay: 0,
			forceFallback: false,
			fallbackClass: 'sortable-fallback',
			fallbackOnBody: false,
			fallbackTolerance: 0,
			fallbackOffset: { x: 0, y: 0 }
		};

		// Set default options
		for (var name in defaults) {
			!(name in options) && (options[name] = defaults[name]);
		}

		_prepareGroup(options);

		// Bind all private methods
		for (var fn in this) {
			if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
				this[fn] = this[fn].bind(this);
			}
		}

		// Setup drag mode
		this.nativeDraggable = options.forceFallback ? false : supportDraggable;

		// Bind events
		_on(el, 'mousedown', this._onTapStart);
		_on(el, 'touchstart', this._onTapStart);
		_on(el, 'pointerdown', this._onTapStart);

		if (this.nativeDraggable) {
			_on(el, 'dragover', this);
			_on(el, 'dragenter', this);
		}

		touchDragOverListeners.push(this._onDragOver);

		// Restore sorting
		options.store && this.sort(options.store.get(this));
	}

	Sortable.prototype = /** @lends Sortable.prototype */{
		constructor: Sortable,

		_onTapStart: function _onTapStart( /** Event|TouchEvent */evt) {
			var _this = this,
			    el = this.el,
			    options = this.options,
			    preventOnFilter = options.preventOnFilter,
			    type = evt.type,
			    touch = evt.touches && evt.touches[0],
			    target = (touch || evt).target,
			    originalTarget = evt.target.shadowRoot && evt.path[0] || target,
			    filter = options.filter,
			    startIndex;

			_saveInputCheckedState(el);

			// Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.
			if (dragEl) {
				return;
			}

			if (type === 'mousedown' && evt.button !== 0 || options.disabled) {
				return; // only left button or enabled
			}

			target = _closest(target, options.draggable, el);

			if (!target) {
				return;
			}

			if (lastDownEl === target) {
				// Ignoring duplicate `down`
				return;
			}

			// Get the index of the dragged element within its parent
			startIndex = _index(target, options.draggable);

			// Check filter
			if (typeof filter === 'function') {
				if (filter.call(this, evt, target, this)) {
					_dispatchEvent(_this, originalTarget, 'filter', target, el, startIndex);
					preventOnFilter && evt.preventDefault();
					return; // cancel dnd
				}
			} else if (filter) {
				filter = filter.split(',').some(function (criteria) {
					criteria = _closest(originalTarget, criteria.trim(), el);

					if (criteria) {
						_dispatchEvent(_this, criteria, 'filter', target, el, startIndex);
						return true;
					}
				});

				if (filter) {
					preventOnFilter && evt.preventDefault();
					return; // cancel dnd
				}
			}

			if (options.handle && !_closest(originalTarget, options.handle, el)) {
				return;
			}

			// Prepare `dragstart`
			this._prepareDragStart(evt, touch, target, startIndex);
		},

		_prepareDragStart: function _prepareDragStart( /** Event */evt, /** Touch */touch, /** HTMLElement */target, /** Number */startIndex) {
			var _this = this,
			    el = _this.el,
			    options = _this.options,
			    ownerDocument = el.ownerDocument,
			    dragStartFn;

			if (target && !dragEl && target.parentNode === el) {
				tapEvt = evt;

				rootEl = el;
				dragEl = target;
				parentEl = dragEl.parentNode;
				nextEl = dragEl.nextSibling;
				lastDownEl = target;
				activeGroup = options.group;
				oldIndex = startIndex;

				this._lastX = (touch || evt).clientX;
				this._lastY = (touch || evt).clientY;

				dragEl.style['will-change'] = 'transform';

				dragStartFn = function dragStartFn() {
					// Delayed drag has been triggered
					// we can re-enable the events: touchmove/mousemove
					_this._disableDelayedDrag();

					// Make the element draggable
					dragEl.draggable = _this.nativeDraggable;

					// Chosen item
					_toggleClass(dragEl, options.chosenClass, true);

					// Bind the events: dragstart/dragend
					_this._triggerDragStart(evt, touch);

					// Drag start event
					_dispatchEvent(_this, rootEl, 'choose', dragEl, rootEl, oldIndex);
				};

				// Disable "draggable"
				options.ignore.split(',').forEach(function (criteria) {
					_find(dragEl, criteria.trim(), _disableDraggable);
				});

				_on(ownerDocument, 'mouseup', _this._onDrop);
				_on(ownerDocument, 'touchend', _this._onDrop);
				_on(ownerDocument, 'touchcancel', _this._onDrop);
				_on(ownerDocument, 'pointercancel', _this._onDrop);
				_on(ownerDocument, 'selectstart', _this);

				if (options.delay) {
					// If the user moves the pointer or let go the click or touch
					// before the delay has been reached:
					// disable the delayed drag
					_on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
					_on(ownerDocument, 'touchend', _this._disableDelayedDrag);
					_on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
					_on(ownerDocument, 'mousemove', _this._disableDelayedDrag);
					_on(ownerDocument, 'touchmove', _this._disableDelayedDrag);
					_on(ownerDocument, 'pointermove', _this._disableDelayedDrag);

					_this._dragStartTimer = setTimeout(dragStartFn, options.delay);
				} else {
					dragStartFn();
				}
			}
		},

		_disableDelayedDrag: function _disableDelayedDrag() {
			var ownerDocument = this.el.ownerDocument;

			clearTimeout(this._dragStartTimer);
			_off(ownerDocument, 'mouseup', this._disableDelayedDrag);
			_off(ownerDocument, 'touchend', this._disableDelayedDrag);
			_off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
			_off(ownerDocument, 'mousemove', this._disableDelayedDrag);
			_off(ownerDocument, 'touchmove', this._disableDelayedDrag);
			_off(ownerDocument, 'pointermove', this._disableDelayedDrag);
		},

		_triggerDragStart: function _triggerDragStart( /** Event */evt, /** Touch */touch) {
			touch = touch || (evt.pointerType == 'touch' ? evt : null);

			if (touch) {
				// Touch device support
				tapEvt = {
					target: dragEl,
					clientX: touch.clientX,
					clientY: touch.clientY
				};

				this._onDragStart(tapEvt, 'touch');
			} else if (!this.nativeDraggable) {
				this._onDragStart(tapEvt, true);
			} else {
				_on(dragEl, 'dragend', this);
				_on(rootEl, 'dragstart', this._onDragStart);
			}

			try {
				if (document.selection) {
					// Timeout neccessary for IE9
					setTimeout(function () {
						document.selection.empty();
					});
				} else {
					window.getSelection().removeAllRanges();
				}
			} catch (err) {}
		},

		_dragStarted: function _dragStarted() {
			if (rootEl && dragEl) {
				var options = this.options;

				// Apply effect
				_toggleClass(dragEl, options.ghostClass, true);
				_toggleClass(dragEl, options.dragClass, false);

				Sortable.active = this;

				// Drag start event
				_dispatchEvent(this, rootEl, 'start', dragEl, rootEl, oldIndex);
			} else {
				this._nulling();
			}
		},

		_emulateDragOver: function _emulateDragOver() {
			if (touchEvt) {
				if (this._lastX === touchEvt.clientX && this._lastY === touchEvt.clientY) {
					return;
				}

				this._lastX = touchEvt.clientX;
				this._lastY = touchEvt.clientY;

				if (!supportCssPointerEvents) {
					_css(ghostEl, 'display', 'none');
				}

				var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY),
				    parent = target,
				    i = touchDragOverListeners.length;

				if (parent) {
					do {
						if (parent[expando]) {
							while (i--) {
								touchDragOverListeners[i]({
									clientX: touchEvt.clientX,
									clientY: touchEvt.clientY,
									target: target,
									rootEl: parent
								});
							}

							break;
						}

						target = parent; // store last element
					}
					/* jshint boss:true */
					while (parent = parent.parentNode);
				}

				if (!supportCssPointerEvents) {
					_css(ghostEl, 'display', '');
				}
			}
		},

		_onTouchMove: function _onTouchMove( /**TouchEvent*/evt) {
			if (tapEvt) {
				var options = this.options,
				    fallbackTolerance = options.fallbackTolerance,
				    fallbackOffset = options.fallbackOffset,
				    touch = evt.touches ? evt.touches[0] : evt,
				    dx = touch.clientX - tapEvt.clientX + fallbackOffset.x,
				    dy = touch.clientY - tapEvt.clientY + fallbackOffset.y,
				    translate3d = evt.touches ? 'translate3d(' + dx + 'px,' + dy + 'px,0)' : 'translate(' + dx + 'px,' + dy + 'px)';

				// only set the status to dragging, when we are actually dragging
				if (!Sortable.active) {
					if (fallbackTolerance && min(abs(touch.clientX - this._lastX), abs(touch.clientY - this._lastY)) < fallbackTolerance) {
						return;
					}

					this._dragStarted();
				}

				// as well as creating the ghost element on the document body
				this._appendGhost();

				moved = true;
				touchEvt = touch;

				_css(ghostEl, 'webkitTransform', translate3d);
				_css(ghostEl, 'mozTransform', translate3d);
				_css(ghostEl, 'msTransform', translate3d);
				_css(ghostEl, 'transform', translate3d);

				evt.preventDefault();
			}
		},

		_appendGhost: function _appendGhost() {
			if (!ghostEl) {
				var rect = dragEl.getBoundingClientRect(),
				    css = _css(dragEl),
				    options = this.options,
				    ghostRect;

				ghostEl = dragEl.cloneNode(true);

				_toggleClass(ghostEl, options.ghostClass, false);
				_toggleClass(ghostEl, options.fallbackClass, true);
				_toggleClass(ghostEl, options.dragClass, true);

				_css(ghostEl, 'top', rect.top - parseInt(css.marginTop, 10));
				_css(ghostEl, 'left', rect.left - parseInt(css.marginLeft, 10));
				_css(ghostEl, 'width', rect.width);
				_css(ghostEl, 'height', rect.height);
				_css(ghostEl, 'opacity', '0.8');
				_css(ghostEl, 'position', 'fixed');
				_css(ghostEl, 'zIndex', '100000');
				_css(ghostEl, 'pointerEvents', 'none');

				options.fallbackOnBody && document.body.appendChild(ghostEl) || rootEl.appendChild(ghostEl);

				// Fixing dimensions.
				ghostRect = ghostEl.getBoundingClientRect();
				_css(ghostEl, 'width', rect.width * 2 - ghostRect.width);
				_css(ghostEl, 'height', rect.height * 2 - ghostRect.height);
			}
		},

		_onDragStart: function _onDragStart( /**Event*/evt, /**boolean*/useFallback) {
			var dataTransfer = evt.dataTransfer,
			    options = this.options;

			this._offUpEvents();

			if (activeGroup.checkPull(this, this, dragEl, evt)) {
				cloneEl = _clone(dragEl);

				cloneEl.draggable = false;
				cloneEl.style['will-change'] = '';

				_css(cloneEl, 'display', 'none');
				_toggleClass(cloneEl, this.options.chosenClass, false);

				rootEl.insertBefore(cloneEl, dragEl);
				_dispatchEvent(this, rootEl, 'clone', dragEl);
			}

			_toggleClass(dragEl, options.dragClass, true);

			if (useFallback) {
				if (useFallback === 'touch') {
					// Bind touch events
					_on(document, 'touchmove', this._onTouchMove);
					_on(document, 'touchend', this._onDrop);
					_on(document, 'touchcancel', this._onDrop);
					_on(document, 'pointermove', this._onTouchMove);
					_on(document, 'pointerup', this._onDrop);
				} else {
					// Old brwoser
					_on(document, 'mousemove', this._onTouchMove);
					_on(document, 'mouseup', this._onDrop);
				}

				this._loopId = setInterval(this._emulateDragOver, 50);
			} else {
				if (dataTransfer) {
					dataTransfer.effectAllowed = 'move';
					options.setData && options.setData.call(this, dataTransfer, dragEl);
				}

				_on(document, 'drop', this);
				setTimeout(this._dragStarted, 0);
			}
		},

		_onDragOver: function _onDragOver( /**Event*/evt) {
			var el = this.el,
			    target,
			    dragRect,
			    targetRect,
			    revert,
			    options = this.options,
			    group = options.group,
			    activeSortable = Sortable.active,
			    isOwner = activeGroup === group,
			    isMovingBetweenSortable = false,
			    canSort = options.sort;

			if (evt.preventDefault !== void 0) {
				evt.preventDefault();
				var is_plugin_not_container = true;
				if ($(evt.target).closest('.cstlayer[type=forms]').length > 0 && $(dragEl).is('.base-plugin-list, .mod_wrapper')) {
					is_plugin_not_container = false;
				}
				!options.dragoverBubble && is_plugin_not_container && evt.stopPropagation();
			}

			if (dragEl.animated) {
				return;
			}

			moved = true;

			if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = !rootEl.contains(dragEl)) // Reverting item into the original list
			: putSortable === this || (activeSortable.lastPullMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt)) && (evt.rootEl === void 0 || evt.rootEl === this.el) // touch fallback
			) {
					// Smart auto-scrolling
					_autoScroll(evt, options, this.el);

					if (_silent) {
						return;
					}

					target = _closest(evt.target, options.draggable, el);
					dragRect = dragEl.getBoundingClientRect();

					if (putSortable !== this) {
						putSortable = this;
						isMovingBetweenSortable = true;
					}

					if (revert) {
						_cloneHide(activeSortable, true);
						parentEl = rootEl; // actualization

						if (cloneEl || nextEl) {
							rootEl.insertBefore(dragEl, cloneEl || nextEl);
						} else if (!canSort) {
							rootEl.appendChild(dragEl);
						}

						return;
					}

					if (el.children.length === 0 || el.children[0] === ghostEl || el === evt.target && _ghostIsLast(el, evt)) {
						//assign target only if condition is true
						if (el.children.length !== 0 && el.children[0] !== ghostEl && el === evt.target) {
							target = el.lastElementChild;
						}

						if (target) {
							if (target.animated) {
								return;
							}

							targetRect = target.getBoundingClientRect();
						}

						_cloneHide(activeSortable, isOwner);

						if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt) !== false) {
							if (!dragEl.contains(el)) {
								el.appendChild(dragEl);
								parentEl = el; // actualization
							}

							this._animate(dragRect, dragEl);
							target && this._animate(targetRect, target);
						}
					} else if (target && !target.animated && target !== dragEl && target.parentNode[expando] !== void 0) {
						if (lastEl !== target) {
							lastEl = target;
							lastCSS = _css(target);
							lastParentCSS = _css(target.parentNode);
						}

						targetRect = target.getBoundingClientRect();

						var width = targetRect.right - targetRect.left,
						    height = targetRect.bottom - targetRect.top,
						    floating = R_FLOAT.test(lastCSS.cssFloat + lastCSS.display) || lastParentCSS.display == 'flex' && lastParentCSS['flex-direction'].indexOf('row') === 0,
						    isWide = target.offsetWidth > dragEl.offsetWidth,
						    isLong = target.offsetHeight > dragEl.offsetHeight,
						    halfway = (floating ? (evt.clientX - targetRect.left) / width : (evt.clientY - targetRect.top) / height) > 0.5,
						    nextSibling = target.nextElementSibling,
						    after = false;

						if (floating) {
							var elTop = dragEl.offsetTop,
							    tgTop = target.offsetTop;

							if (elTop === tgTop) {
								after = target.previousElementSibling === dragEl && !isWide || halfway && isWide;
							} else if (target.previousElementSibling === dragEl || dragEl.previousElementSibling === target) {
								after = (evt.clientY - targetRect.top) / height > 0.5;
							} else {
								after = tgTop > elTop;
							}
						} else if (!isMovingBetweenSortable) {
							after = nextSibling !== dragEl && !isLong || halfway && isLong;
						}

						var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);

						if (moveVector !== false) {
							if (moveVector === 1 || moveVector === -1) {
								after = moveVector === 1;
							}

							_silent = true;
							setTimeout(_unsilent, 30);

							_cloneHide(activeSortable, isOwner);

							if (!dragEl.contains(el)) {
								if (after && !nextSibling) {
									el.appendChild(dragEl);
								} else {
									target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
								}
							}

							parentEl = dragEl.parentNode; // actualization

							this._animate(dragRect, dragEl);
							this._animate(targetRect, target);
						}
					}
				}
		},

		_animate: function _animate(prevRect, target) {
			var ms = this.options.animation;

			if (ms) {
				var currentRect = target.getBoundingClientRect();

				if (prevRect.nodeType === 1) {
					prevRect = prevRect.getBoundingClientRect();
				}

				_css(target, 'transition', 'none');
				_css(target, 'transform', 'translate3d(' + (prevRect.left - currentRect.left) + 'px,' + (prevRect.top - currentRect.top) + 'px,0)');

				target.offsetWidth; // repaint

				_css(target, 'transition', 'all ' + ms + 'ms');
				_css(target, 'transform', 'translate3d(0,0,0)');

				clearTimeout(target.animated);
				target.animated = setTimeout(function () {
					_css(target, 'transition', '');
					_css(target, 'transform', '');
					target.animated = false;
				}, ms);
			}
		},

		_offUpEvents: function _offUpEvents() {
			var ownerDocument = this.el.ownerDocument;

			_off(document, 'touchmove', this._onTouchMove);
			_off(document, 'pointermove', this._onTouchMove);
			_off(ownerDocument, 'mouseup', this._onDrop);
			_off(ownerDocument, 'touchend', this._onDrop);
			_off(ownerDocument, 'pointerup', this._onDrop);
			_off(ownerDocument, 'touchcancel', this._onDrop);
			_off(ownerDocument, 'pointercancel', this._onDrop);
			_off(ownerDocument, 'selectstart', this);
		},

		_onDrop: function _onDrop( /**Event*/evt) {
			var el = this.el,
			    options = this.options;

			clearInterval(this._loopId);
			clearInterval(autoScroll.pid);
			clearTimeout(this._dragStartTimer);

			// Unbind events
			_off(document, 'mousemove', this._onTouchMove);

			if (this.nativeDraggable) {
				_off(document, 'drop', this);
				_off(el, 'dragstart', this._onDragStart);
			}

			this._offUpEvents();

			if (evt) {
				if (moved) {
					evt.preventDefault();
					!options.dropBubble && evt.stopPropagation();
				}

				ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);

				if (rootEl === parentEl || Sortable.active.lastPullMode !== 'clone') {
					// Remove clone
					cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
				}

				if (dragEl) {
					if (this.nativeDraggable) {
						_off(dragEl, 'dragend', this);
					}

					_disableDraggable(dragEl);
					dragEl.style['will-change'] = '';

					// Remove class's
					_toggleClass(dragEl, this.options.ghostClass, false);
					_toggleClass(dragEl, this.options.chosenClass, false);

					// Drag stop event
					_dispatchEvent(this, rootEl, 'unchoose', dragEl, rootEl, oldIndex);

					if (rootEl !== parentEl) {
						newIndex = _index(dragEl, options.draggable);

						if (newIndex >= 0) {
							// Add event
							_dispatchEvent(null, parentEl, 'add', dragEl, rootEl, oldIndex, newIndex);

							// Remove event
							_dispatchEvent(this, rootEl, 'remove', dragEl, rootEl, oldIndex, newIndex);

							// drag from one list and drop into another
							_dispatchEvent(null, parentEl, 'sort', dragEl, rootEl, oldIndex, newIndex);
							_dispatchEvent(this, rootEl, 'sort', dragEl, rootEl, oldIndex, newIndex);
						}
					} else {
						if (dragEl.nextSibling !== nextEl) {
							// Get the index of the dragged element within its parent
							newIndex = _index(dragEl, options.draggable);

							if (newIndex >= 0) {
								// drag & drop within the same list
								_dispatchEvent(this, rootEl, 'update', dragEl, rootEl, oldIndex, newIndex);
								_dispatchEvent(this, rootEl, 'sort', dragEl, rootEl, oldIndex, newIndex);
							}
						}
					}

					if (Sortable.active) {
						/* jshint eqnull:true */
						if (newIndex == null || newIndex === -1) {
							newIndex = oldIndex;
						}

						_dispatchEvent(this, rootEl, 'end', dragEl, rootEl, oldIndex, newIndex);

						// Save sorting
						this.save();
					}
				}
			}

			this._nulling();
		},

		_nulling: function _nulling() {
			rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = scrollEl = scrollParentEl = tapEvt = touchEvt = moved = newIndex = lastEl = lastCSS = putSortable = activeGroup = Sortable.active = null;

			savedInputChecked.forEach(function (el) {
				el.checked = true;
			});
			savedInputChecked.length = 0;
		},

		handleEvent: function handleEvent( /**Event*/evt) {
			switch (evt.type) {
				case 'drop':
				case 'dragend':
					this._onDrop(evt);
					break;

				case 'dragover':
				case 'dragenter':
					var screl = $(evt.srcElement);
					if (!screl.length) screl = $(evt.target);
					if (screl.closest('.phonetop').length) {
						$('#scroll_container').trigger('scrolltoup');
					}
					if (screl.closest('.phonebottom').length) {
						$('#scroll_container').trigger('scrolltodown');
					}
					if (dragEl) {
						this._onDragOver(evt);
						_globalDragOver(evt);
					}
					break;

				case 'selectstart':
					evt.preventDefault();
					break;
			}
		},

		/**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
		toArray: function toArray() {
			var order = [],
			    el,
			    children = this.el.children,
			    i = 0,
			    n = children.length,
			    options = this.options;

			for (; i < n; i++) {
				el = children[i];
				if (_closest(el, options.draggable, this.el)) {
					order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
				}
			}

			return order;
		},

		/**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
		sort: function sort(order) {
			var items = {},
			    rootEl = this.el;

			this.toArray().forEach(function (id, i) {
				var el = rootEl.children[i];

				if (_closest(el, this.options.draggable, rootEl)) {
					items[id] = el;
				}
			}, this);

			order.forEach(function (id) {
				if (items[id]) {
					rootEl.removeChild(items[id]);
					rootEl.appendChild(items[id]);
				}
			});
		},

		/**
   * Save the current sorting
   */
		save: function save() {
			var store = this.options.store;
			store && store.set(this);
		},

		/**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
		closest: function closest(el, selector) {
			return _closest(el, selector || this.options.draggable, this.el);
		},

		/**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
		option: function option(name, value) {
			var options = this.options;

			if (value === void 0) {
				return options[name];
			} else {
				options[name] = value;

				if (name === 'group') {
					_prepareGroup(options);
				}
			}
		},

		/**
   * Destroy
   */
		destroy: function destroy() {
			var el = this.el;

			el[expando] = null;

			_off(el, 'mousedown', this._onTapStart);
			_off(el, 'touchstart', this._onTapStart);
			_off(el, 'pointerdown', this._onTapStart);

			if (this.nativeDraggable) {
				_off(el, 'dragover', this);
				_off(el, 'dragenter', this);
			}

			// Remove draggable attributes
			Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function (el) {
				el.removeAttribute('draggable');
			});

			touchDragOverListeners.splice(touchDragOverListeners.indexOf(this._onDragOver), 1);

			this._onDrop();

			this.el = el = null;
		}
	};

	function _cloneHide(sortable, state) {
		if (sortable.lastPullMode !== 'clone') {
			state = true;
		}

		if (cloneEl && cloneEl.state !== state) {
			_css(cloneEl, 'display', state ? 'none' : '');

			if (!state) {
				if (cloneEl.state) {
					if (sortable.options.group.revertClone) {
						rootEl.insertBefore(cloneEl, nextEl);
						sortable._animate(dragEl, cloneEl);
					} else {
						rootEl.insertBefore(cloneEl, dragEl);
					}
				}
			}

			cloneEl.state = state;
		}
	}

	function _closest( /**HTMLElement*/el, /**String*/selector, /**HTMLElement*/ctx) {
		if (el) {
			ctx = ctx || document;

			do {
				if (selector === '>*' && el.parentNode === ctx || _matches(el, selector)) {
					return el;
				}
				/* jshint boss:true */
			} while (el = _getParentOrHost(el));
		}

		return null;
	}

	function _getParentOrHost(el) {
		var parent = el.host;

		return parent && parent.nodeType ? parent : el.parentNode;
	}

	function _globalDragOver( /**Event*/evt) {
		if (evt.dataTransfer) {
			evt.dataTransfer.dropEffect = 'move';
		}
		evt.preventDefault();
	}

	function _on(el, event, fn) {
		el.addEventListener(event, fn, captureMode);
	}

	function _off(el, event, fn) {
		el.removeEventListener(event, fn, captureMode);
	}

	function _toggleClass(el, name, state) {
		if (el) {
			if (el.classList) {
				el.classList[state ? 'add' : 'remove'](name);
			} else {
				var className = (' ' + el.className + ' ').replace(R_SPACE, ' ').replace(' ' + name + ' ', ' ');
				el.className = (className + (state ? ' ' + name : '')).replace(R_SPACE, ' ');
			}
		}
	}

	function _css(el, prop, val) {
		var style = el && el.style;

		if (style) {
			if (val === void 0) {
				if (document.defaultView && document.defaultView.getComputedStyle) {
					val = document.defaultView.getComputedStyle(el, '');
				} else if (el.currentStyle) {
					val = el.currentStyle;
				}

				return prop === void 0 ? val : val[prop];
			} else {
				if (!(prop in style)) {
					prop = '-webkit-' + prop;
				}

				style[prop] = val + (typeof val === 'string' ? '' : 'px');
			}
		}
	}

	function _find(ctx, tagName, iterator) {
		if (ctx) {
			var list = ctx.getElementsByTagName(tagName),
			    i = 0,
			    n = list.length;

			if (iterator) {
				for (; i < n; i++) {
					iterator(list[i], i);
				}
			}

			return list;
		}

		return [];
	}

	function _dispatchEvent(sortable, rootEl, name, targetEl, fromEl, startIndex, newIndex) {
		sortable = sortable || rootEl[expando];

		var evt = document.createEvent('Event'),
		    options = sortable.options,
		    onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1);

		evt.initEvent(name, true, true);

		evt.to = rootEl;
		evt.from = fromEl || rootEl;
		evt.item = targetEl || rootEl;
		evt.clone = cloneEl;

		evt.oldIndex = startIndex;
		evt.newIndex = newIndex;

		rootEl.dispatchEvent(evt);

		if (options[onName]) {
			options[onName].call(sortable, evt);
		}
	}

	function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvt, willInsertAfter) {
		var evt,
		    sortable = fromEl[expando],
		    onMoveFn = sortable.options.onMove,
		    retVal;

		evt = document.createEvent('Event');
		evt.initEvent('move', true, true);

		evt.to = toEl;
		evt.from = fromEl;
		evt.dragged = dragEl;
		evt.draggedRect = dragRect;
		evt.related = targetEl || toEl;
		evt.relatedRect = targetRect || toEl.getBoundingClientRect();
		evt.willInsertAfter = willInsertAfter;

		fromEl.dispatchEvent(evt);

		if (onMoveFn) {
			retVal = onMoveFn.call(sortable, evt, originalEvt);
		}

		return retVal;
	}

	function _disableDraggable(el) {
		el.draggable = false;
	}

	function _unsilent() {
		_silent = false;
	}

	/** @returns {HTMLElement|false} */
	function _ghostIsLast(el, evt) {
		var lastEl = el.lastElementChild,
		    rect = lastEl.getBoundingClientRect();

		// 5 — min delta
		// abs — нельзя добавлять, а то глюки при наведении сверху
		return evt.clientY - (rect.top + rect.height) > 5 || evt.clientX - (rect.left + rect.width) > 5;
	}

	/**
  * Generate id
  * @param   {HTMLElement} el
  * @returns {String}
  * @private
  */
	function _generateId(el) {
		var str = el.tagName + el.className + el.src + el.href + el.textContent,
		    i = str.length,
		    sum = 0;

		while (i--) {
			sum += str.charCodeAt(i);
		}

		return sum.toString(36);
	}

	/**
  * Returns the index of an element within its parent for a selected set of
  * elements
  * @param  {HTMLElement} el
  * @param  {selector} selector
  * @return {number}
  */
	function _index(el, selector) {
		var index = 0;

		if (!el || !el.parentNode) {
			return -1;
		}

		while (el && (el = el.previousElementSibling)) {
			if (el.nodeName.toUpperCase() !== 'TEMPLATE' && (selector === '>*' || _matches(el, selector))) {
				index++;
			}
		}

		return index;
	}

	function _matches( /**HTMLElement*/el, /**String*/selector) {
		if (el) {
			selector = selector.split('.');

			var tag = selector.shift().toUpperCase(),
			    re = new RegExp('\\s(' + selector.join('|') + ')(?=\\s)', 'g');

			return (tag === '' || el.nodeName.toUpperCase() == tag) && (!selector.length || ((' ' + el.className + ' ').match(re) || []).length == selector.length);
		}

		return false;
	}

	function _throttle(callback, ms) {
		var args, _this;

		return function () {
			if (args === void 0) {
				args = arguments;
				_this = this;

				setTimeout(function () {
					if (args.length === 1) {
						callback.call(_this, args[0]);
					} else {
						callback.apply(_this, args);
					}

					args = void 0;
				}, ms);
			}
		};
	}

	function _extend(dst, src) {
		if (dst && src) {
			for (var key in src) {
				if (src.hasOwnProperty(key)) {
					dst[key] = src[key];
				}
			}
		}

		return dst;
	}

	function _clone(el) {
		return $ ? $(el).clone(true)[0] : Polymer && Polymer.dom ? Polymer.dom(el).cloneNode(true) : el.cloneNode(true);
	}

	function _saveInputCheckedState(root) {
		var inputs = root.getElementsByTagName('input');
		var idx = inputs.length;

		while (idx--) {
			var el = inputs[idx];
			el.checked && savedInputChecked.push(el);
		}
	}

	// Fixed #973: 
	_on(document, 'touchmove', function (evt) {
		if (Sortable.active) {
			evt.preventDefault();
		}
	});

	try {
		window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
			get: function get() {
				captureMode = {
					capture: false,
					passive: false
				};
			}
		}));
	} catch (err) {}

	// Export utils
	Sortable.utils = {
		on: _on,
		off: _off,
		css: _css,
		find: _find,
		is: function is(el, selector) {
			return !!_closest(el, selector, el);
		},
		extend: _extend,
		throttle: _throttle,
		closest: _closest,
		toggleClass: _toggleClass,
		clone: _clone,
		index: _index
	};

	/**
  * Create sortable instance
  * @param {HTMLElement}  el
  * @param {Object}      [options]
  */
	Sortable.create = function (el, options) {
		return new Sortable(el, options);
	};

	// Export
	Sortable.version = '1.6.0';
	return Sortable;
});
/* harmony default export */ __webpack_exports__["default"] = (exportobj);

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_iview__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_iview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_iview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuebar__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cookie__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_iview_dist_styles_iview_css__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_iview_dist_styles_iview_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_iview_dist_styles_iview_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_iconfont_css__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_iconfont_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_iconfont_css__);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_iview___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuebar___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4__cookie__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
	el: '#approot',
	template: '<App/>',
	components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 153 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 154 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 155 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 156 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 157 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 158 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 160 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 162 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 163 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 164 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 165 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 166 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 167 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 168 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(157)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(186),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-337879fe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(158)
  __webpack_require__(159)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(90),
  /* template */
  __webpack_require__(187),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-39032d14",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(153)
  __webpack_require__(154)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(91),
  /* template */
  __webpack_require__(184),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0f576c25",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(182),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(195),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(161)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(96),
  /* template */
  __webpack_require__(189),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(165)
  __webpack_require__(166)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(97),
  /* template */
  __webpack_require__(193),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7a56f9d2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(167)
  __webpack_require__(168)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(194),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9cbbcbba",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(160)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(99),
  /* template */
  __webpack_require__(188),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3f7b0601",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 182 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.cmpname, {
    tag: "component",
    attrs: {
      "options": _vm.options,
      "attrs": _vm.attrs
    }
  })
},staticRenderFns: []}

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c((!_vm.is_relative && !_vm.ispreview) ? 'drag-resizable' : 'div', {
    tag: "div",
    staticClass: "cstlayer",
    class: {
      'mod_wrapper': _vm.iswrapper
    },
    style: ([_vm.modStyle(_vm.mod_param.globalstyle), {
      'box-sizing': (_vm.type == 'media') ? 'content-box' : 'border-box',
      left: _vm.is_relative ? false : ((_vm.pos.left) + "px"),
      top: _vm.is_relative ? false : ((_vm.pos.top) + "px"),
      width: _vm.is_relative ? false : ((_vm.size.width) + "px"),
      height: (_vm.type == 'webpage') ? '100%' : ((_vm.size.height == 'auto') ? _vm.size.height : ((_vm.size.height) + "px")),
      'z-index': _vm.is_relative ? false : _vm.pos.zindex
    }]),
    attrs: {
      "id": _vm.id,
      "x": _vm.pos.left,
      "y": _vm.pos.top,
      "w": _vm.size.width,
      "h": _vm._f("calcheight")(_vm.size.height, _vm.is_relative ? '' : _vm.id),
      "type": _vm.type,
      "parent": true
    },
    on: {
      "dragging": _vm.onDrag,
      "resizing": _vm.onResize,
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onActivated($event)
      },
      "activated": _vm.onActivated,
      "deactivated": _vm.onDeactivated
    }
  }, [(!_vm.ispreview) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_active),
      expression: "is_active"
    }],
    staticClass: "handler handler-top"
  }) : _vm._e(), _vm._v(" "), (!_vm.ispreview) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_active),
      expression: "is_active"
    }],
    staticClass: "handler handler-btm"
  }, [(_vm.heightResizable && _vm.isActive && _vm.is_active) ? _c('span', {
    staticClass: "btmhandler",
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.layoutResize('bm', $event)
      }
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.is_relative && !_vm.ispreview) ? [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_active),
      expression: "is_active"
    }],
    staticClass: "handler handler-right"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_active),
      expression: "is_active"
    }],
    staticClass: "handler handler-left"
  })] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wp_content",
    style: ({
      'text-align': _vm.mod_param.childprop['text-align'] || 'left',
      width: _vm.is_relative ? '100%' : ((_vm.size.width) + "px"),
      height: _vm.is_relative ? '100%' : ((_vm.size.height) + "px")
    }),
    on: {
      "click": function($event) {
        _vm.layerTap(_vm.mod_param.childprop)
      }
    }
  }, [_c(("wp_" + _vm.type), {
    tag: "component",
    class: {
      'last-placeholder': _vm.islast && _vm.isContainer
    },
    attrs: {
      "param": _vm.mod_param.childprop,
      "children": _vm.children,
      "comp_id": _vm.mod_param.id,
      "isactive": _vm.is_active
    }
  })], 1), _vm._v(" "), (_vm.position == 'relative' && !_vm.ispreview) ? [_c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "myhandler"
  }, [_vm._v("Ξ")])] : _vm._e(), _vm._v(" "), (!_vm.ispreview) ? _c('div', {
    staticClass: "removit",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.rmPlugin($event)
      }
    }
  }, [_vm._v("×")]) : _vm._e(), _vm._v(" "), (!_vm.isContainer && !_vm.ispreview) ? _c('div', {
    staticClass: "masklayer"
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 184 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "file-fade"
    }
  }, [_c('div', {
    staticClass: "file-manager"
  }, [_c('div', {
    staticClass: "mask"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "dlgdrag",
      rawName: "v-dlgdrag"
    }],
    staticClass: "dig",
    style: ({
      height: _vm.con_height
    })
  }, [_c('div', {
    staticClass: "dig_title clearFix"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('b', {
    staticClass: "mark_choose"
  }), _vm._v(_vm._s(_vm.dig_title))]), _vm._v(" "), _c('Icon', {
    staticClass: "fr",
    attrs: {
      "type": "close-round"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.dialogClose($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dig-main clearFix"
  }, [_c('div', {
    staticClass: "main-left"
  }, [_c('Tabs', {
    on: {
      "on-click": _vm.tabSwitch
    },
    model: {
      value: (_vm.tabtype),
      callback: function($$v) {
        _vm.tabtype = $$v
      },
      expression: "tabtype"
    }
  }, _vm._l((_vm.tabpanes), function(pane, i) {
    return _c('TabPane', {
      key: i,
      style: ({
        height: _vm.con_main_left_height
      }),
      attrs: {
        "name": pane.name,
        "label": pane.alias
      }
    }, [_c('div', {
      staticClass: "tanchuang-content"
    }, [(_vm.items.length) ? [_c('div', {
      staticClass: "tanchuang-content-box"
    }, [_c('div', {
      directives: [{
        name: "bar",
        rawName: "v-bar",
        value: ({
          preventParentScroll: true,
          scrollThrottle: 30
        }),
        expression: "{preventParentScroll: true,scrollThrottle: 30}"
      }],
      staticStyle: {
        "height": "100%"
      }
    }, [_c('div', [_c('ul', {
      staticClass: "main-left-list clearFix"
    }, _vm._l((_vm.items), function(item, i) {
      return _c('li', {
        key: item.id,
        staticClass: "list-li fl"
      }, [_c('div', {
        staticClass: "list-li-top",
        class: {
          selected: _vm.selectedIdx.findIndex(function (v) {
            return v == i
          }) > -1
        },
        staticStyle: {
          "height": "63px",
          "position": "relative",
          "background-color": "#eee"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.imgFocus(i, item.fpath)
          }
        }
      }, [_c('div', {
        staticClass: "loading"
      }), _vm._v(" "), _c('img', {
        directives: [{
          name: "adapt",
          rawName: "v-adapt"
        }],
        attrs: {
          "src": item.ftype.toLowerCase() == 'mp3' ?
            _vm.soundGif : item.fpath,
          "title": '类型：' + item.ftype + '\n大小：' + item.fsize + '\n尺寸：' + item.width + '*' + item.height + '像素\n修改日期：' + item.ftime
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "selectState"
      }, [_c('span', {
        staticClass: "iconfont icon-dui",
        staticStyle: {
          "font-size": "32px"
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "list-li-bottom",
        attrs: {
          "title": "双击此处重命名"
        },
        on: {
          "dblclick": function($event) {
            _vm.renameid = i
          }
        }
      }, [(_vm.renameid == i) ? [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.fbasename),
          expression: "item.fbasename"
        }],
        staticClass: "inprename",
        domProps: {
          "value": (item.fbasename)
        },
        on: {
          "keyup": function($event) {
            if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
            _vm.fileRename(i, $event)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "fbasename", $event.target.value)
          }
        }
      }), _vm._v(_vm._s(item.fname.replace(/^[^\.]+\./i, '.')))] : [_vm._v(_vm._s(item.fname))]], 2), _vm._v(" "), _c('Icon', {
        staticClass: "list-li-delete",
        staticStyle: {
          "font-size": "10px"
        },
        attrs: {
          "type": "close-round"
        },
        nativeOn: {
          "click": function($event) {
            _vm.fileDelete(item.fname)
          }
        }
      })], 1)
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "clearFix"
    }), _vm._v(" "), _c('Page', {
      staticClass: "page-btn",
      attrs: {
        "current": _vm.curr_page,
        "page-size": _vm.page_size,
        "total": _vm.items_total
      },
      on: {
        "on-change": _vm.pageSwitch
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both",
        "height": "2px",
        "width": "100%",
        "overflow": "hidden"
      }
    })], 1)])]), _vm._v(" "), (_vm.getFiles.length) ? _c('div', {
      staticClass: "confirm_btn",
      staticStyle: {
        "bottom": "10px"
      },
      on: {
        "click": _vm.picSelect
      }
    }, [_vm._v("确定(" + _vm._s(_vm.getFiles.length) + ")")]) : _vm._e()] : [_c('span', {
      staticClass: "empty"
    }, [_vm._v(_vm._s(_vm.file_err_str))])]], 2)])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "searchAndOpera"
  }, [(!_vm.getFiles.length) ? _c('div', {
    staticClass: "page_search"
  }, [_c('Input', {
    attrs: {
      "placeholder": "按文件名查找"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fileSearch($event)
      }
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  }, [_c('Button', {
    attrs: {
      "slot": "append",
      "icon": "ios-search"
    },
    on: {
      "click": _vm.fileSearch
    },
    slot: "append"
  })], 1)], 1) : _c('div', {
    staticClass: "page_opera"
  }, [(_vm.multiselect) ? [_c('div', {
    staticClass: "opera-list",
    on: {
      "click": _vm.selectAll
    }
  }, [_vm._v("全选")]), _vm._v(" "), _c('div', {
    staticClass: "opera-list",
    on: {
      "click": _vm.deleteBatch
    }
  }, [_vm._v("批量删除")])] : _vm._e(), _vm._v(" "), _c('Select', {
    staticClass: "opera-list-sele",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "移动至"
    },
    on: {
      "on-change": _vm.fileMoveTo
    }
  }, _vm._l((_vm.categoryTree), function(category) {
    return _c('Option', {
      key: category,
      attrs: {
        "value": category
      }
    }, [_vm._v(_vm._s(_vm.parseTitle(category)))])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "opera-list",
    on: {
      "click": _vm.unSelect
    }
  }, [_vm._v("取消选择")])], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "main-right fr"
  }, [_c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "page-setup"
  }, [_c('div', {
    staticClass: "upFile"
  }, [_c('Upload', {
    attrs: {
      "accept": _vm.file_accept,
      "max-size": _vm.file_maxsize,
      "on-success": _vm.uploadSuccess,
      "on-exceeded-size": _vm.maxSizeTips,
      "multiple": "",
      "action": _vm.uploadUrl,
      "show-upload-list": false,
      "data": {
        sid: _vm.sid,
        token: _vm.token,
        maxFileSize: _vm.file_maxsize * 1024,
        fileType: _vm.file_allowext,
        tag: _vm.cur_category
      }
    }
  }, [_c('Button', {
    attrs: {
      "type": "success"
    }
  }, [_c('i', {
    staticClass: "ivu-icon ivu-icon-ios-cloud-upload-outline",
    staticStyle: {
      "font-size": "18px",
      "padding-right": "10px"
    }
  }), _vm._v("\r\n\t\t\t\t\t\t\t\t\t\t上传文件")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "categoryBox"
  }, [_c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar",
      value: ({
        preventParentScroll: true,
        scrollThrottle: 30
      }),
      expression: "{preventParentScroll: true,scrollThrottle: 30}"
    }],
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', [_vm._l((_vm.categories), function(category) {
    return _c('div', {
      key: category,
      staticClass: "category-main",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.categorySearch(category)
        }
      }
    }, [_c('div', {
      staticClass: "father",
      class: {
        active: _vm.cur_category == category
      }
    }, [_c('b', {
      staticClass: "mark_choose"
    }), _vm._v(" "), (_vm.renameCtag == category) ? _c('div', [_c('input', {
      staticClass: "catrename",
      attrs: {
        "placeholder": "分类名称"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }), _vm._v(" "), _c('Button', {
      staticClass: "catrename",
      staticStyle: {
        "width": "50px"
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.categoryEdit(category, $event)
        }
      }
    }, [_vm._v("确定")])], 1) : _c('div', {
      staticClass: "clearFix",
      staticStyle: {
        "padding-right": "5px"
      }
    }, [(category) ? [(!_vm.subCategoryClose[category]) ? _c('Icon', {
      staticClass: "fl page-setup-father",
      staticStyle: {
        "line-height": "13px"
      },
      attrs: {
        "type": "plus-round"
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.branchOpen('plus', category)
        }
      }
    }) : _c('Icon', {
      staticClass: "fl page-setup-father",
      staticStyle: {
        "line-height": "13px"
      },
      attrs: {
        "type": "minus-round"
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.branchOpen('minus', category)
        }
      }
    })] : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.parseTitle(category)))]), _vm._v(" "), (category) ? _c('div', {
      staticClass: "fr"
    }, [_c('i', {
      staticClass: "page-setup-li iconfont icon-bianji",
      attrs: {
        "title": "编辑分类"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.showCateInput(category, $event)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "page-setup-li iconfont icon-shezhi1",
      attrs: {
        "title": "设置上级分类"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.categoryTofather(category)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "page-setup-li iconfont icon-chuyidong",
      attrs: {
        "title": "删除分类"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.categoryDelete(category)
        }
      }
    })]) : _vm._e()], 2)]), _vm._v(" "), _vm._l((_vm.category_children[category]), function(subcategory) {
      return (_vm.subCategoryClose[category]) ? _c('div', {
        key: subcategory,
        staticClass: "children",
        class: {
          active: _vm.cur_category == subcategory
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.categorySearch(subcategory)
          }
        }
      }, [_c('b', {
        staticClass: "mark_choose"
      }), _vm._v(" "), (_vm.renameCtag == subcategory) ? _c('div', [_c('input', {
        staticClass: "catrename",
        attrs: {
          "placeholder": "分类名称"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
          }
        }
      }), _vm._v(" "), _c('Button', {
        staticClass: "catrename",
        staticStyle: {
          "width": "56px"
        },
        nativeOn: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.categoryEdit(subcategory, $event)
          }
        }
      }, [_vm._v("确定")])], 1) : _c('div', {
        staticClass: "clearFix",
        staticStyle: {
          "padding-right": "5px"
        }
      }, [_c('span', {
        staticStyle: {
          "line-height": "22px"
        }
      }, [_vm._v(_vm._s(_vm.parseTitle(subcategory)))]), _vm._v(" "), _c('div', {
        staticClass: "fr"
      }, [_c('i', {
        staticClass: "page-setup-li iconfont icon-bianji",
        attrs: {
          "title": "编辑分类"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.showCateInput(subcategory, $event)
          }
        }
      }), _vm._v(" "), _c('i', {
        staticClass: "page-setup-li iconfont icon-shezhi1",
        attrs: {
          "title": "设置上级分类"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.categoryTofather(subcategory, category)
          }
        }
      }), _vm._v(" "), _c('i', {
        staticClass: "page-setup-li iconfont icon-chuyidong",
        attrs: {
          "title": "删除分类"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.categoryDelete(subcategory)
          }
        }
      })])])]) : _vm._e()
    }), _vm._v(" "), (_vm.subCategoryClose[category]) ? _c('div', {
      staticClass: "children",
      staticStyle: {
        "border-bottom": "1px solid #dddee1"
      }
    }, [_c('b', {
      staticClass: "mark_choose"
    }), _vm._v(" "), _c('input', {
      staticClass: "children_ipt",
      attrs: {
        "placeholder": "分类名称"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }), _vm._v(" "), _c('Button', {
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.addSubCategory(category, $event)
        }
      }
    }, [_vm._v("确定")])], 1) : _vm._e()], 2)
  }), _vm._v(" "), (_vm.category_err_str) ? _c('div', {
    staticStyle: {
      "color": "#f00",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.category_err_str))]) : _vm._e()], 2)])]), _vm._v(" "), _c('Input', {
    staticClass: "setup-btn",
    attrs: {
      "placeholder": "按Enter键添加分类"
    },
    on: {
      "on-keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addCategory($event)
      }
    },
    model: {
      value: (_vm.catename),
      callback: function($$v) {
        _vm.catename = $$v
      },
      expression: "catename"
    }
  })], 1)])])])]), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": 370,
      "title": "设置上级分类"
    },
    on: {
      "on-ok": _vm.superCategorySet
    },
    model: {
      value: (_vm.showSuperCate),
      callback: function($$v) {
        _vm.showSuperCate = $$v
      },
      expression: "showSuperCate"
    }
  }, [_c('ul', {
    staticClass: "supercate-set"
  }, [_c('li', [_c('label', {
    staticClass: "ctitle"
  }, [_vm._v("分类名称")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.parseTitle(_vm.current_cname)))])]), _vm._v(" "), _c('li', [_c('label', {
    staticClass: "ctitle"
  }, [_vm._v("上级分类")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('Select', {
    staticStyle: {
      "width": "200px"
    },
    model: {
      value: (_vm.current_fathercname),
      callback: function($$v) {
        _vm.current_fathercname = $$v
      },
      expression: "current_fathercname"
    }
  }, _vm._l((_vm.categories), function(category, c) {
    return _c('Option', {
      key: c,
      attrs: {
        "value": category || 'top'
      }
    }, [_vm._v(_vm._s(_vm.parseTitle(category || '最上层')))])
  }), 1)], 1)])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 185 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar"
    }],
    ref: "approot",
    style: ({
      width: _vm.ispreview ? '375px' : ''
    }),
    attrs: {
      "id": "approot"
    },
    on: {
      "dragover": _vm.allowDrop
    }
  }, [_c('div', [(_vm.logined && !_vm.ispreview) ? _c('div', {
    staticClass: "header",
    style: ({
      height: (_vm.headerh + "px"),
      'z-index': _vm.iseditor ? 1 : 100
    })
  }, [_c('img', {
    staticClass: "logo fl",
    attrs: {
      "src": _vm.logo,
      "title": _vm.page_title
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fl",
    staticStyle: {
      "color": "#ccc",
      "padding-top": "17px"
    }
  }, [_vm._v(_vm._s(_vm.page_subtitle))]), _vm._v(" "), (_vm.logined) ? _c('div', {
    staticClass: "fr",
    staticStyle: {
      "line-height": "50px"
    }
  }, [(_vm.iseditor) ? [_c('label', {
    staticClass: "btnli",
    on: {
      "click": _vm.showFile
    }
  }, [_c('i', {
    staticClass: "iconfont icon-wenjianguanli"
  }), _vm._v("\n\t\t\t\t文件管理")]), _vm._v(" "), _c('label', {
    staticClass: "btnli",
    on: {
      "click": _vm.showSetting
    }
  }, [_c('i', {
    staticClass: "iconfont icon-shezhi"
  }), _vm._v("\n\t\t\t\t设置")]), _vm._v(" "), _c('label', {
    staticClass: "btnli",
    on: {
      "click": _vm.onSave
    }
  }, [_c('i', {
    staticClass: "iconfont icon-save"
  }), _vm._v("\n\t\t\t\t保存")])] : [(_vm.version.length) ? _c('Poptip', {
    attrs: {
      "trigger": "hover",
      "placement": "bottom",
      "word-wrap": "true",
      "width": "380"
    },
    on: {
      "on-popper-show": _vm.updateVersion
    }
  }, [(_vm.syslog.id) ? [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "14px"
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.syslog.created) + " V" + _vm._s(_vm.syslog.version))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "348px",
      "overflow": "hidden"
    },
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('p', {
    staticStyle: {
      "line-height": "1.5",
      "font-size": "14px",
      "padding": "5px 0 8px",
      "white-space": "normal"
    }
  }, [_vm._v(_vm._s(_vm.syslog.remark))]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "syslogs"
    }
  }, _vm._l((JSON.parse(_vm.syslog.content || '[]')), function(txt, idx) {
    return _c('li', {
      key: idx
    }, [_vm._v(_vm._s(txt))])
  }), 0), _vm._v(" "), _c('a', {
    staticClass: "syslog-history",
    attrs: {
      "href": _vm.logsmore,
      "target": "_blank"
    }
  }, [_vm._v("更多历史更新日志")])])] : [_c('p', {
    staticStyle: {
      "color": "#999"
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("未发现更新日志")])], _vm._v(" "), _c('Badge', {
    staticStyle: {
      "color": "#999",
      "margin-right": "15px"
    },
    attrs: {
      "dot": "",
      "count": _vm.vscnt
    }
  }, [_vm._v("更新日志")])], 2) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "helper",
    attrs: {
      "href": _vm.helper,
      "target": "_blank"
    }
  }, [_vm._v("帮助文档")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.loguser))]), _vm._v(" "), _c('i', {
    staticClass: "iconfont icon-tuichu logout",
    attrs: {
      "title": "登出"
    },
    on: {
      "click": _vm.logout
    }
  })]], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.logined) ? _c('div', {
    staticClass: "main",
    style: ({
      'margin-top': _vm.ispreview ? '0px' : '50px',
      height: _vm.ispreview ? '100%' : ''
    })
  }, [(!_vm.ispreview) ? _c('div', {
    ref: "sidebar",
    class: ['sidebar', 'fl', {
      'editor-bar': _vm.iseditor
    }]
  }, [_c('sidebar', {
    attrs: {
      "iseditor": _vm.iseditor,
      "height": _vm.containerh
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "content",
    staticClass: "content fl",
    style: (_vm.ctstyle)
  }, [(_vm.iseditor || _vm.ispreview) ? _c('weditor', {
    attrs: {
      "id": _vm.pageid,
      "height": _vm.containerh,
      "ispreview": _vm.ispreview
    }
  }) : _c(("Mc" + _vm.cmpalias), {
    tag: "component",
    attrs: {
      "type": _vm.cmptype
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.show_filedialog && !_vm.ispreview) ? _c('file-manager', {
    attrs: {
      "fmtype": _vm.filemgr_type,
      "con_height": _vm.con_height,
      "multiselect": _vm.filemgr_multiselect,
      "con_main_left_height": _vm.con_main_left_height
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.logined) ? _c('login') : _vm._e(), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "温馨提示",
      "class-name": "vertical-center-modal",
      "closable": false,
      "mask-closable": false,
      "ok-text": "马上绑定",
      "cancel-text": "先体验一下"
    },
    on: {
      "on-ok": _vm.onBuild,
      "on-cancel": _vm.onTaste
    },
    model: {
      value: (_vm.buildAppTip),
      callback: function($$v) {
        _vm.buildAppTip = $$v
      },
      expression: "buildAppTip"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("部分功能需要授权绑定小程序后才能体验")])]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "温馨提示",
      "class-name": "vertical-center-modal siterr",
      "closable": false,
      "mask-closable": false
    },
    model: {
      value: (_vm.siteError),
      callback: function($$v) {
        _vm.siteError = $$v
      },
      expression: "siteError"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("抱歉，" + _vm._s(_vm.siteErrTips))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_vm._v("  ")])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vdr",
    class: {
      draggable: _vm.draggable, resizable: _vm.resizable, active: _vm.active
    },
    style: (_vm.style),
    on: {
      "click": function($event) {
        $event.stopPropagation();
      },
      "mousedown": _vm.elmDown,
      "dblclick": _vm.fillParent
    }
  }, [_vm._l((_vm.handles), function(handle) {
    return (_vm.resizable) ? _c('div', {
      staticClass: "handle",
      class: ("handle-" + handle),
      style: ({
        display: _vm.active ? 'block' : 'none'
      }),
      on: {
        "mousedown": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.handleDown(handle, $event)
        }
      }
    }) : _vm._e()
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "editor-main",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('div', {
    ref: "editor",
    staticClass: "editor fl",
    style: (_vm.edstyle)
  }, [(!_vm.ispreview) ? _c('draggable', {
    staticClass: "phonetop",
    attrs: {
      "options": {
        group: {
          name: 'phonetop',
          pull: false,
          put: false
        },
        scroll: false
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(82)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar",
      value: ({
        preventParentScroll: true,
        scrollThrottle: 30
      }),
      expression: "{preventParentScroll: true,scrollThrottle: 30}"
    }],
    style: (_vm.scstyle),
    attrs: {
      "id": "scroll_container"
    }
  }, [_c('div', [_c('draggable', {
    style: (_vm.pagestyle),
    attrs: {
      "id": "canvas",
      "options": {
        disabled: _vm.ispreview,
        group: {
          name: 'sort1',
          pull: false
        },
        handle: '.myhandler',
        ghostClass: 'sortghost',
        scroll: true
      }
    },
    model: {
      value: (_vm.tree_modules),
      callback: function($$v) {
        _vm.tree_modules = $$v
      },
      expression: "tree_modules"
    }
  }, [_vm._l((_vm.tree_modules), function(child, m) {
    return _c('wp-module', {
      key: child.id,
      attrs: {
        "id": child.id,
        "mod_param": child.orimodinf,
        "children": child.children,
        "is_active": child.active,
        "active": child.active,
        "position": 'relative',
        "islast": (_vm.tree_modules.length == m + 1) ? true : false
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "place-holder",
    style: ({
      'height': _vm.placeholder_height + 'px'
    })
  })], 2)], 1)]), _vm._v(" "), (!_vm.ispreview) ? _c('draggable', {
    staticClass: "phonebottom",
    style: ({
      'top': (_vm.btmtop + "px")
    }),
    attrs: {
      "options": {
        group: {
          name: 'phonetop',
          pull: false,
          put: false
        },
        scroll: false
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(79)
    }
  })]) : _vm._e()], 1), _vm._v(" "), (!_vm.ispreview) ? _c('div', {
    staticClass: "propanel fr"
  }, [_c('property', {
    attrs: {
      "attrs": _vm.propInfo,
      "height": _vm.height
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.show_setdialog && !_vm.ispreview) ? _c('setting') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 188 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app_tips"
  }, [(_vm.type == 'loading') ? [_c('img', {
    attrs: {
      "src": _vm.loading
    }
  }), _vm._v("\n\t\t页面加载中...\n\t")] : (404) ? [_c('h1', {
    staticStyle: {
      "color": "#f00"
    }
  }, [_vm._v("404")])] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 189 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Tabs', {
    attrs: {
      "animated": false
    }
  }, [_c('Tab-pane', {
    directives: [{
      name: "bar",
      rawName: "v-bar",
      value: ({
        preventParentScroll: true,
        scrollThrottle: 30
      }),
      expression: "{preventParentScroll: true,scrollThrottle: 30}"
    }],
    staticClass: "proptab",
    style: ({
      height: (_vm.height + "px")
    }),
    attrs: {
      "label": "属性设置"
    }
  }, [_c('div', [(_vm.ispage) ? _c('div', {
    staticStyle: {
      "padding-bottom": "70px",
      "overflow": "hidden"
    }
  }, [_c('page-set', {
    attrs: {
      "pageinfo": _vm.options
    }
  })], 1) : _c('div', {
    staticStyle: {
      "padding-bottom": "70px",
      "overflow": "hidden"
    }
  }, [_c('mod-property', {
    key: _vm.attrs.type,
    attrs: {
      "options": _vm.options,
      "attrs": _vm.attrs
    }
  }), _vm._v(" "), (_vm.attrs.parent && !_vm.isformel) ? _c('div', {
    staticClass: "content",
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_c('div', {
    staticClass: "form-group clearFix"
  }, [_c('label', {
    staticClass: "option-alias"
  }, [_vm._v("位置")]), _vm._v(" "), _c('div', {
    staticClass: "rightbox"
  }, [_c('span', {
    staticClass: "subtitle"
  }, [_vm._v("X:")]), _vm._v(" "), _c('InputNumber', {
    staticClass: "subinp",
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.attrs.left),
      callback: function($$v) {
        _vm.$set(_vm.attrs, "left", $$v)
      },
      expression: "attrs.left"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("Y:")]), _vm._v(" "), _c('InputNumber', {
    staticClass: "subinp",
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.attrs.top),
      callback: function($$v) {
        _vm.$set(_vm.attrs, "top", $$v)
      },
      expression: "attrs.top"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group clearFix"
  }, [_c('label', {
    staticClass: "option-alias"
  }, [_vm._v("尺寸")]), _vm._v(" "), _c('div', {
    staticClass: "rightbox"
  }, [_c('span', {
    staticClass: "subtitle"
  }, [_vm._v("宽:")]), _vm._v(" "), _c('InputNumber', {
    staticClass: "subinp",
    attrs: {
      "min": _vm.isAbsMedia ? 20 : 0,
      "size": "large"
    },
    model: {
      value: (_vm.attrs.width),
      callback: function($$v) {
        _vm.$set(_vm.attrs, "width", $$v)
      },
      expression: "attrs.width"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("高:")]), _vm._v(" "), _c('InputNumber', {
    staticClass: "subinp",
    attrs: {
      "min": _vm.isAbsMedia ? 20 : 0,
      "size": "large"
    },
    model: {
      value: (_vm.attrs.height),
      callback: function($$v) {
        _vm.$set(_vm.attrs, "height", $$v)
      },
      expression: "attrs.height"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.ispage && ['media', 'mtitle', 'buttons'].findIndex(function (c) { return c == _vm.attrs.type; }) > -1) ? _c('div', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_c('div', {
    staticClass: "form-group clearFix"
  }, [_c('label', {
    staticClass: "option-alias"
  }, [_vm._v("点击事件")]), _vm._v(" "), _c('Pagelinker', {
    staticStyle: {
      "line-height": "36px"
    },
    attrs: {
      "attrs": _vm.attrs,
      "inner": _vm.isInner
    },
    model: {
      value: (_vm.attrs.childprop.modclick),
      callback: function($$v) {
        _vm.$set(_vm.attrs.childprop, "modclick", $$v)
      },
      expression: "attrs.childprop.modclick"
    }
  })], 1), _vm._v(" "), (_vm.showDetailId) ? _c('div', {
    staticClass: "form-group clearFix"
  }, [_c('label', {
    staticClass: "option-alias"
  }, [_vm._v("链接到")]), _vm._v(" "), _c('Select', {
    staticClass: "option-control fl",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "disabled": _vm.detail_pages.length ? false : true,
      "placeholder": _vm.detail_pages.length ? '请选择' : ("请先创建「" + _vm.detailType + "」页"),
      "size": "large",
      "placement": _vm.pagePlacement
    },
    model: {
      value: (_vm.attrs.childprop.modclick.param.pagevalue),
      callback: function($$v) {
        _vm.$set(_vm.attrs.childprop.modclick.param, "pagevalue", $$v)
      },
      expression: "attrs.childprop.modclick.param.pagevalue"
    }
  }, _vm._l((_vm.detail_pages), function(page) {
    return _c('Option', {
      key: page.id,
      attrs: {
        "value": page.id
      }
    }, [_vm._v(_vm._s(page.name))])
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showDetailId && _vm.attrs.childprop.modclick.param.pagevalue) ? _c('div', {
    staticClass: "form-group clearFix"
  }, [_c('label', {
    staticClass: "option-alias"
  }, [_vm._v("数据源")]), _vm._v(" "), _c('Input', {
    staticClass: "option-control fl special",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "disabled": true,
      "value": _vm.dataSourceAlias,
      "size": "large"
    }
  }, [_c('span', {
    attrs: {
      "slot": "prepend"
    },
    slot: "prepend"
  }, [_vm._v("已选择")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "append"
    },
    on: {
      "click": function($event) {
        _vm.dialogShow = true
      }
    },
    slot: "append"
  }, [_vm._v("选择")])])], 1) : _vm._e(), _vm._v(" "), (_vm.isPageDirectShow) ? _c('div', {
    staticClass: "form-group clearFix"
  }, [_c('label', {
    staticClass: "option-alias"
  }, [_vm._v("跳转方式")]), _vm._v(" "), _c('RadioGroup', {
    staticStyle: {
      "line-height": "36px"
    },
    model: {
      value: (_vm.linkredirect),
      callback: function($$v) {
        _vm.linkredirect = $$v
      },
      expression: "linkredirect"
    }
  }, [_c('Poptip', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v("新页面")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('p', [_vm._v("保留当前页面且有返回键")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#f00"
    }
  }, [_vm._v("注：目前页面路径只能最多十层")])])], 1), _vm._v(" "), _c('Poptip', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("原页面")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('p', [_vm._v("关闭当前页面且无返回键")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff"
    }
  }, [_vm._v("注：页面路径无限制")])])], 1)], 1)], 1) : _vm._e()]) : _vm._e()], 1)])]), _vm._v(" "), _c('Tab-pane', {
    directives: [{
      name: "bar",
      rawName: "v-bar",
      value: ({
        preventParentScroll: true,
        scrollThrottle: 30
      }),
      expression: "{preventParentScroll: true,scrollThrottle: 30}"
    }],
    staticClass: "proptab",
    style: ({
      height: (_vm.height + "px")
    }),
    attrs: {
      "label": "样式设置"
    }
  }, [_c('div', [_c('div', {
    staticStyle: {
      "padding-bottom": "70px",
      "overflow": "hidden"
    }
  }, [(!_vm.nostyle) ? _c('Collapse', {
    staticClass: "set_box-container",
    staticStyle: {
      "width": "105% !important"
    },
    model: {
      value: (_vm.panelId),
      callback: function($$v) {
        _vm.panelId = $$v
      },
      expression: "panelId"
    }
  }, [_c('Panel', {
    staticClass: "set_box",
    attrs: {
      "name": "bg"
    }
  }, [_c('b', {
    staticClass: "mark_choose"
  }), _vm._v("背景设置\r\n\t\t\t\t\t"), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "form-group clearFix input-reset"
  }, [_c('label', {
    staticClass: "control-label tex-left tex-width fl"
  }, [_vm._v("背景图片：")]), _vm._v(" "), _c('div', {
    staticClass: "fl bg-container",
    style: ({
      'background-color': _vm.glbstyle['background-color'],
      'background-image': _vm.parseBgimg,
      'background-repeat': _vm.glbstyle['background-repeat'],
      'background-position': _vm.glbstyle['background-position']
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm bg-col-sm",
    staticStyle: {
      "margin-left": "8px",
      "width": "60px"
    }
  }, [_c('div', [_c('Button', {
    staticClass: "bg-col-sm-btn",
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.choosePic('bgimg')
      }
    }
  }, [_vm._v("上传")]), _vm._v(" "), _c('Button', {
    staticClass: "bg-col-sm-btn",
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.glbstyle['background-image'] = 'none'
      }
    }
  }, [_vm._v("移除")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group clearFix"
  }, [_c('label', {
    staticClass: "control-label tex-left tex-width fl"
  }, [_vm._v("背景颜色：")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm"
  }, [_c('ColorPicker2', {
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.glbstyle['background-color']),
      callback: function($$v) {
        _vm.$set(_vm.glbstyle, 'background-color', $$v)
      },
      expression: "glbstyle['background-color']"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group clearFix input-reset form-sort"
  }, [_c('label', {
    staticClass: "control-label tex-left tex-width fl"
  }, [_vm._v("背景重复：")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm propbgrepeat"
  }, [_c('RadioGroup', {
    attrs: {
      "type": "button"
    },
    model: {
      value: (_vm.glbstyle['background-repeat']),
      callback: function($$v) {
        _vm.$set(_vm.glbstyle, 'background-repeat', $$v)
      },
      expression: "glbstyle['background-repeat']"
    }
  }, [_c('Radio', {
    staticClass: "t1",
    attrs: {
      "label": "repeat"
    }
  }, [_vm._v("平铺")]), _vm._v(" "), _c('Radio', {
    staticClass: "t2",
    attrs: {
      "label": "repeat-x"
    }
  }, [_vm._v("横向平铺")]), _vm._v(" "), _c('Radio', {
    staticClass: "t3",
    attrs: {
      "label": "repeat-y"
    }
  }, [_vm._v("纵向平铺")]), _vm._v(" "), _c('Radio', {
    staticClass: "t4",
    attrs: {
      "label": "no-repeat"
    }
  }, [_vm._v("不平铺")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group clearFix"
  }, [_c('label', {
    staticClass: "control-label tex-left tex-width fl label-height"
  }, [_vm._v("对齐位置：")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm",
    staticStyle: {
      "width": "66px"
    }
  }, [_c('div', {
    staticClass: "position-set-block"
  }, _vm._l((_vm.bgpos), function(pos) {
    return _c('span', {
      class: {
        on: _vm.glbstyle['background-position'] == pos
      },
      on: {
        "click": function($event) {
          _vm.glbstyle['background-position'] = pos
        }
      }
    }, [_c('span', {
      staticClass: "mark"
    })])
  }), 0)])])])]), _vm._v(" "), (!_vm.ispage && !_vm.nostyle) ? _c('Panel', {
    staticClass: "set_box",
    attrs: {
      "name": "gborder"
    }
  }, [_c('b', {
    staticClass: "mark_choose"
  }), _vm._v("边框设置\r\n\t\t\t\t\t"), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "form-group clearFix"
  }, [_c('label', {
    staticClass: "control-label tex-left tex-width fl"
  }, [_vm._v("边框样式：")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm"
  }, [_c('Select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "size": "large",
      "transfer": true,
      "placement": "top"
    },
    model: {
      value: (_vm.glbstyle['border-style']),
      callback: function($$v) {
        _vm.$set(_vm.glbstyle, 'border-style', $$v)
      },
      expression: "glbstyle['border-style']"
    }
  }, _vm._l((_vm.borderstyle), function(item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group clearFix"
  }, [_c('label', {
    staticClass: "control-label tex-left tex-width fl"
  }, [_vm._v("边框粗细：")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm"
  }, [_c('InputNumber', {
    attrs: {
      "size": "large",
      "max": 10,
      "min": 0
    },
    model: {
      value: (_vm.glbstyle['border-width']),
      callback: function($$v) {
        _vm.$set(_vm.glbstyle, 'border-width', $$v)
      },
      expression: "glbstyle['border-width']"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group clearFix"
  }, [_c('label', {
    staticClass: "control-label tex-left tex-width fl"
  }, [_vm._v("边框颜色：")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm"
  }, [_c('ColorPicker2', {
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.glbstyle['border-color']),
      callback: function($$v) {
        _vm.$set(_vm.glbstyle, 'border-color', $$v)
      },
      expression: "glbstyle['border-color']"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group clearFix"
  }, [_c('label', {
    staticClass: "control-label tex-left tex-width fl"
  }, [_vm._v("边框圆角：")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm"
  }, [_c('InputNumber', {
    attrs: {
      "size": "large",
      "min": 0
    },
    model: {
      value: (_vm.glbstyle['border-radius']),
      callback: function($$v) {
        _vm.$set(_vm.glbstyle, 'border-radius', $$v)
      },
      expression: "glbstyle['border-radius']"
    }
  })], 1)])])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c(_vm.compStyle, {
    tag: "component",
    attrs: {
      "options": _vm.options,
      "attrs": _vm.attrs
    }
  })], 1)])])], 1), _vm._v(" "), (_vm.dialogShow) ? _c('product-selector', {
    attrs: {
      "isradio": _vm.isradio,
      "attrs": _vm.attrs
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 190 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-linker"
  }, [(!_vm.inner) ? _c('div', {
    staticClass: "mask"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'dig': !_vm.inner
    }
  }, [(!_vm.inner) ? _c('div', {
    staticClass: "dig_title clearFix"
  }, [_vm._m(0), _vm._v(" "), _c('i', {
    staticClass: "fr ivu-icon ivu-icon-close-round",
    nativeOn: {
      "click": function($event) {
        return _vm.popupClose($event)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-main",
    style: ({
      margin: _vm.inner ? '0' : '30px 0'
    })
  }, [_c('RadioGroup', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "size": "large"
    },
    on: {
      "on-change": _vm.etabSwitch
    },
    model: {
      value: (_vm.lnkobj.type),
      callback: function($$v) {
        _vm.$set(_vm.lnkobj, "type", $$v)
      },
      expression: "lnkobj.type"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "page"
    }
  }, [_vm._v("页面")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "func"
    }
  }, [_vm._v("功能")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "none"
    }
  }, [_vm._v("无")])], 1), _vm._v(" "), (_vm.lnkobj.type == 'page') ? _c('div', {
    staticClass: "box-form"
  }, [_c('inline-linker', {
    attrs: {
      "size": "large",
      "data": _vm.pages,
      "placement": _vm.placement,
      "placeholder": "连接至...",
      "filterable": ""
    },
    model: {
      value: (_vm.lnkobj.param.value),
      callback: function($$v) {
        _vm.$set(_vm.lnkobj.param, "value", $$v)
      },
      expression: "lnkobj.param.value"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.lnkobj.type == 'func') ? [_c('div', {
    staticClass: "box-form"
  }, [_c('Select', {
    attrs: {
      "size": "large",
      "placement": _vm.placement,
      "placeholder": "调用功能..."
    },
    model: {
      value: (_vm.lnkobj.param.type),
      callback: function($$v) {
        _vm.$set(_vm.lnkobj.param, "type", $$v)
      },
      expression: "lnkobj.param.type"
    }
  }, [_c('Option', {
    attrs: {
      "value": "callto"
    }
  }, [_vm._v("拨打电话")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "product_list"
    }
  }, [_vm._v("产品列表")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "product_detail"
    }
  }, [_vm._v("产品详情")])], 1)], 1), _vm._v(" "), (_vm.lnkobj.param.type == 'callto') ? _c('div', {
    staticClass: "box-form sub-box-form"
  }, [_c('Input', {
    attrs: {
      "size": "large",
      "placeholder": "请输入电话号码..."
    },
    model: {
      value: (_vm.lnkobj.param.value),
      callback: function($$v) {
        _vm.$set(_vm.lnkobj.param, "value", $$v)
      },
      expression: "lnkobj.param.value"
    }
  })], 1) : _vm._e()] : _vm._e()], 2), _vm._v(" "), (!_vm.inner) ? _c('div', {
    staticClass: "dig-footer clearfix"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.popupClose($event)
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.linkerSet($event)
      }
    }
  }, [_vm._v("确 定")])], 1) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fl"
  }, [_c('b', {
    staticClass: "mark_choose"
  }), _vm._v("设置链接")])
}]}

/***/ }),
/* 191 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loginer"
  }, [_c('div', {
    staticClass: "bgheadeimg"
  }, [_c('img', {
    attrs: {
      "src": _vm.bgimg
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "newclasswindow shadow"
  }, [_c('div', {
    staticClass: "title",
    staticStyle: {
      "margin-top": "20px",
      "text-align": "center"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-size": "30px",
      "color": "#ff9900"
    }
  }, [_vm._v(_vm._s(_vm.page_title))]), _vm._v(" "), _c('div', {
    staticClass: "subtitle",
    staticStyle: {
      "font-size": "20px",
      "color": "#333"
    }
  }, [_vm._v(_vm._s(_vm.page_subtitle))])]), _vm._v(" "), _c('Form', {
    ref: "frmdata",
    staticClass: "logform",
    attrs: {
      "model": _vm.frmdata,
      "rules": _vm.rulers
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "account"
    }
  }, [_c('Input', {
    attrs: {
      "size": "large",
      "type": "text",
      "placeholder": "管理账号",
      "autofocus": ""
    },
    on: {
      "on-enter": function($event) {
        _vm.onSubmit('frmdata')
      }
    },
    model: {
      value: (_vm.frmdata.account),
      callback: function($$v) {
        _vm.$set(_vm.frmdata, "account", $$v)
      },
      expression: "frmdata.account"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-user",
    attrs: {
      "slot": "prepend"
    },
    slot: "prepend"
  })])], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "password"
    }
  }, [_c('Input', {
    attrs: {
      "size": "large",
      "type": "password",
      "placeholder": "输入密码"
    },
    on: {
      "on-enter": function($event) {
        _vm.onSubmit('frmdata')
      }
    },
    model: {
      value: (_vm.frmdata.password),
      callback: function($$v) {
        _vm.$set(_vm.frmdata, "password", $$v)
      },
      expression: "frmdata.password"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-3701mima",
    attrs: {
      "slot": "prepend"
    },
    slot: "prepend"
  })])], 1), _vm._v(" "), _c('FormItem', {
    staticStyle: {
      "margin": "0"
    }
  }, [_c('Button', {
    attrs: {
      "size": "large",
      "long": "",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.onSubmit('frmdata')
      }
    }
  }, [_vm._v("登 录")])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 192 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input')
},staticRenderFns: []}

/***/ }),
/* 193 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "mask"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "dlgdrag",
      rawName: "v-dlgdrag"
    }],
    staticClass: "dig setting-dig",
    staticStyle: {
      "height": "300px"
    }
  }, [_c('div', {
    staticClass: "dig_title clearFix"
  }, [_vm._m(0), _vm._v(" "), _c('Icon', {
    staticClass: "fr",
    attrs: {
      "type": "close-round"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.dialogClose($event)
      }
    }
  })], 1), _vm._v(" "), (_vm.errmsg) ? _c('div', {
    staticClass: "dig-main clearFix",
    staticStyle: {
      "color": "#f00",
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(_vm.errmsg))]) : _c('div', {
    staticClass: "dig-main clearFix",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "form-grounp clearFix"
  }, [_c('label', {
    staticClass: "fl control-label"
  }, [_vm._v("页面标题")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm fl"
  }, [_c('Input', {
    staticStyle: {
      "width": "235px"
    },
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.settings.navigationBarTitleText),
      callback: function($$v) {
        _vm.$set(_vm.settings, "navigationBarTitleText", $$v)
      },
      expression: "settings.navigationBarTitleText"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-grounp clearFix"
  }, [_c('label', {
    staticClass: "fl control-label"
  }, [_vm._v("标题栏颜色")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm fl"
  }, [_c('Input', {
    staticStyle: {
      "width": "235px"
    },
    attrs: {
      "value": _vm.settings.navigationBarBackgroundColor,
      "disabled": true,
      "size": "large"
    }
  }), _vm._v(" "), _c('ColorPicker2', {
    attrs: {
      "format": "single",
      "size": "large"
    },
    model: {
      value: (_vm.settings.navigationBarBackgroundColor),
      callback: function($$v) {
        _vm.$set(_vm.settings, "navigationBarBackgroundColor", $$v)
      },
      expression: "settings.navigationBarBackgroundColor"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-grounp clearFix"
  }, [_c('label', {
    staticClass: "fl control-label"
  }, [_vm._v("文字颜色")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm fl"
  }, [_c('RadioGroup', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "size": "large",
      "type": "button"
    },
    model: {
      value: (_vm.settings.navigationBarTextStyle),
      callback: function($$v) {
        _vm.$set(_vm.settings, "navigationBarTextStyle", $$v)
      },
      expression: "settings.navigationBarTextStyle"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "white"
    }
  }, [_vm._v("白色")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "black"
    }
  }, [_vm._v("黑色")])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "dig-footer clearfix",
    staticStyle: {
      "position": "absolute",
      "left": "0",
      "right": "0px",
      "bottom": "0",
      "padding": "5px 40px 20px 40px"
    }
  }, [_c('div', {
    staticClass: "setting-btn"
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.settingsSave($event)
      }
    }
  }, [_vm._v("保存")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fl"
  }, [_c('b', {
    staticClass: "mark_choose"
  }), _vm._v("设置")])
}]}

/***/ }),
/* 194 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.iseditor) ? _c('div', {
    staticClass: "baseplugin",
    staticStyle: {
      "width": "calc(100% + 10px)"
    }
  }, [_c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar",
      value: ({
        preventParentScroll: true
      }),
      expression: "{preventParentScroll: true}"
    }],
    style: ({
      height: (_vm.height + "px")
    })
  }, [_c('div', [_c('draggable', {
    staticClass: "baseplugin-ul",
    attrs: {
      "options": {
        group: {
          name: 'sort1',
          pull: 'clone',
          put: false
        },
        draggable: '.plugin-li',
        sort: false,
        ghostClass: 'sortghost'
      }
    },
    on: {
      "start": _vm.onStart,
      "end": _vm.onEnd
    }
  }, [_c('div', {
    staticClass: "plugin-li",
    staticStyle: {
      "border": "0",
      "width": "0"
    }
  }), _vm._v(" "), _vm._l((_vm.plugins), function(plugin, idx) {
    return _c('div', {
      key: idx,
      staticClass: "plugin-li",
      attrs: {
        "data-role": plugin.name
      }
    }, [_c('i', {
      class: plugin.icon
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(plugin.alias))])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both",
      "height": "0",
      "overflow": "hidden"
    }
  })], 2)], 1)]), _vm._v(" "), (_vm.pluginTipsShow) ? _c('div', {
    staticClass: "tip-left"
  }, [_vm._v("\n\t\t按住鼠标左键拖动插件到页面\n\t\t"), _c('span', {
    staticClass: "tip-close",
    on: {
      "click": _vm.hidePlugintips
    }
  }, [_vm._v("x")])]) : _vm._e()]) : _c('div', [_c('Menu', {
    staticStyle: {
      "background": "transparent"
    },
    attrs: {
      "active-name": _vm.mactived,
      "theme": "light",
      "open-names": _vm.activedMenu,
      "accordion": true
    },
    on: {
      "on-select": _vm.fnSwitch,
      "on-open-change": _vm.openChange
    }
  }, [_vm._l((_vm.menus), function(menu, idx) {
    return [(menu.children.length) ? _c('Submenu', {
      attrs: {
        "name": ("super-m" + idx)
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: menu.icon
    }), _vm._v(_vm._s(menu.title) + "\n\t\t\t    ")]), _vm._v(" "), _vm._l((menu.children), function(submenu, subidx) {
      return _c('MenuItem', {
        key: subidx,
        attrs: {
          "name": submenu._src
        }
      }, [_vm._v("\n\t\t\t    \t" + _vm._s(submenu.title) + "\n\t\t\t\t")])
    })], 2) : _c('MenuItem', {
      attrs: {
        "name": menu._src
      }
    }, [_c('i', {
      class: menu.icon
    }), _vm._v(_vm._s(menu.title) + "\n\t        ")])]
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 195 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-group clearFix"
  }, [_c('label', {
    staticClass: "control-label tex-left tex-width fl"
  }, [_vm._v("页面名称：")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm"
  }, [_c('Input', {
    staticClass: "con-width",
    attrs: {
      "size": "large",
      "placeholder": "请输入..."
    },
    model: {
      value: (_vm.frmdata.name),
      callback: function($$v) {
        _vm.$set(_vm.frmdata, "name", $$v)
      },
      expression: "frmdata.name"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group clearFix"
  }, [_c('label', {
    staticClass: "control-label tex-left tex-width fl"
  }, [_vm._v("导航显示：")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm"
  }, [_c('i-switch', {
    model: {
      value: (_vm.frmdata.display),
      callback: function($$v) {
        _vm.$set(_vm.frmdata, "display", $$v)
      },
      expression: "frmdata.display"
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("是")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("否")])])], 1), _vm._v(" "), _c('span', {
    staticClass: "check-tip"
  }, [_vm._v("页面名称将出现在导航中")])])])
},staticRenderFns: []}

/***/ }),
/* 196 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "file-manager"
  }, [_c('div', {
    staticClass: "mask"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "dlgdrag",
      rawName: "v-dlgdrag"
    }],
    staticClass: "dig"
  }, [_c('div', {
    staticClass: "dig_title clearFix"
  }, [_vm._m(0), _vm._v(" "), _c('Icon', {
    staticClass: "fr",
    attrs: {
      "type": "close-round"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.dialogClose($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dig-main clearFix artical-file-dig-main"
  }, [_c('div', {
    staticClass: "main-left main-left-table",
    staticStyle: {
      "right": "0px",
      "padding-right": "20px"
    }
  }, [_c('div', {
    staticClass: "tab_content",
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar",
      value: ({
        preventParentScroll: true,
        scrollThrottle: 30
      }),
      expression: "{preventParentScroll: true,scrollThrottle: 30}"
    }],
    ref: "tabul",
    staticClass: "artical_tab_ul"
  }, [_c('div', {
    staticClass: "artical_tab_li",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('ul', {
    staticClass: "main-left-list clearFix"
  }, [_vm._l((_vm.products), function(product) {
    return _c('li', {
      key: product.id,
      staticClass: "list-li fl",
      on: {
        "click": function($event) {
          _vm.selectedPrdById(product.id)
        }
      }
    }, [_c('div', {
      staticClass: "list-li-top",
      class: {
        selected: _vm.selectedArr.findIndex(function (v) { return v == product.id; }) > -1
      },
      staticStyle: {
        "height": "60px",
        "position": "relative"
      }
    }, [_c('img', {
      attrs: {
        "src": product.thumb
      }
    }), _vm._v(" "), _vm._m(1, true)]), _vm._v(" "), _c('div', {
      staticClass: "list-li-bottom"
    }, [
      [_vm._v(_vm._s(product.name))]
    ], 2)])
  }), _vm._v(" "), (!_vm.products.length) ? _c('li', {
    staticClass: "list-li fl",
    staticStyle: {
      "color": "#f00",
      "width": "150px"
    }
  }, [_vm._v("未找到匹配的产品")]) : _vm._e()], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "confirm_btn",
    staticStyle: {
      "bottom": "25px"
    },
    on: {
      "click": _vm.selectedProduct
    }
  }, [_vm._v("确定(" + _vm._s(_vm.selectedArr.length) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "file_category_box"
  }, [_c('div', {
    staticClass: "fr"
  }, [_c('Input', {
    attrs: {
      "placeholder": "按产品名称查找"
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  }, [_c('Button', {
    attrs: {
      "slot": "append",
      "icon": "ios-search"
    },
    on: {
      "click": _vm.searchProduct
    },
    slot: "append"
  })], 1)], 1)])])]), _vm._v(" "), _c('Page', {
    staticClass: "pager",
    attrs: {
      "total": _vm.total,
      "page-size": _vm.pagesize,
      "size": "small"
    },
    on: {
      "on-change": _vm.onPager
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fl"
  }, [_c('b', {
    staticClass: "mark_choose"
  }), _vm._v("选择产品")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selectState"
  }, [_c('span', {
    staticClass: "iconfont icon-dui",
    staticStyle: {
      "font-size": "32px"
    }
  })])
}]}

/***/ })
],[104]);


// WEBPACK FOOTER //
// static/js/app.js